require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./functions/1b07f526ab2675c1f595f218cd9d6b6f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1b07f526ab2675c1f595f218cd9d6b6f'] = async function fn_1b07f526ab2675c1f595f218cd9d6b6f(modifiedData, WebpageDataRoot, PocketBaseID, _webpageSections) {
var PatchResults, modifiedListToSave, results, error, filterItem, _changesInnerHTML, _changesID, processing, trimmedList, i;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function CodeWorkingNow() {
  var i_inc2 = 1;
  if (1 > _webpageSections) {
    i_inc2 = -i_inc2;
  }
  for (i = 1; i_inc2 >= 0 ? i <= _webpageSections : i >= _webpageSections; i += i_inc2) {
    processing = modifiedData[(i - 1)];
    console.log('Processing: ');
    console.log(processing);
    try {
      _changesID = subsequenceFromStartLast((getObjectProperty(processing, 'className')).split(' ')[0], 5);
      console.log(_changesID);
      _changesInnerHTML = (getObjectProperty(processing, 'innerHTML'));
      results = (await asyncListFilter((getObjectProperty(WebpageDataRoot, 'PageContent.WebpageSections')), async (filterItem) => {
         if ((getObjectProperty(filterItem, 'id')) == _changesID) {
          filterItem['HTMLContent'] = (encodeURIComponent(_changesInnerHTML));
          console.log(_changesInnerHTML);
          return true;
        } else {
          return false;
        }


       return filterItem;
      }));

    } catch (error) {
      console.log(error);

    }
  }
  console.log(results);
  PatchResults = (await Backendless.Request['patch']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://accoweb.pockethost.io/api/collections/webpages/records/') + String(PocketBaseID)))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken')) })).setEncoding('utf8').send(({ [`PageContent`]: ({ [`WebpageSections`]: results }) })));
  console.log(PatchResults);
}


  modifiedListToSave = [];
  var i_inc = 1;
  if (1 > _webpageSections) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= _webpageSections : i >= _webpageSections; i += i_inc) {
    processing = modifiedData[(i - 1)];
    console.log('Processing: ');
    console.log(processing);
    try {
      _changesID = subsequenceFromStartLast((getObjectProperty(processing, 'className')).split(' ')[0], 5);
      console.log(_changesID);
      _changesInnerHTML = (getObjectProperty(processing, 'innerHTML'));
      results = (await asyncListFilter((getObjectProperty(WebpageDataRoot, 'PageContent.WebpageSections')), async (filterItem) => {
         if ((getObjectProperty(filterItem, 'id')) == _changesID) {
          filterItem['HTMLContent'] = (encodeURIComponent(_changesInnerHTML));
          console.log(_changesInnerHTML);
          return true;
        } else {
          return false;
        }


       return filterItem;
      }));

    } catch (error) {
      console.log(error);

    } finally {
      addItemToList(modifiedListToSave, results);

    }
  }
  console.log(results);
  PatchResults = (await Backendless.Request['patch']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://accoweb.pockethost.io/api/collections/webpages/records/') + String(PocketBaseID)))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken')) })).setEncoding('utf8').send(({ [`PageContent`]: ({ [`WebpageSections`]: modifiedListToSave }) })));
  console.log(PatchResults);

return PatchResults
}

})
define('./functions/1daef9594124e1d1dda1414d88be10bd/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'] = async function fn_1daef9594124e1d1dda1414d88be10bd(token) {
var currentUser;


  console.log('### FUNCTION: PB_ValidateUser ###');
  if (token != null) {
    currentUser = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://accoweb.pockethost.io/api/collections/users/auth-refresh')).set(({ [`Authorization`]: token })).setEncoding('utf8').send());
  } else {
    return false;
  }

return currentUser
}

})
define('./functions/2a484e2882037fcf0007ebb10bfcbf2c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2a484e2882037fcf0007ebb10bfcbf2c'] = async function fn_2a484e2882037fcf0007ebb10bfcbf2c(pageData, sectionName) {
var decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



return (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty(pageData, 'webpageCache')), 'webpagesections')), async (item) => {
   if ((getObjectProperty(item, 'sectionname')) == sectionName) {
    decision = true;
  } else {
    decision = false;
  }


 return decision;
}))[0]), 'HTMLContent'))
}

})
define('./functions/3c63a6490c9c483f2ce74cbe8fb69592/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3c63a6490c9c483f2ce74cbe8fb69592'] = async function fn_3c63a6490c9c483f2ce74cbe8fb69592(HTMLContent) {
var decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ((await asyncListFilter((getObjectProperty((getObjectProperty(HTMLContent, 'webpageData')), 'webpagesections')), async (item) => {
     if ((getObjectProperty(item, 'sectionname')) == sectionName) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }))[0])['HTMLContent'] = HTMLContent;

return 
}

})
define('./functions/476e0b7c9ee7ae9ea5da774edbe841c1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1'] = function fn_476e0b7c9ee7ae9ea5da774edbe841c1(CurrentUser) {
function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('####### FUNCTION: isWebsiteEditor #######');
  console.log(CurrentUser);
  if ((getObjectProperty((getObjectProperty(CurrentUser, 'record')), 'UserRoles')).indexOf('WebsiteEditor') + 1 > 0) {
    return true;
  } else {
    return false;
  }

return 
}

})
define('./functions/655372cecddc8dea5b58db2e2917220f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_655372cecddc8dea5b58db2e2917220f'] = async function fn_655372cecddc8dea5b58db2e2917220f(token) {
var NewToken, currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (token != null) {
    NewToken = (getObjectProperty((await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://accoweb.pockethost.io/api/collections/users/auth-refresh')).set(({ [`Authorization`]: token })).setEncoding('utf8').send()), 'record'));
    NewToken = (getObjectProperty(currentUser, 'token'));
  } else {
    return false;
  }

return NewToken
}

})
define('./functions/7c99d93c763398d595b7ff4a51c14f57/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7c99d93c763398d595b7ff4a51c14f57'] = async function fn_7c99d93c763398d595b7ff4a51c14f57() {
var return2;


  return2 = (await (async function() {
  	return window.location.href
  })());

return return2
}

})
define('./functions/8ad53e4e1c97580bf801a3793885f106/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8ad53e4e1c97580bf801a3793885f106'] = async function fn_8ad53e4e1c97580bf801a3793885f106(pageData, webpageObjectID, webpageSections) {
var AppBaseURL, AppURL, _localWebPageDataRoot, _webpageObjectID, _webpageSections;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  pageData['isPageReady'] = false;
  _webpageObjectID = webpageObjectID;
  pageData['WebpageObjectID'] = _webpageObjectID;
  _webpageSections = webpageSections;
  pageData['_webpageSections'] = (_webpageSections.length);
  _localWebPageDataRoot = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accoweb.pockethost.io/api/collections/webpages/records?filter=(objectId=\'',_webpageObjectID,'\')'].join('')))).setEncoding('utf8').send()), 'items'))[0];
  pageData['WebpageDataRoot'] = _localWebPageDataRoot;
  pageData['WebpageData'] = (getObjectProperty(_localWebPageDataRoot, 'PageContent'));
  pageData['isPageReady'] = true;
  pageData['BETAItemsVisible'] = false;
  AppURL = (await BackendlessUI.Functions.Custom['fn_7c99d93c763398d595b7ff4a51c14f57']());
  console.log(String('AppBaseURL = ') + String(AppBaseURL));

return pageData
}

})
define('./functions/8dc91128a0037b9d1967b6ecd646bbb8/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8dc91128a0037b9d1967b6ecd646bbb8'] = async function fn_8dc91128a0037b9d1967b6ecd646bbb8(pageData, sectionName) {
var decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



return (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty(pageData, 'webpageData')), 'webpagesections')), async (item) => {
   if ((getObjectProperty(item, 'sectionname')) == sectionName) {
    decision = true;
  } else {
    decision = false;
  }


 return decision;
}))[0]), 'HTMLContent'))
}

})
define('./functions/90ffad4968bc0d1df319c785e7316443/code.js', () => { 

BackendlessUI.Functions.Custom['fn_90ffad4968bc0d1df319c785e7316443'] = function fn_90ffad4968bc0d1df319c785e7316443(ID) {
  console.log(String('For Popup: ') + String(ID));

return ID
}

})
define('./functions/d58e64163f69377f57fedfdaa18831c1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d58e64163f69377f57fedfdaa18831c1'] = async function fn_d58e64163f69377f57fedfdaa18831c1(pageData, sectionName) {
var decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



return (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty(pageData, 'webpageData')), 'webpagesections')), async (item) => {
   if ((getObjectProperty(item, 'id')) == sectionName) {
    decision = true;
  } else {
    decision = false;
  }


 return decision;
}))[0]), 'HTMLContent'))
}

})
define('./pages/404/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('', null);

  },  
/* handler:onClick *//* content */
}));

define('./pages/NOT_AUTHORIZED/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('mailto:mike@hyperpixels.net', true, undefined);

  },
  /* handler:onClick *//* content */
}));

define('./pages/NOT_AUTHORIZED/components/e56c223c2ff4cb9b65c9147101973505/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Quote7-30-25/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
    
  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/about/components/55343ac7f355e5866b258f56b9374e51/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projects-and-services', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/about/components/e3dbcfc8260ddb18fbfa650584ebcb7b/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    
  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('about', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) == 'about') {
    if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
      return ['easeInAndOut', 'underline'];
    } else {
      return ['hide-beta', 'easeInAndOut', 'underline'];
    }
  } else {
    if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
      return ['easeInAndOut'];
    } else {
      return ['hide-beta', 'easeInAndOut'];
    }
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/about/components/9274dbcfe0ee894416a264e55332b426/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('subcontractors', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/about/components/c7db3fda439eae33a98479749c1f6cdc/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('employees', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/about/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var WebsiteMode, AppBaseURL, AppURL, _localWebPageDataRoot, _webpageObjectID, _webpageSections;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ AN - ON BEFORE PAGE ENTER - EVENT JUST HAPPENED!!! ############################');
  ___arguments.context.pageData['isPageReady'] = false;
  _webpageObjectID = '4abc8008-3922-cc0d-9efb-ee21b558e728';
  ___arguments.context.pageData['WebpageObjectID'] = _webpageObjectID;
  _webpageSections = ['headerBlock1', 'headerBlock2', 'heroBlock1', 'heroBlock2', 'landingBlock1', 'landingBlock2', 'landingBlock3', 'landingBlock4', 'footerBlock1', 'footerBlock2'];
  ___arguments.context.pageData['_webpageSections'] = (_webpageSections.length);
  ___arguments.context.pageData['WebpageSections'] = _webpageSections;
  _localWebPageDataRoot = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accoweb.pockethost.io/api/collections/webpages/records?filter=(objectId=\'',_webpageObjectID,'\')'].join('')))).setEncoding('utf8').send()), 'items'))[0];
  ___arguments.context.pageData['WebpageDataRoot'] = _localWebPageDataRoot;
  ___arguments.context.pageData['WebpageData'] = (getObjectProperty(_localWebPageDataRoot, 'PageContent'));
  ___arguments.context.pageData['isPageReady'] = true;
  ___arguments.context.pageData['BETAItemsVisible'] = false;
  AppURL = (await BackendlessUI.Functions.Custom['fn_7c99d93c763398d595b7ff4a51c14f57']());
  AppBaseURL = AppURL.slice(0, 23);
  console.log(String('AppBaseURL = ') + String(AppBaseURL));

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var result2, result, currentDataSource, _currentUser, _storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ A PAGE ENTER JUST HAPPENED!!! ############################');
  _storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
  if (_storedTokenFromCookie != null || _storedTokenFromCookie != 'undefined') {
    _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](_storedTokenFromCookie));
    console.log('### CURRENT USER ###');
    console.log(_currentUser);
    if (_currentUser != false) {
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
      if ((getObjectProperty(___arguments.context.appData, 'currentUser.record.BETAModeEnabled')) == true) {
        ___arguments.context.appData['isBETAEnabled'] = true;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = true;
      } else {
        ___arguments.context.appData['isBETAEnabled'] = false;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = false;
      }
    } else {
      ___arguments.context.appData['CurrentUser'] = null;
    }
  }
  ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['taskBarTop'] = true;
  ___arguments.context.pageData['taskBarBottom'] = false;
  ___arguments.context.pageData['hideButtonsMode'] = true;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onEnter */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onResize */
  /* handler:onPageQuery */
  async ['onPageQuery'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.pageQuery, 'debugMode')) == true && (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'currentUser'))))) {
    ___arguments.context.appData['debugMode'] = true;
  } else {
    ___arguments.context.appData['debugMode'] = false;
  }

  },
  /* handler:onPageQuery */
  /* content */
}))

define('./pages/about/components/f6c3d992d48fe05b791cfba8a2c9ea19/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 1;
  	video.playbackRate = 1;
  	video.play();
  })();

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 0;
  	video.playbackRate = 1;
  	video.pause();
  })();

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/about/components/27b9fd37c4233d555444978939bfe4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/about/components/4a16f104bfbce399523c5d8152efe8af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/about/components/e49eae259f43d5e4ed34fbed4c1690f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '8D6FAC01-F4F5-466C-8D61-4C6395519121';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/about/components/d6338723fe754ea845c18574e1db8e3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'B103EFB3-F65C-4F60-A3A7-0CBBB9F80C08';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/about/components/fa5129e49d61d9c6b57287189523e39e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '428FA853-8475-41D5-BEAE-0A758818D0BC';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/about/components/26ebd15ce2f2c1d6f9813d1a00a26054/bundle.js', [], () => ({
  /* content */
  /* handler:onAction */
  async ['onAction'](___arguments) {
      await (async function() {
  	window.location.reload()
  })();

  },
  /* handler:onAction */
  /* content */
}))

define('./pages/about/components/54dcab8d080f34d8921bdbb632146cd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();//pageData.currentDataContent;
  	ownerBlock[0].innerHTML = `${sourceContent}`;
  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/about/components/c19816bbc89f510c6b0f61af2ce6e8cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/about/components/868de2a35dc382de3c1cd8fbad23a403/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  blockObjectID = '4645C476-DE2B-4007-9A54-03BBC0D8B746';
  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
       if ((getObjectProperty(item, 'id')) == blockObjectID) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/about/components/4ab52bf14234a3b76ef19002bc343042/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '4087A0EA-27D1-45A5-97A2-9E787C8323E6';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/about/components/f84a59cfd95b86ecac0818e2f8369ed1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '5155423A-F695-4B2F-AADB-4D18281D0F89';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/about/components/7b1cb0a9932c78bfd8d5b79381e54204/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'A512CA81-3F67-48FE-9F52-1773D57EEC5B';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/about/components/8b7ea841affa30d6d4891c06e62e2d89/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogo-mini', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var _currentUser, result2, result, storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.event, 'ctrlKey')) == true && (getObjectProperty(___arguments.event, 'altKey')) == true) {
    ___arguments.context.pageData['hideButtonsMode'] = false;
    storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
    if (storedTokenFromCookie != null || storedTokenFromCookie != '') {
      _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](storedTokenFromCookie));
      if (_currentUser != false) {
        if ((getObjectProperty(_currentUser, 'token')) != '') {
          localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
        }
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
      }
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      ___arguments.context.appData['inAdminMode'] = true;
      ___arguments.context.appData['isLoggedIn'] = true;
      ___arguments.context.pageData['showAdminBar'] = true;
    } else {
      console.log('####### THE COOKIE IS NOT NULL!!! #######');
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
    }
    console.log(___arguments.event);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('####### appData.CurrentUser #######');
  console.log(getObjectProperty(___arguments.context.appData, 'CurrentUser'));
  console.log('####### ISLOGGEDIN: #######');
  console.log(getObjectProperty(___arguments.context.appData, 'isLoggedIn'));
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
    if ((getObjectProperty(___arguments.context.appData, 'CurrentUser')) != false) {
      console.log('####### CHECKING IF USER isWebsiteEditor #######');
      result = (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'CurrentUser'))));
      if (result == true) {
        console.log('####### RETURN FROM isWebsiteEditor FUNCTION #######');
        console.log('isWebsiteEditor = ');
        console.log(result);
        console.log('####### HIDE BUTTONS MODE #######');
        console.log(getObjectProperty(___arguments.context.pageData, 'hideButtonsMode'));
        if ((getObjectProperty(___arguments.context.pageData, 'hideButtonsMode')) == true) {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', true);
        } else {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);
        }
      }
    }
  }

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/about/components/e18a76e42143485dabe50caddb6fdd6f/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogoCell-right', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/about/components/3ea61bdd3ad1e562a5185b8204761226/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();
  	pageData.currentDataContent = sourceContent; // added decodeURIComponent for troubleshooting

  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('admin_Webpages').save( ({ 'objectId': (getObjectProperty(___arguments.context.pageData, 'currentDataSource')),'BlockContent': (encodeURIComponent((getObjectProperty(___arguments.context.pageData, 'currentDataContent')))) }) );

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/about/components/19f2f0dacd13571dc9b931385a463b62/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/about/components/cc3a9886128a333e4fb5d24ca934c255/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  return (['You are logged on as: ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'CurrentUser')), 'record')), 'name')),' | CTRL + ALT Click on your logo to turn edit mode back on again.'].join(''));

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/about/components/0b76d57506286594c0a8661497f83bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'C1F6E9F5-7F62-4DEC-87C0-70A43E04649C';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/about/components/226882c510580398880a31741218b794/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('careers', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/about/components/ac5384a89159966cc8681bfea27aa946/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('industries', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/about/components/f96298252c8b58c3630720c3f3968e33/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var result2, result;

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  result = (await (async function(pageData, HTMLSource, tinydrive_dropbox_app_key, created_jwt_token) {
  	/*
  	
  	// Plugins that we probably will need: mediaembed, export linkchecker?, powerpaste, advtable, editimage, autocorrect, typography, checklist
  	Existing plugins backup: 'tinydrive code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
  	Removed from below: 
  	toolbar_sticky: true,
  	toolbar_mode: 'floating', // Modes: floating, sliding, scrolling, wrap
  	
  	*/
  	
  	const editor = await BackendlessUI.requireModule('https://cdn.tiny.cloud/1/dwt7je7v9gjog7a8oc867xici2xmy80whuw0asnvstr20590/tinymce/8/tinymce.min.js')
  	tinymce.init({ selector: '.TinyMCETextEditor',
  	plugins: 'tinydrive code anchor link charmap codesample emoticons image lists media searchreplace table visualblocks wordcount',
  	toolbar: 'undo redo | blocks fontfamily fontsize | fontsizeselect | forecolor backcolor | bold italic underline strikethrough blockquote | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat | code',
  	font_family_formats: 'Andale Mono="Andale Mono"; Arial=arial; Arial Black="arial black"; Book Antiqua = "book antiqua"; Comic Sans MS="Comic Sans MS"; Courier New=courier new,courier,monospace; Georgia=georgia; Helvetica=helvetica; Impact=impact; Tahoma=tahoma; Terminal=terminal; Times New Roman="times new roman"; Trebuchet MS = "trebuchet ms"; Sans Serif="sans serif"; Segoe UI=segoe ui; Verdana=verdana; Webdings=webdings; Wingdings=wingdings',
  	font_size_formats: "8px 10px 12px 14px 16px 18px 20px 24px 30px 36px 48px 60px 72px 96px",
  	relative_urls : true,
  	remove_script_host : false,
  	document_base_url : 'https://www.accofg.com/',
  	tinydrive_dropbox_app_key: tinydrive_dropbox_app_key,
  	tinydrive_token_provider: (success, failure) => {
  	        success({ token:  created_jwt_token });
  	  },
  	setup: function (editor) {
  	      editor.on('init', function (e) {
  	        editor.setContent(HTMLSource);
  	      });
  	  }
  	
  	}) //#${id}`}) `this was inside a template string`
  	
  	// document.getElementById('btnUpdateContent').addEventListener("click", saveContent)
  	
  	function saveContent() {
  	const myContent = tinymce.activeEditor.getContent()
  	pageData.myContent = myContent
  	}

  })(___arguments.context.pageData, (getObjectProperty(___arguments.context.pageData, 'currentDataContent')), '7svncuz1u3xumyc', (getObjectProperty(((function () { return BackendlessUI.getCustomSettings() })()), 'created_jwt_token'))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/about/components/859df6fc47f553256c989f7c2b88adcc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isOpenModal'))

  },
  /* handler:onDisplayAssignment */
  /* handler:modalVisibilityLogic */
  ['modalVisibilityLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isOpenModal'))

  },
  /* handler:modalVisibilityLogic */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;

  },
  /* handler:onClose */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    var result;


  console.log('Modal: (OnVisibilityChange) Modal Visible | Content Pushed to TinyMCE in the modal__card.OnVisible Event');

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/about/components/71dd7f53b1157583c11cd04885411f04/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var result;


  result = (await (async function(pageData) {
  	// Create an array by ClassName 'content_editable' and invoke the function (editable) and create an event listener for each index in the array
  	// const runner = { currentDataSource: ""};
  	
  	var loadFromBlock, HTMLSource;
  	loadFromBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource);
  	console.log ('modal__card: OnMounted: The data source has been set to: ' + pageData.currentDataSource);
  	HTMLSource = loadFromBlock[0].innerHTML;
  	// loadFromBlock.currentTarget.getAttribute('data-source')
  	tinymce.activeEditor.setContent(HTMLSource);
  	pageData.currentDataContent = HTMLSource
  })(___arguments.context.pageData));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/admin/components/85dae34486144e2efa2d934bfdddb172/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var user, error, password, username, stayLoggedIn, logging, buttonLogin;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function login() {
  try {
    user = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://accoweb.pockethost.io/api/collections/users/auth-with-password')).setEncoding('utf8').send(({ [`identity`]: username,[`password`]: password })));

  } catch (error) {
    await setError(error);

  }
}

/**
 * Describe this function...
 */
async function updateButtonLogin(logging) {
  buttonLogin = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('db5546014b7940ad8771a98d85f83036'));
  buttonLogin['label'] = (logging ? 'Please wait...' : 'Login');
  buttonLogin['disabled'] = logging;
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = error;
}


  user = ({  });
  await setError(null);
  username = (getObjectProperty(___arguments.context.dataModel, 'username'));
  password = (getObjectProperty(___arguments.context.dataModel, 'password'));
  stayLoggedIn = (getObjectProperty(___arguments.context.dataModel, 'stayLoggedIn'));
  if (username && password) {
    await updateButtonLogin(true);
    try {
      await login();

    } catch (error) {
      if ((getObjectProperty(error, 'code')) == 3033) {
        await login();
      } else {
        await setError(error);
      }

    } finally {
      await updateButtonLogin(false);

    }
  } else {
    await setError((new Error('Username and Password must be filled')));
  }
  console.log(user);
  if (user) {
    if ((getObjectProperty((getObjectProperty(user, 'record')), 'UserRoles')).indexOf('WebsiteEditor') + 1 > 0 || (getObjectProperty((getObjectProperty(user, 'record')), 'UserRoles')).indexOf('GlobalAdmin') + 1 > 0) {
      ___arguments.context.appData['CurrentUser'] = user;
      ___arguments.context.appData['isLoggedIn'] = true;
      ___arguments.context.appData['inAdminMode'] = true;
      localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(user, 'token'))));
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('NOT_AUTHORIZED', undefined);
    }
  }

  },
  /* handler:onSubmit *//* content */
}));

define('./pages/careers/components/55343ac7f355e5866b258f56b9374e51/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projects-and-services', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/careers/components/e3dbcfc8260ddb18fbfa650584ebcb7b/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('about', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/careers/components/9274dbcfe0ee894416a264e55332b426/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('subcontractors', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/careers/components/c7db3fda439eae33a98479749c1f6cdc/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('employees', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/careers/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var WebsiteMode, AppBaseURL, AppURL, _localWebPageDataRoot, _webpageObjectID, _webpageSections;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ AN - ON BEFORE PAGE ENTER - EVENT JUST HAPPENED!!! ############################');
  ___arguments.context.pageData['isPageReady'] = false;
  _webpageObjectID = '51d2bf82-8646-7978-f453-16b8c5b863e8';
  ___arguments.context.pageData['WebpageObjectID'] = _webpageObjectID;
  _webpageSections = ['headerBlock1', 'headerBlock2', 'heroBlock1', 'heroBlock2', 'landingBlock1', 'landingBlock2', 'landingBlock3', 'landingBlock4', 'footerBlock1', 'footerBlock2'];
  ___arguments.context.pageData['_webpageSections'] = (_webpageSections.length);
  ___arguments.context.pageData['WebpageSections'] = _webpageSections;
  _localWebPageDataRoot = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accoweb.pockethost.io/api/collections/webpages/records?filter=(objectId=\'',_webpageObjectID,'\')'].join('')))).setEncoding('utf8').send()), 'items'))[0];
  ___arguments.context.pageData['WebpageDataRoot'] = _localWebPageDataRoot;
  ___arguments.context.pageData['WebpageData'] = (getObjectProperty(_localWebPageDataRoot, 'PageContent'));
  ___arguments.context.pageData['isPageReady'] = true;
  ___arguments.context.pageData['BETAItemsVisible'] = false;
  AppURL = (await BackendlessUI.Functions.Custom['fn_7c99d93c763398d595b7ff4a51c14f57']());
  AppBaseURL = AppURL.slice(0, 23);
  console.log(String('AppBaseURL = ') + String(AppBaseURL));

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var result2, result, currentDataSource, _currentUser, _storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ A PAGE ENTER JUST HAPPENED!!! ############################');
  _storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
  if (_storedTokenFromCookie != null || _storedTokenFromCookie != 'undefined') {
    _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](_storedTokenFromCookie));
    console.log('### CURRENT USER ###');
    console.log(_currentUser);
    if (_currentUser != false) {
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
      if ((getObjectProperty(___arguments.context.appData, 'currentUser.record.BETAModeEnabled')) == true) {
        ___arguments.context.appData['isBETAEnabled'] = true;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = true;
      } else {
        ___arguments.context.appData['isBETAEnabled'] = false;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = false;
      }
    } else {
      ___arguments.context.appData['CurrentUser'] = null;
    }
  }
  ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['taskBarTop'] = true;
  ___arguments.context.pageData['taskBarBottom'] = false;
  ___arguments.context.pageData['hideButtonsMode'] = true;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onEnter */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onResize */
  /* handler:onPageQuery */
  async ['onPageQuery'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.pageQuery, 'debugMode')) == true && (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'currentUser'))))) {
    ___arguments.context.appData['debugMode'] = true;
  } else {
    ___arguments.context.appData['debugMode'] = false;
  }

  },
  /* handler:onPageQuery */
  /* content */
}))

define('./pages/careers/components/f6c3d992d48fe05b791cfba8a2c9ea19/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 1;
  	video.playbackRate = 1;
  	video.play();
  })();

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 0;
  	video.playbackRate = 1;
  	video.pause();
  })();

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/careers/components/27b9fd37c4233d555444978939bfe4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/careers/components/4a16f104bfbce399523c5d8152efe8af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/careers/components/e49eae259f43d5e4ed34fbed4c1690f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '8D6FAC01-F4F5-466C-8D61-4C6395519121';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/careers/components/d6338723fe754ea845c18574e1db8e3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'B103EFB3-F65C-4F60-A3A7-0CBBB9F80C08';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/careers/components/fa5129e49d61d9c6b57287189523e39e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '428FA853-8475-41D5-BEAE-0A758818D0BC';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/careers/components/26ebd15ce2f2c1d6f9813d1a00a26054/bundle.js', [], () => ({
  /* content */
  /* handler:onAction */
  async ['onAction'](___arguments) {
      await (async function() {
  	window.location.reload()
  })();

  },
  /* handler:onAction */
  /* content */
}))

define('./pages/careers/components/54dcab8d080f34d8921bdbb632146cd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();//pageData.currentDataContent;
  	ownerBlock[0].innerHTML = `${sourceContent}`;
  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/careers/components/c19816bbc89f510c6b0f61af2ce6e8cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/careers/components/868de2a35dc382de3c1cd8fbad23a403/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  blockObjectID = '4645C476-DE2B-4007-9A54-03BBC0D8B746';
  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
       if ((getObjectProperty(item, 'id')) == blockObjectID) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/careers/components/4ab52bf14234a3b76ef19002bc343042/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '4087A0EA-27D1-45A5-97A2-9E787C8323E6';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/careers/components/f84a59cfd95b86ecac0818e2f8369ed1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '5155423A-F695-4B2F-AADB-4D18281D0F89';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/careers/components/7b1cb0a9932c78bfd8d5b79381e54204/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'A512CA81-3F67-48FE-9F52-1773D57EEC5B';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/careers/components/8b7ea841affa30d6d4891c06e62e2d89/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogo-mini', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var _currentUser, result2, result, storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.event, 'ctrlKey')) == true && (getObjectProperty(___arguments.event, 'altKey')) == true) {
    ___arguments.context.pageData['hideButtonsMode'] = false;
    storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
    if (storedTokenFromCookie != null || storedTokenFromCookie != '') {
      _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](storedTokenFromCookie));
      if (_currentUser != false) {
        if ((getObjectProperty(_currentUser, 'token')) != '') {
          localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
        }
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
      }
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      ___arguments.context.appData['inAdminMode'] = true;
      ___arguments.context.appData['isLoggedIn'] = true;
      ___arguments.context.pageData['showAdminBar'] = true;
    } else {
      console.log('####### THE COOKIE IS NOT NULL!!! #######');
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
    }
    console.log(___arguments.event);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('####### appData.CurrentUser #######');
  console.log(getObjectProperty(___arguments.context.appData, 'CurrentUser'));
  console.log('####### ISLOGGEDIN: #######');
  console.log(getObjectProperty(___arguments.context.appData, 'isLoggedIn'));
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
    if ((getObjectProperty(___arguments.context.appData, 'CurrentUser')) != false) {
      console.log('####### CHECKING IF USER isWebsiteEditor #######');
      result = (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'CurrentUser'))));
      if (result == true) {
        console.log('####### RETURN FROM isWebsiteEditor FUNCTION #######');
        console.log('isWebsiteEditor = ');
        console.log(result);
        console.log('####### HIDE BUTTONS MODE #######');
        console.log(getObjectProperty(___arguments.context.pageData, 'hideButtonsMode'));
        if ((getObjectProperty(___arguments.context.pageData, 'hideButtonsMode')) == true) {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', true);
        } else {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);
        }
      }
    }
  }

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/careers/components/e18a76e42143485dabe50caddb6fdd6f/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogoCell-right', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/careers/components/3ea61bdd3ad1e562a5185b8204761226/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();
  	pageData.currentDataContent = sourceContent; // added decodeURIComponent for troubleshooting

  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('admin_Webpages').save( ({ 'objectId': (getObjectProperty(___arguments.context.pageData, 'currentDataSource')),'BlockContent': (encodeURIComponent((getObjectProperty(___arguments.context.pageData, 'currentDataContent')))) }) );

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/careers/components/19f2f0dacd13571dc9b931385a463b62/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/careers/components/cc3a9886128a333e4fb5d24ca934c255/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  return (['You are logged on as: ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'CurrentUser')), 'record')), 'name')),' | CTRL + ALT Click on your logo to turn edit mode back on again.'].join(''));

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/careers/components/0b76d57506286594c0a8661497f83bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'C1F6E9F5-7F62-4DEC-87C0-70A43E04649C';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/careers/components/226882c510580398880a31741218b794/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('careers', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    
  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/careers/components/ac5384a89159966cc8681bfea27aa946/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('industries', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/careers/components/f96298252c8b58c3630720c3f3968e33/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var result2, result;

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  result = (await (async function(pageData, HTMLSource, tinydrive_dropbox_app_key, created_jwt_token) {
  	/*
  	
  	// Plugins that we probably will need: mediaembed, export linkchecker?, powerpaste, advtable, editimage, autocorrect, typography, checklist
  	Existing plugins backup: 'tinydrive code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
  	Removed from below: 
  	toolbar_sticky: true,
  	toolbar_mode: 'floating', // Modes: floating, sliding, scrolling, wrap
  	
  	*/
  	
  	const editor = await BackendlessUI.requireModule('https://cdn.tiny.cloud/1/dwt7je7v9gjog7a8oc867xici2xmy80whuw0asnvstr20590/tinymce/8/tinymce.min.js')
  	tinymce.init({ selector: '.TinyMCETextEditor',
  	plugins: 'tinydrive code anchor link charmap codesample emoticons image lists media searchreplace table visualblocks wordcount',
  	toolbar: 'undo redo | blocks fontfamily fontsize | fontsizeselect | forecolor backcolor | bold italic underline strikethrough blockquote | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat | code',
  	font_family_formats: 'Andale Mono="Andale Mono"; Arial=arial; Arial Black="arial black"; Book Antiqua = "book antiqua"; Comic Sans MS="Comic Sans MS"; Courier New=courier new,courier,monospace; Georgia=georgia; Helvetica=helvetica; Impact=impact; Tahoma=tahoma; Terminal=terminal; Times New Roman="times new roman"; Trebuchet MS = "trebuchet ms"; Sans Serif="sans serif"; Segoe UI=segoe ui; Verdana=verdana; Webdings=webdings; Wingdings=wingdings',
  	font_size_formats: "8px 10px 12px 14px 16px 18px 20px 24px 30px 36px 48px 60px 72px 96px",
  	relative_urls : true,
  	remove_script_host : false,
  	document_base_url : 'https://www.accofg.com/',
  	tinydrive_dropbox_app_key: tinydrive_dropbox_app_key,
  	tinydrive_token_provider: (success, failure) => {
  	        success({ token:  created_jwt_token });
  	  },
  	setup: function (editor) {
  	      editor.on('init', function (e) {
  	        editor.setContent(HTMLSource);
  	      });
  	  }
  	
  	}) //#${id}`}) `this was inside a template string`
  	
  	// document.getElementById('btnUpdateContent').addEventListener("click", saveContent)
  	
  	function saveContent() {
  	const myContent = tinymce.activeEditor.getContent()
  	pageData.myContent = myContent
  	}

  })(___arguments.context.pageData, (getObjectProperty(___arguments.context.pageData, 'currentDataContent')), '7svncuz1u3xumyc', (getObjectProperty(((function () { return BackendlessUI.getCustomSettings() })()), 'created_jwt_token'))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/careers/components/859df6fc47f553256c989f7c2b88adcc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isOpenModal'))

  },
  /* handler:onDisplayAssignment */
  /* handler:modalVisibilityLogic */
  ['modalVisibilityLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isOpenModal'))

  },
  /* handler:modalVisibilityLogic */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;

  },
  /* handler:onClose */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    var result;


  console.log('Modal: (OnVisibilityChange) Modal Visible | Content Pushed to TinyMCE in the modal__card.OnVisible Event');

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/careers/components/71dd7f53b1157583c11cd04885411f04/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var result;


  result = (await (async function(pageData) {
  	// Create an array by ClassName 'content_editable' and invoke the function (editable) and create an event listener for each index in the array
  	// const runner = { currentDataSource: ""};
  	
  	var loadFromBlock, HTMLSource;
  	loadFromBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource);
  	console.log ('modal__card: OnMounted: The data source has been set to: ' + pageData.currentDataSource);
  	HTMLSource = loadFromBlock[0].innerHTML;
  	// loadFromBlock.currentTarget.getAttribute('data-source')
  	tinymce.activeEditor.setContent(HTMLSource);
  	pageData.currentDataContent = HTMLSource
  })(___arguments.context.pageData));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/careersearch/components/55343ac7f355e5866b258f56b9374e51/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projects-and-services', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/careersearch/components/e3dbcfc8260ddb18fbfa650584ebcb7b/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('about', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/careersearch/components/9274dbcfe0ee894416a264e55332b426/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('subcontractors', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/careersearch/components/c7db3fda439eae33a98479749c1f6cdc/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('employees', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/careersearch/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var WebsiteMode, AppBaseURL, AppURL, _localWebPageDataRoot, _webpageObjectID, _webpageSections;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isPageReady'] = false;
  _webpageObjectID = '4e9690fa-21a8-ed16-8b58-b2350bb8f9dd';
  ___arguments.context.pageData['WebpageObjectID'] = _webpageObjectID;
  _webpageSections = ['headerBlock1', 'headerBlock2', 'heroBlock1', 'heroBlock2', 'landingBlock1', 'landingBlock2', 'landingBlock3', 'landingBlock4', 'footerBlock1', 'footerBlock2'];
  ___arguments.context.pageData['_webpageSections'] = (_webpageSections.length);
  ___arguments.context.pageData['WebpageSections'] = _webpageSections;
  _localWebPageDataRoot = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accoweb.pockethost.io/api/collections/webpages/records?filter=(objectId=\'',_webpageObjectID,'\')'].join('')))).setEncoding('utf8').send()), 'items'))[0];
  ___arguments.context.pageData['WebpageDataRoot'] = _localWebPageDataRoot;
  ___arguments.context.pageData['WebpageData'] = (getObjectProperty(_localWebPageDataRoot, 'PageContent'));
  ___arguments.context.pageData['isPageReady'] = true;
  ___arguments.context.pageData['BETAItemsVisible'] = false;
  AppURL = (await BackendlessUI.Functions.Custom['fn_7c99d93c763398d595b7ff4a51c14f57']());
  AppBaseURL = AppURL.slice(0, 23);
  console.log(String('AppBaseURL = ') + String(AppBaseURL));

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var result2, result, currentDataSource, _currentUser, _storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ A PAGE ENTER JUST HAPPENED!!! ############################');
  _storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
  if (_storedTokenFromCookie != null || _storedTokenFromCookie != 'undefined') {
    _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](_storedTokenFromCookie));
    console.log('### CURRENT USER ###');
    console.log(_currentUser);
    if (_currentUser != false) {
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
      if ((getObjectProperty(___arguments.context.appData, 'currentUser.record.BETAModeEnabled')) == true) {
        ___arguments.context.appData['isBETAEnabled'] = true;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = true;
      } else {
        ___arguments.context.appData['isBETAEnabled'] = false;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = false;
      }
    } else {
      ___arguments.context.appData['CurrentUser'] = null;
    }
  }
  ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['taskBarTop'] = true;
  ___arguments.context.pageData['taskBarBottom'] = false;
  ___arguments.context.pageData['hideButtonsMode'] = true;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onEnter */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onResize */
  /* handler:onPageQuery */
  async ['onPageQuery'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.pageQuery, 'debugMode')) == true && (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'currentUser'))))) {
    ___arguments.context.appData['debugMode'] = true;
  } else {
    ___arguments.context.appData['debugMode'] = false;
  }

  },
  /* handler:onPageQuery */
  /* content */
}))

define('./pages/careersearch/components/f6c3d992d48fe05b791cfba8a2c9ea19/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 1;
  	video.playbackRate = 1;
  	video.play();
  })();

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 0;
  	video.playbackRate = 1;
  	video.pause();
  })();

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/careersearch/components/27b9fd37c4233d555444978939bfe4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/careersearch/components/4a16f104bfbce399523c5d8152efe8af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/careersearch/components/e49eae259f43d5e4ed34fbed4c1690f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '8D6FAC01-F4F5-466C-8D61-4C6395519121';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/careersearch/components/d6338723fe754ea845c18574e1db8e3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'B103EFB3-F65C-4F60-A3A7-0CBBB9F80C08';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/careersearch/components/fa5129e49d61d9c6b57287189523e39e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '428FA853-8475-41D5-BEAE-0A758818D0BC';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/careersearch/components/26ebd15ce2f2c1d6f9813d1a00a26054/bundle.js', [], () => ({
  /* content */
  /* handler:onAction */
  async ['onAction'](___arguments) {
      await (async function() {
  	window.location.reload()
  })();

  },
  /* handler:onAction */
  /* content */
}))

define('./pages/careersearch/components/54dcab8d080f34d8921bdbb632146cd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();//pageData.currentDataContent;
  	ownerBlock[0].innerHTML = `${sourceContent}`;
  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/careersearch/components/c19816bbc89f510c6b0f61af2ce6e8cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/careersearch/components/868de2a35dc382de3c1cd8fbad23a403/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  blockObjectID = '4645C476-DE2B-4007-9A54-03BBC0D8B746';
  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
       if ((getObjectProperty(item, 'id')) == blockObjectID) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/careersearch/components/4ab52bf14234a3b76ef19002bc343042/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '4087A0EA-27D1-45A5-97A2-9E787C8323E6';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/careersearch/components/f84a59cfd95b86ecac0818e2f8369ed1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '5155423A-F695-4B2F-AADB-4D18281D0F89';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/careersearch/components/7b1cb0a9932c78bfd8d5b79381e54204/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'A512CA81-3F67-48FE-9F52-1773D57EEC5B';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/careersearch/components/8b7ea841affa30d6d4891c06e62e2d89/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogo-mini', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var _currentUser, result2, result, storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.event, 'ctrlKey')) == true && (getObjectProperty(___arguments.event, 'altKey')) == true) {
    ___arguments.context.pageData['hideButtonsMode'] = false;
    storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
    if (storedTokenFromCookie != null || storedTokenFromCookie != '') {
      _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](storedTokenFromCookie));
      if (_currentUser != false) {
        if ((getObjectProperty(_currentUser, 'token')) != '') {
          localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
        }
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
      }
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      ___arguments.context.appData['inAdminMode'] = true;
      ___arguments.context.appData['isLoggedIn'] = true;
      ___arguments.context.pageData['showAdminBar'] = true;
    } else {
      console.log('####### THE COOKIE IS NOT NULL!!! #######');
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
    }
    console.log(___arguments.event);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('####### appData.CurrentUser #######');
  console.log(getObjectProperty(___arguments.context.appData, 'CurrentUser'));
  console.log('####### ISLOGGEDIN: #######');
  console.log(getObjectProperty(___arguments.context.appData, 'isLoggedIn'));
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
    if ((getObjectProperty(___arguments.context.appData, 'CurrentUser')) != false) {
      console.log('####### CHECKING IF USER isWebsiteEditor #######');
      result = (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'CurrentUser'))));
      if (result == true) {
        console.log('####### RETURN FROM isWebsiteEditor FUNCTION #######');
        console.log('isWebsiteEditor = ');
        console.log(result);
        console.log('####### HIDE BUTTONS MODE #######');
        console.log(getObjectProperty(___arguments.context.pageData, 'hideButtonsMode'));
        if ((getObjectProperty(___arguments.context.pageData, 'hideButtonsMode')) == true) {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', true);
        } else {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);
        }
      }
    }
  }

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/careersearch/components/e18a76e42143485dabe50caddb6fdd6f/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogoCell-right', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/careersearch/components/3ea61bdd3ad1e562a5185b8204761226/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();
  	pageData.currentDataContent = sourceContent; // added decodeURIComponent for troubleshooting

  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('admin_Webpages').save( ({ 'objectId': (getObjectProperty(___arguments.context.pageData, 'currentDataSource')),'BlockContent': (encodeURIComponent((getObjectProperty(___arguments.context.pageData, 'currentDataContent')))) }) );

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/careersearch/components/19f2f0dacd13571dc9b931385a463b62/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/careersearch/components/cc3a9886128a333e4fb5d24ca934c255/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  return (['You are logged on as: ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'CurrentUser')), 'record')), 'name')),' | CTRL + ALT Click on your logo to turn edit mode back on again.'].join(''));

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/careersearch/components/0b76d57506286594c0a8661497f83bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'C1F6E9F5-7F62-4DEC-87C0-70A43E04649C';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/careersearch/components/226882c510580398880a31741218b794/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('careers', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/careersearch/components/ac5384a89159966cc8681bfea27aa946/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('industries', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/careersearch/components/f96298252c8b58c3630720c3f3968e33/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var result2, result;

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  result = (await (async function(pageData, HTMLSource, tinydrive_dropbox_app_key, created_jwt_token) {
  	/*
  	
  	// Plugins that we probably will need: mediaembed, export linkchecker?, powerpaste, advtable, editimage, autocorrect, typography, checklist
  	Existing plugins backup: 'tinydrive code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
  	Removed from below: 
  	toolbar_sticky: true,
  	toolbar_mode: 'floating', // Modes: floating, sliding, scrolling, wrap
  	
  	*/
  	
  	const editor = await BackendlessUI.requireModule('https://cdn.tiny.cloud/1/dwt7je7v9gjog7a8oc867xici2xmy80whuw0asnvstr20590/tinymce/8/tinymce.min.js')
  	tinymce.init({ selector: '.TinyMCETextEditor',
  	plugins: 'tinydrive code anchor link charmap codesample emoticons image lists media searchreplace table visualblocks wordcount',
  	toolbar: 'undo redo | blocks fontfamily fontsize | fontsizeselect | forecolor backcolor | bold italic underline strikethrough blockquote | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat | code',
  	font_family_formats: 'Andale Mono="Andale Mono"; Arial=arial; Arial Black="arial black"; Book Antiqua = "book antiqua"; Comic Sans MS="Comic Sans MS"; Courier New=courier new,courier,monospace; Georgia=georgia; Helvetica=helvetica; Impact=impact; Tahoma=tahoma; Terminal=terminal; Times New Roman="times new roman"; Trebuchet MS = "trebuchet ms"; Sans Serif="sans serif"; Segoe UI=segoe ui; Verdana=verdana; Webdings=webdings; Wingdings=wingdings',
  	font_size_formats: "8px 10px 12px 14px 16px 18px 20px 24px 30px 36px 48px 60px 72px 96px",
  	relative_urls : true,
  	remove_script_host : false,
  	document_base_url : 'https://www.accofg.com/',
  	tinydrive_dropbox_app_key: tinydrive_dropbox_app_key,
  	tinydrive_token_provider: (success, failure) => {
  	        success({ token:  created_jwt_token });
  	  },
  	setup: function (editor) {
  	      editor.on('init', function (e) {
  	        editor.setContent(HTMLSource);
  	      });
  	  }
  	
  	}) //#${id}`}) `this was inside a template string`
  	
  	// document.getElementById('btnUpdateContent').addEventListener("click", saveContent)
  	
  	function saveContent() {
  	const myContent = tinymce.activeEditor.getContent()
  	pageData.myContent = myContent
  	}

  })(___arguments.context.pageData, (getObjectProperty(___arguments.context.pageData, 'currentDataContent')), '7svncuz1u3xumyc', (getObjectProperty(((function () { return BackendlessUI.getCustomSettings() })()), 'created_jwt_token'))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/careersearch/components/859df6fc47f553256c989f7c2b88adcc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isOpenModal'))

  },
  /* handler:onDisplayAssignment */
  /* handler:modalVisibilityLogic */
  ['modalVisibilityLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isOpenModal'))

  },
  /* handler:modalVisibilityLogic */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;

  },
  /* handler:onClose */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    var result;


  console.log('Modal: (OnVisibilityChange) Modal Visible | Content Pushed to TinyMCE in the modal__card.OnVisible Event');

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/careersearch/components/71dd7f53b1157583c11cd04885411f04/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var result;


  result = (await (async function(pageData) {
  	// Create an array by ClassName 'content_editable' and invoke the function (editable) and create an event listener for each index in the array
  	// const runner = { currentDataSource: ""};
  	
  	var loadFromBlock, HTMLSource;
  	loadFromBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource);
  	console.log ('modal__card: OnMounted: The data source has been set to: ' + pageData.currentDataSource);
  	HTMLSource = loadFromBlock[0].innerHTML;
  	// loadFromBlock.currentTarget.getAttribute('data-source')
  	tinymce.activeEditor.setContent(HTMLSource);
  	pageData.currentDataContent = HTMLSource
  })(___arguments.context.pageData));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/css-playground/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var WebsiteMode, AppBaseURL, AppURL, _localWebPageDataRoot, _webpageObjectID, _webpageSections;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isPageReady'] = false;
  _webpageObjectID = '3B6B2404-C1AA-47E8-B2BB-AD3C6BB91242';
  ___arguments.context.pageData['WebpageObjectID'] = _webpageObjectID;
  _webpageSections = ['headerBlock1', 'headerBlock2', 'heroBlock1', 'heroBlock2', 'landingBlock1', 'landingBlock2', 'landingBlock3', 'landingBlock4', 'footerBlock1', 'footerBlock2'];
  ___arguments.context.pageData['_webpageSections'] = (_webpageSections.length);
  ___arguments.context.pageData['WebpageSections'] = _webpageSections;
  _localWebPageDataRoot = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accoweb.pockethost.io/api/collections/webpages/records?filter=(objectId=\'',_webpageObjectID,'\')'].join('')))).setEncoding('utf8').send()), 'items'))[0];
  ___arguments.context.pageData['WebpageDataRoot'] = _localWebPageDataRoot;
  ___arguments.context.pageData['WebpageData'] = (getObjectProperty(_localWebPageDataRoot, 'PageContent'));
  ___arguments.context.pageData['isPageReady'] = true;
  ___arguments.context.pageData['BETAItemsVisible'] = false;
  AppURL = (await BackendlessUI.Functions.Custom['fn_7c99d93c763398d595b7ff4a51c14f57']());
  AppBaseURL = AppURL.slice(0, 23);
  console.log(String('AppBaseURL = ') + String(AppBaseURL));

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var result2, result, currentDataSource, _currentUser, _storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ A PAGE ENTER JUST HAPPENED!!! ############################');
  _storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
  if (_storedTokenFromCookie != null || _storedTokenFromCookie != 'undefined') {
    _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](_storedTokenFromCookie));
    console.log('### CURRENT USER ###');
    console.log(_currentUser);
    if (_currentUser != false) {
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
      if ((getObjectProperty(___arguments.context.appData, 'currentUser.record.BETAModeEnabled')) == true) {
        ___arguments.context.appData['isBETAEnabled'] = true;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = true;
      } else {
        ___arguments.context.appData['isBETAEnabled'] = false;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = false;
      }
    } else {
      ___arguments.context.appData['CurrentUser'] = null;
    }
  }
  ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['taskBarTop'] = true;
  ___arguments.context.pageData['taskBarBottom'] = false;
  ___arguments.context.pageData['hideButtonsMode'] = true;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onEnter */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onResize */
  /* handler:onPageQuery */
  async ['onPageQuery'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.pageQuery, 'debugMode')) == true && (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'currentUser'))))) {
    ___arguments.context.appData['debugMode'] = true;
  } else {
    ___arguments.context.appData['debugMode'] = false;
  }

  },
  /* handler:onPageQuery */
  /* content */
}))

define('./pages/css-playground/components/f6c3d992d48fe05b791cfba8a2c9ea19/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 1;
  	video.playbackRate = 1;
  	video.play();
  })();

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 0;
  	video.playbackRate = 1;
  	video.pause();
  })();

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/css-playground/components/27b9fd37c4233d555444978939bfe4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/css-playground/components/717adc521cbdf7ca7f3db4188da3a5c7/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classesList = ['modal'];
  if (getObjectProperty(___arguments.context.pageData, 'isOpenModal')) {
    addItemToList(classesList, 'open');
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'blockMouseOverEvent')) != true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('717adc521cbdf7ca7f3db4188da3a5c7', true);
    ___arguments.context.pageData['blockMouseOverEvent'] = true;
  }

  },
  /* handler:onMouseOver */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var result;


  result = (await (async function(pageData) {
  	// Create an array by ClassName 'content_editable' and invoke the function (editable) and create an event listener for each index in the array
  	// const runner = { currentDataSource: ""};
  	
  	var loadFromBlock, HTMLSource;
  	loadFromBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource);
  	console.log ('The data source has been set to: ' + pageData.currentDataSource);
  	HTMLSource = loadFromBlock[0].innerHTML;
  	// loadFromBlock.currentTarget.getAttribute('data-source')
  	tinymce.activeEditor.setContent(HTMLSource);
  	pageData.currentDataContent = HTMLSource
  })(___arguments.context.pageData));

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/css-playground/components/8cd91f8f8d38899143393ed8c8129c7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/css-playground/components/4a16f104bfbce399523c5d8152efe8af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/css-playground/components/e49eae259f43d5e4ed34fbed4c1690f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '8D6FAC01-F4F5-466C-8D61-4C6395519121';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/css-playground/components/d6338723fe754ea845c18574e1db8e3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'B103EFB3-F65C-4F60-A3A7-0CBBB9F80C08';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/css-playground/components/fa5129e49d61d9c6b57287189523e39e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '428FA853-8475-41D5-BEAE-0A758818D0BC';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/css-playground/components/26ebd15ce2f2c1d6f9813d1a00a26054/bundle.js', [], () => ({
  /* content */
  /* handler:onAction */
  async ['onAction'](___arguments) {
    var WebsiteMode, AppBaseURL, AppURL, _localWebPageDataRoot, _webpageObjectID, _webpageSections;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isPageReady'] = false;
  _webpageObjectID = (getObjectProperty(___arguments.context.pageData, 'WebpageObjectID'));
  ___arguments.context.pageData['WebpageObjectID'] = _webpageObjectID;
  _webpageSections = ['headerBlock1', 'headerBlock2', 'heroBlock1', 'heroBlock2', 'landingBlock1', 'landingBlock2', 'landingBlock3', 'landingBlock4', 'footerBlock1', 'footerBlock2'];
  ___arguments.context.pageData['_webpageSections'] = (_webpageSections.length);
  ___arguments.context.pageData['WebpageSections'] = _webpageSections;
  _localWebPageDataRoot = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accoweb.pockethost.io/api/collections/webpages/records?filter=(objectId=\'',_webpageObjectID,'\')'].join('')))).setEncoding('utf8').send()), 'items'))[0];
  ___arguments.context.pageData['WebpageDataRoot'] = _localWebPageDataRoot;
  ___arguments.context.pageData['WebpageData'] = (getObjectProperty(_localWebPageDataRoot, 'PageContent'));
  ___arguments.context.pageData['isPageReady'] = true;
  ___arguments.context.pageData['BETAItemsVisible'] = false;
  AppURL = (await BackendlessUI.Functions.Custom['fn_7c99d93c763398d595b7ff4a51c14f57']());
  AppBaseURL = AppURL.slice(0, 23);
  console.log(String('AppBaseURL = ') + String(AppBaseURL));

  },
  /* handler:onAction */
  /* content */
}))

define('./pages/css-playground/components/54dcab8d080f34d8921bdbb632146cd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();//pageData.currentDataContent;
  	ownerBlock[0].innerHTML = `${sourceContent}`;
  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/css-playground/components/c19816bbc89f510c6b0f61af2ce6e8cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/css-playground/components/868de2a35dc382de3c1cd8fbad23a403/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  blockObjectID = '4645C476-DE2B-4007-9A54-03BBC0D8B746';
  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
       if ((getObjectProperty(item, 'id')) == blockObjectID) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/css-playground/components/4ab52bf14234a3b76ef19002bc343042/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '4087A0EA-27D1-45A5-97A2-9E787C8323E6';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/css-playground/components/f84a59cfd95b86ecac0818e2f8369ed1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '5155423A-F695-4B2F-AADB-4D18281D0F89';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/css-playground/components/7b1cb0a9932c78bfd8d5b79381e54204/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'A512CA81-3F67-48FE-9F52-1773D57EEC5B';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/css-playground/components/8b7ea841affa30d6d4891c06e62e2d89/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    
  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var _currentUser, result2, result, storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.event, 'ctrlKey')) == true && (getObjectProperty(___arguments.event, 'altKey')) == true) {
    ___arguments.context.pageData['hideButtonsMode'] = false;
    storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
    if (storedTokenFromCookie != null || storedTokenFromCookie != '') {
      _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](storedTokenFromCookie));
      if (_currentUser != false) {
        if ((getObjectProperty(_currentUser, 'token')) != '') {
          localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
        }
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
      }
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      ___arguments.context.appData['inAdminMode'] = true;
      ___arguments.context.appData['isLoggedIn'] = true;
      ___arguments.context.pageData['showAdminBar'] = true;
      if ((getObjectProperty(___arguments.context.appData, 'inAdminMode')) == true) {
        result = (await (async function(pageData) {
        	var myFunction = (e)=> {
        	  // console.log(e.currentTarget.getAttribute('data-source'));
        	  e.currentTarget.setAttribute('data-modified','true');
        	  console.log('This element has been marked as data-modified: ' + e.currentTarget.getAttribute('data-source'));
        	}
        	
        	Array.from(document.getElementsByClassName('content_editable')).forEach((editable) => {
        	  // editable.addEventListener('click', myFunction);
        	  editable.addEventListener('click', myFunction);
        	  
        	});
        })(___arguments.context.pageData));
      }
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
    }
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('####### appData.CurrentUser #######');
  console.log(getObjectProperty(___arguments.context.appData, 'CurrentUser'));
  console.log('####### ISLOGGEDIN: #######');
  console.log(getObjectProperty(___arguments.context.appData, 'isLoggedIn'));
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
    if ((getObjectProperty(___arguments.context.appData, 'CurrentUser')) != false) {
      console.log('####### CHECKING IF USER isWebsiteEditor #######');
      result = (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'CurrentUser'))));
      if (result == true) {
        console.log('####### RETURN FROM isWebsiteEditor FUNCTION #######');
        console.log('isWebsiteEditor = ');
        console.log(result);
        console.log('####### HIDE BUTTONS MODE #######');
        console.log(getObjectProperty(___arguments.context.pageData, 'hideButtonsMode'));
        if ((getObjectProperty(___arguments.context.pageData, 'hideButtonsMode')) == true) {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', true);
        } else {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);
        }
      }
    }
  }

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/css-playground/components/3ea61bdd3ad1e562a5185b8204761226/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();
  	pageData.currentDataContent = sourceContent; // added decodeURIComponent for troubleshooting

  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('admin_Webpages').save( ({ 'objectId': (getObjectProperty(___arguments.context.pageData, 'currentDataSource')),'BlockContent': (encodeURIComponent((getObjectProperty(___arguments.context.pageData, 'currentDataContent')))) }) );

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/css-playground/components/0b76d57506286594c0a8661497f83bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'C1F6E9F5-7F62-4DEC-87C0-70A43E04649C';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/employees/components/55343ac7f355e5866b258f56b9374e51/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projects-and-services', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/employees/components/e3dbcfc8260ddb18fbfa650584ebcb7b/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('about', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/employees/components/9274dbcfe0ee894416a264e55332b426/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('subcontractors', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/employees/components/c7db3fda439eae33a98479749c1f6cdc/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    
  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('employees', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) == 'employees') {
    if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
      return ['easeInAndOut', 'underline'];
    } else {
      return ['hide-beta', 'easeInAndOut', 'underline'];
    }
  } else {
    if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
      return ['easeInAndOut'];
    } else {
      return ['hide-beta', 'easeInAndOut'];
    }
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/employees/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var WebsiteMode, AppBaseURL, AppURL, _localWebPageDataRoot, _webpageObjectID, _webpageSections;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ AN - ON BEFORE PAGE ENTER - EVENT JUST HAPPENED!!! ############################');
  ___arguments.context.pageData['isPageReady'] = false;
  _webpageObjectID = '25d8d818-9da8-f758-77bc-81b8c39c6318';
  ___arguments.context.pageData['WebpageObjectID'] = _webpageObjectID;
  _webpageSections = ['headerBlock1', 'headerBlock2', 'heroBlock1', 'heroBlock2', 'landingBlock1', 'landingBlock2', 'landingBlock3', 'landingBlock4', 'footerBlock1', 'footerBlock2'];
  ___arguments.context.pageData['_webpageSections'] = (_webpageSections.length);
  ___arguments.context.pageData['WebpageSections'] = _webpageSections;
  _localWebPageDataRoot = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accoweb.pockethost.io/api/collections/webpages/records?filter=(objectId=\'',_webpageObjectID,'\')'].join('')))).setEncoding('utf8').send()), 'items'))[0];
  ___arguments.context.pageData['WebpageDataRoot'] = _localWebPageDataRoot;
  ___arguments.context.pageData['WebpageData'] = (getObjectProperty(_localWebPageDataRoot, 'PageContent'));
  ___arguments.context.pageData['isPageReady'] = true;
  ___arguments.context.pageData['BETAItemsVisible'] = false;
  AppURL = (await BackendlessUI.Functions.Custom['fn_7c99d93c763398d595b7ff4a51c14f57']());
  AppBaseURL = AppURL.slice(0, 23);
  console.log(String('AppBaseURL = ') + String(AppBaseURL));

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var result2, result, currentDataSource, _currentUser, _storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ A PAGE ENTER JUST HAPPENED!!! ############################');
  _storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
  if (_storedTokenFromCookie != null || _storedTokenFromCookie != 'undefined') {
    _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](_storedTokenFromCookie));
    console.log('### CURRENT USER ###');
    console.log(_currentUser);
    if (_currentUser != false) {
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
      if ((getObjectProperty(___arguments.context.appData, 'currentUser.record.BETAModeEnabled')) == true) {
        ___arguments.context.appData['isBETAEnabled'] = true;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = true;
      } else {
        ___arguments.context.appData['isBETAEnabled'] = false;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = false;
      }
    } else {
      ___arguments.context.appData['CurrentUser'] = null;
    }
  }
  ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['taskBarTop'] = true;
  ___arguments.context.pageData['taskBarBottom'] = false;
  ___arguments.context.pageData['hideButtonsMode'] = true;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onEnter */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onResize */
  /* handler:onPageQuery */
  async ['onPageQuery'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.pageQuery, 'debugMode')) == true && (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'currentUser'))))) {
    ___arguments.context.appData['debugMode'] = true;
  } else {
    ___arguments.context.appData['debugMode'] = false;
  }

  },
  /* handler:onPageQuery */
  /* content */
}))

define('./pages/employees/components/f6c3d992d48fe05b791cfba8a2c9ea19/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 1;
  	video.playbackRate = 1;
  	video.play();
  })();

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 0;
  	video.playbackRate = 1;
  	video.pause();
  })();

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/employees/components/27b9fd37c4233d555444978939bfe4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/employees/components/4a16f104bfbce399523c5d8152efe8af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/employees/components/e49eae259f43d5e4ed34fbed4c1690f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '8D6FAC01-F4F5-466C-8D61-4C6395519121';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/employees/components/d6338723fe754ea845c18574e1db8e3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'B103EFB3-F65C-4F60-A3A7-0CBBB9F80C08';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/employees/components/fa5129e49d61d9c6b57287189523e39e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '428FA853-8475-41D5-BEAE-0A758818D0BC';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/employees/components/26ebd15ce2f2c1d6f9813d1a00a26054/bundle.js', [], () => ({
  /* content */
  /* handler:onAction */
  async ['onAction'](___arguments) {
      await (async function() {
  	window.location.reload()
  })();

  },
  /* handler:onAction */
  /* content */
}))

define('./pages/employees/components/54dcab8d080f34d8921bdbb632146cd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();//pageData.currentDataContent;
  	ownerBlock[0].innerHTML = `${sourceContent}`;
  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/employees/components/c19816bbc89f510c6b0f61af2ce6e8cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/employees/components/868de2a35dc382de3c1cd8fbad23a403/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  blockObjectID = '4645C476-DE2B-4007-9A54-03BBC0D8B746';
  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
       if ((getObjectProperty(item, 'id')) == blockObjectID) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/employees/components/4ab52bf14234a3b76ef19002bc343042/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '4087A0EA-27D1-45A5-97A2-9E787C8323E6';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/employees/components/f84a59cfd95b86ecac0818e2f8369ed1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '5155423A-F695-4B2F-AADB-4D18281D0F89';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/employees/components/7b1cb0a9932c78bfd8d5b79381e54204/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'A512CA81-3F67-48FE-9F52-1773D57EEC5B';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/employees/components/8b7ea841affa30d6d4891c06e62e2d89/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogo-mini', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var _currentUser, result2, result, storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.event, 'ctrlKey')) == true && (getObjectProperty(___arguments.event, 'altKey')) == true) {
    ___arguments.context.pageData['hideButtonsMode'] = false;
    storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
    if (storedTokenFromCookie != null || storedTokenFromCookie != '') {
      _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](storedTokenFromCookie));
      if (_currentUser != false) {
        if ((getObjectProperty(_currentUser, 'token')) != '') {
          localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
        }
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
      }
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      ___arguments.context.appData['inAdminMode'] = true;
      ___arguments.context.appData['isLoggedIn'] = true;
      ___arguments.context.pageData['showAdminBar'] = true;
    } else {
      console.log('####### THE COOKIE IS NOT NULL!!! #######');
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
    }
    console.log(___arguments.event);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('####### appData.CurrentUser #######');
  console.log(getObjectProperty(___arguments.context.appData, 'CurrentUser'));
  console.log('####### ISLOGGEDIN: #######');
  console.log(getObjectProperty(___arguments.context.appData, 'isLoggedIn'));
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
    if ((getObjectProperty(___arguments.context.appData, 'CurrentUser')) != false) {
      console.log('####### CHECKING IF USER isWebsiteEditor #######');
      result = (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'CurrentUser'))));
      if (result == true) {
        console.log('####### RETURN FROM isWebsiteEditor FUNCTION #######');
        console.log('isWebsiteEditor = ');
        console.log(result);
        console.log('####### HIDE BUTTONS MODE #######');
        console.log(getObjectProperty(___arguments.context.pageData, 'hideButtonsMode'));
        if ((getObjectProperty(___arguments.context.pageData, 'hideButtonsMode')) == true) {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', true);
        } else {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);
        }
      }
    }
  }

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/employees/components/e18a76e42143485dabe50caddb6fdd6f/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogoCell-right', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/employees/components/3ea61bdd3ad1e562a5185b8204761226/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();
  	pageData.currentDataContent = sourceContent; // added decodeURIComponent for troubleshooting

  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('admin_Webpages').save( ({ 'objectId': (getObjectProperty(___arguments.context.pageData, 'currentDataSource')),'BlockContent': (encodeURIComponent((getObjectProperty(___arguments.context.pageData, 'currentDataContent')))) }) );

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/employees/components/19f2f0dacd13571dc9b931385a463b62/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/employees/components/cc3a9886128a333e4fb5d24ca934c255/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  return (['You are logged on as: ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'CurrentUser')), 'record')), 'name')),' | CTRL + ALT Click on your logo to turn edit mode back on again.'].join(''));

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/employees/components/0b76d57506286594c0a8661497f83bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'C1F6E9F5-7F62-4DEC-87C0-70A43E04649C';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/employees/components/226882c510580398880a31741218b794/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('careers', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/employees/components/ac5384a89159966cc8681bfea27aa946/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('industries', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/employees/components/f96298252c8b58c3630720c3f3968e33/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var result2, result;

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  result = (await (async function(pageData, HTMLSource, tinydrive_dropbox_app_key, created_jwt_token) {
  	/*
  	
  	// Plugins that we probably will need: mediaembed, export linkchecker?, powerpaste, advtable, editimage, autocorrect, typography, checklist
  	Existing plugins backup: 'tinydrive code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
  	Removed from below: 
  	toolbar_sticky: true,
  	toolbar_mode: 'floating', // Modes: floating, sliding, scrolling, wrap
  	
  	*/
  	
  	const editor = await BackendlessUI.requireModule('https://cdn.tiny.cloud/1/dwt7je7v9gjog7a8oc867xici2xmy80whuw0asnvstr20590/tinymce/8/tinymce.min.js')
  	tinymce.init({ selector: '.TinyMCETextEditor',
  	plugins: 'tinydrive code anchor link charmap codesample emoticons image lists media searchreplace table visualblocks wordcount',
  	toolbar: 'undo redo | blocks fontfamily fontsize | fontsizeselect | forecolor backcolor | bold italic underline strikethrough blockquote | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat | code',
  	font_family_formats: 'Andale Mono="Andale Mono"; Arial=arial; Arial Black="arial black"; Book Antiqua = "book antiqua"; Comic Sans MS="Comic Sans MS"; Courier New=courier new,courier,monospace; Georgia=georgia; Helvetica=helvetica; Impact=impact; Tahoma=tahoma; Terminal=terminal; Times New Roman="times new roman"; Trebuchet MS = "trebuchet ms"; Sans Serif="sans serif"; Segoe UI=segoe ui; Verdana=verdana; Webdings=webdings; Wingdings=wingdings',
  	font_size_formats: "8px 10px 12px 14px 16px 18px 20px 24px 30px 36px 48px 60px 72px 96px",
  	relative_urls : true,
  	remove_script_host : false,
  	document_base_url : 'https://www.accofg.com/',
  	tinydrive_dropbox_app_key: tinydrive_dropbox_app_key,
  	tinydrive_token_provider: (success, failure) => {
  	        success({ token:  created_jwt_token });
  	  },
  	setup: function (editor) {
  	      editor.on('init', function (e) {
  	        editor.setContent(HTMLSource);
  	      });
  	  }
  	
  	}) //#${id}`}) `this was inside a template string`
  	
  	// document.getElementById('btnUpdateContent').addEventListener("click", saveContent)
  	
  	function saveContent() {
  	const myContent = tinymce.activeEditor.getContent()
  	pageData.myContent = myContent
  	}

  })(___arguments.context.pageData, (getObjectProperty(___arguments.context.pageData, 'currentDataContent')), '7svncuz1u3xumyc', (getObjectProperty(((function () { return BackendlessUI.getCustomSettings() })()), 'created_jwt_token'))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/employees/components/859df6fc47f553256c989f7c2b88adcc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isOpenModal'))

  },
  /* handler:onDisplayAssignment */
  /* handler:modalVisibilityLogic */
  ['modalVisibilityLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isOpenModal'))

  },
  /* handler:modalVisibilityLogic */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;

  },
  /* handler:onClose */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    var result;


  console.log('Modal: (OnVisibilityChange) Modal Visible | Content Pushed to TinyMCE in the modal__card.OnVisible Event');

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/employees/components/71dd7f53b1157583c11cd04885411f04/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var result;


  result = (await (async function(pageData) {
  	// Create an array by ClassName 'content_editable' and invoke the function (editable) and create an event listener for each index in the array
  	// const runner = { currentDataSource: ""};
  	
  	var loadFromBlock, HTMLSource;
  	loadFromBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource);
  	console.log ('modal__card: OnMounted: The data source has been set to: ' + pageData.currentDataSource);
  	HTMLSource = loadFromBlock[0].innerHTML;
  	// loadFromBlock.currentTarget.getAttribute('data-source')
  	tinymce.activeEditor.setContent(HTMLSource);
  	pageData.currentDataContent = HTMLSource
  })(___arguments.context.pageData));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/home/components/55343ac7f355e5866b258f56b9374e51/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projects-and-services', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home/components/e3dbcfc8260ddb18fbfa650584ebcb7b/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('about', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home/components/9274dbcfe0ee894416a264e55332b426/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('subcontractors', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home/components/c7db3fda439eae33a98479749c1f6cdc/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('employees', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var WebsiteMode, AppBaseURL, AppURL, _localWebPageDataRoot, _webpageObjectID, _webpageSections;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ AN - ON BEFORE PAGE ENTER - EVENT JUST HAPPENED!!! ############################');
  ___arguments.context.pageData['isPageReady'] = false;
  _webpageObjectID = '3B6B2404-C1AA-47E8-B2BB-AD3C6BB91242';
  ___arguments.context.pageData['WebpageObjectID'] = _webpageObjectID;
  _webpageSections = ['headerBlock1', 'headerBlock2', 'heroBlock1', 'heroBlock2', 'landingBlock1', 'landingBlock2', 'landingBlock3', 'landingBlock4', 'footerBlock1', 'footerBlock2'];
  ___arguments.context.pageData['_webpageSections'] = (_webpageSections.length);
  ___arguments.context.pageData['WebpageSections'] = _webpageSections;
  _localWebPageDataRoot = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accoweb.pockethost.io/api/collections/webpages/records?filter=(objectId=\'',_webpageObjectID,'\')'].join('')))).setEncoding('utf8').send()), 'items'))[0];
  ___arguments.context.pageData['WebpageDataRoot'] = _localWebPageDataRoot;
  ___arguments.context.pageData['WebpageData'] = (getObjectProperty(_localWebPageDataRoot, 'PageContent'));
  ___arguments.context.pageData['isPageReady'] = true;
  ___arguments.context.pageData['BETAItemsVisible'] = false;
  AppURL = (await BackendlessUI.Functions.Custom['fn_7c99d93c763398d595b7ff4a51c14f57']());
  AppBaseURL = AppURL.slice(0, 23);
  console.log(String('AppBaseURL = ') + String(AppBaseURL));

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var result2, result, currentDataSource, _currentUser, _storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ A PAGE ENTER JUST HAPPENED!!! ############################');
  _storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
  if (_storedTokenFromCookie != null || _storedTokenFromCookie != 'undefined') {
    _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](_storedTokenFromCookie));
    console.log('### CURRENT USER ###');
    console.log(_currentUser);
    if (_currentUser != false) {
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
      if ((getObjectProperty(___arguments.context.appData, 'currentUser.record.BETAModeEnabled')) == true) {
        ___arguments.context.appData['isBETAEnabled'] = true;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = true;
      } else {
        ___arguments.context.appData['isBETAEnabled'] = false;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = false;
      }
    } else {
      ___arguments.context.appData['CurrentUser'] = null;
    }
  }
  ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['taskBarTop'] = true;
  ___arguments.context.pageData['taskBarBottom'] = false;
  ___arguments.context.pageData['hideButtonsMode'] = true;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onEnter */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onResize */
  /* handler:onPageQuery */
  async ['onPageQuery'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.pageQuery, 'debugMode')) == true && (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'currentUser'))))) {
    ___arguments.context.appData['debugMode'] = true;
  } else {
    ___arguments.context.appData['debugMode'] = false;
  }

  },
  /* handler:onPageQuery */
  /* content */
}))

define('./pages/home/components/f6c3d992d48fe05b791cfba8a2c9ea19/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 1;
  	video.playbackRate = 1;
  	video.play();
  })();

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 0;
  	video.playbackRate = 1;
  	video.pause();
  })();

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/home/components/27b9fd37c4233d555444978939bfe4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/4a16f104bfbce399523c5d8152efe8af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/e49eae259f43d5e4ed34fbed4c1690f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '8D6FAC01-F4F5-466C-8D61-4C6395519121';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home/components/d6338723fe754ea845c18574e1db8e3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'B103EFB3-F65C-4F60-A3A7-0CBBB9F80C08';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home/components/fa5129e49d61d9c6b57287189523e39e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '428FA853-8475-41D5-BEAE-0A758818D0BC';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home/components/26ebd15ce2f2c1d6f9813d1a00a26054/bundle.js', [], () => ({
  /* content */
  /* handler:onAction */
  async ['onAction'](___arguments) {
      await (async function() {
  	window.location.reload()
  })();

  },
  /* handler:onAction */
  /* content */
}))

define('./pages/home/components/54dcab8d080f34d8921bdbb632146cd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();//pageData.currentDataContent;
  	ownerBlock[0].innerHTML = `${sourceContent}`;
  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/c19816bbc89f510c6b0f61af2ce6e8cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/868de2a35dc382de3c1cd8fbad23a403/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  blockObjectID = '4645C476-DE2B-4007-9A54-03BBC0D8B746';
  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
       if ((getObjectProperty(item, 'id')) == blockObjectID) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home/components/4ab52bf14234a3b76ef19002bc343042/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '4087A0EA-27D1-45A5-97A2-9E787C8323E6';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home/components/f84a59cfd95b86ecac0818e2f8369ed1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '5155423A-F695-4B2F-AADB-4D18281D0F89';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home/components/7b1cb0a9932c78bfd8d5b79381e54204/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'A512CA81-3F67-48FE-9F52-1773D57EEC5B';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home/components/8b7ea841affa30d6d4891c06e62e2d89/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogo-mini', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var _currentUser, result2, result, storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.event, 'ctrlKey')) == true && (getObjectProperty(___arguments.event, 'altKey')) == true) {
    ___arguments.context.pageData['hideButtonsMode'] = false;
    storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
    if (storedTokenFromCookie != null || storedTokenFromCookie != '') {
      _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](storedTokenFromCookie));
      if (_currentUser != false) {
        if ((getObjectProperty(_currentUser, 'token')) != '') {
          localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
        }
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
      }
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      ___arguments.context.appData['inAdminMode'] = true;
      ___arguments.context.appData['isLoggedIn'] = true;
      ___arguments.context.pageData['showAdminBar'] = true;
    } else {
      console.log('####### THE COOKIE IS NOT NULL!!! #######');
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
    }
    console.log(___arguments.event);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('####### appData.CurrentUser #######');
  console.log(getObjectProperty(___arguments.context.appData, 'CurrentUser'));
  console.log('####### ISLOGGEDIN: #######');
  console.log(getObjectProperty(___arguments.context.appData, 'isLoggedIn'));
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
    if ((getObjectProperty(___arguments.context.appData, 'CurrentUser')) != false) {
      console.log('####### CHECKING IF USER isWebsiteEditor #######');
      result = (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'CurrentUser'))));
      if (result == true) {
        console.log('####### RETURN FROM isWebsiteEditor FUNCTION #######');
        console.log('isWebsiteEditor = ');
        console.log(result);
        console.log('####### HIDE BUTTONS MODE #######');
        console.log(getObjectProperty(___arguments.context.pageData, 'hideButtonsMode'));
        if ((getObjectProperty(___arguments.context.pageData, 'hideButtonsMode')) == true) {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', true);
        } else {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);
        }
      }
    }
  }

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/home/components/e18a76e42143485dabe50caddb6fdd6f/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogoCell-right', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/home/components/3ea61bdd3ad1e562a5185b8204761226/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();
  	pageData.currentDataContent = sourceContent; // added decodeURIComponent for troubleshooting

  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('admin_Webpages').save( ({ 'objectId': (getObjectProperty(___arguments.context.pageData, 'currentDataSource')),'BlockContent': (encodeURIComponent((getObjectProperty(___arguments.context.pageData, 'currentDataContent')))) }) );

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/home/components/19f2f0dacd13571dc9b931385a463b62/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/home/components/cc3a9886128a333e4fb5d24ca934c255/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  return (['You are logged on as: ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'CurrentUser')), 'record')), 'name')),' | CTRL + ALT Click on your logo to turn edit mode back on again.'].join(''));

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home/components/0b76d57506286594c0a8661497f83bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'C1F6E9F5-7F62-4DEC-87C0-70A43E04649C';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home/components/226882c510580398880a31741218b794/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('careers', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/home/components/ac5384a89159966cc8681bfea27aa946/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('industries', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home/components/f96298252c8b58c3630720c3f3968e33/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var result2, result;

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  result = (await (async function(pageData, HTMLSource, tinydrive_dropbox_app_key, created_jwt_token) {
  	/*
  	
  	// Plugins that we probably will need: mediaembed, export linkchecker?, powerpaste, advtable, editimage, autocorrect, typography, checklist
  	Existing plugins backup: 'tinydrive code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
  	Removed from below: 
  	toolbar_sticky: true,
  	toolbar_mode: 'floating', // Modes: floating, sliding, scrolling, wrap
  	
  	*/
  	
  	const editor = await BackendlessUI.requireModule('https://cdn.tiny.cloud/1/dwt7je7v9gjog7a8oc867xici2xmy80whuw0asnvstr20590/tinymce/8/tinymce.min.js')
  	tinymce.init({ selector: '.TinyMCETextEditor',
  	plugins: 'tinydrive code anchor link charmap codesample emoticons image lists media searchreplace table visualblocks wordcount',
  	toolbar: 'undo redo | blocks fontfamily fontsize | fontsizeselect | forecolor backcolor | bold italic underline strikethrough blockquote | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat | code',
  	font_family_formats: 'Andale Mono="Andale Mono"; Arial=arial; Arial Black="arial black"; Book Antiqua = "book antiqua"; Comic Sans MS="Comic Sans MS"; Courier New=courier new,courier,monospace; Georgia=georgia; Helvetica=helvetica; Impact=impact; Tahoma=tahoma; Terminal=terminal; Times New Roman="times new roman"; Trebuchet MS = "trebuchet ms"; Sans Serif="sans serif"; Segoe UI=segoe ui; Verdana=verdana; Webdings=webdings; Wingdings=wingdings',
  	font_size_formats: "8px 10px 12px 14px 16px 18px 20px 24px 30px 36px 48px 60px 72px 96px",
  	relative_urls : true,
  	remove_script_host : false,
  	document_base_url : 'https://www.accofg.com/',
  	tinydrive_dropbox_app_key: tinydrive_dropbox_app_key,
  	tinydrive_token_provider: (success, failure) => {
  	        success({ token:  created_jwt_token });
  	  },
  	setup: function (editor) {
  	      editor.on('init', function (e) {
  	        editor.setContent(HTMLSource);
  	      });
  	  }
  	
  	}) //#${id}`}) `this was inside a template string`
  	
  	// document.getElementById('btnUpdateContent').addEventListener("click", saveContent)
  	
  	function saveContent() {
  	const myContent = tinymce.activeEditor.getContent()
  	pageData.myContent = myContent
  	}

  })(___arguments.context.pageData, (getObjectProperty(___arguments.context.pageData, 'currentDataContent')), '7svncuz1u3xumyc', (getObjectProperty(((function () { return BackendlessUI.getCustomSettings() })()), 'created_jwt_token'))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/home/components/859df6fc47f553256c989f7c2b88adcc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isOpenModal'))

  },
  /* handler:onDisplayAssignment */
  /* handler:modalVisibilityLogic */
  ['modalVisibilityLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isOpenModal'))

  },
  /* handler:modalVisibilityLogic */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;

  },
  /* handler:onClose */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    var result;


  console.log('Modal: (OnVisibilityChange) Modal Visible | Content Pushed to TinyMCE in the modal__card.OnVisible Event');

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/home/components/71dd7f53b1157583c11cd04885411f04/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var result;


  result = (await (async function(pageData) {
  	// Create an array by ClassName 'content_editable' and invoke the function (editable) and create an event listener for each index in the array
  	// const runner = { currentDataSource: ""};
  	
  	var loadFromBlock, HTMLSource;
  	loadFromBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource);
  	console.log ('modal__card: OnMounted: The data source has been set to: ' + pageData.currentDataSource);
  	HTMLSource = loadFromBlock[0].innerHTML;
  	// loadFromBlock.currentTarget.getAttribute('data-source')
  	tinymce.activeEditor.setContent(HTMLSource);
  	pageData.currentDataContent = HTMLSource
  })(___arguments.context.pageData));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/home-backup_9-17/components/55343ac7f355e5866b258f56b9374e51/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projects-and-services', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-backup_9-17/components/e3dbcfc8260ddb18fbfa650584ebcb7b/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('about', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-backup_9-17/components/9274dbcfe0ee894416a264e55332b426/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('subcontractors', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-backup_9-17/components/c7db3fda439eae33a98479749c1f6cdc/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('employees', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-backup_9-17/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var WebsiteMode, AppBaseURL, AppURL, _localWebPageDataRoot, _webpageObjectID, _webpageSections;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ AN - ON BEFORE PAGE ENTER - EVENT JUST HAPPENED!!! ############################');
  ___arguments.context.pageData['isPageReady'] = false;
  _webpageObjectID = '3B6B2404-C1AA-47E8-B2BB-AD3C6BB91242';
  ___arguments.context.pageData['WebpageObjectID'] = _webpageObjectID;
  _webpageSections = ['headerBlock1', 'headerBlock2', 'heroBlock1', 'heroBlock2', 'landingBlock1', 'landingBlock2', 'landingBlock3', 'landingBlock4', 'footerBlock1', 'footerBlock2'];
  ___arguments.context.pageData['_webpageSections'] = (_webpageSections.length);
  ___arguments.context.pageData['WebpageSections'] = _webpageSections;
  _localWebPageDataRoot = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accoweb.pockethost.io/api/collections/webpages/records?filter=(objectId=\'',_webpageObjectID,'\')'].join('')))).setEncoding('utf8').send()), 'items'))[0];
  ___arguments.context.pageData['WebpageDataRoot'] = _localWebPageDataRoot;
  ___arguments.context.pageData['WebpageData'] = (getObjectProperty(_localWebPageDataRoot, 'PageContent'));
  ___arguments.context.pageData['isPageReady'] = true;
  ___arguments.context.pageData['BETAItemsVisible'] = false;
  AppURL = (await BackendlessUI.Functions.Custom['fn_7c99d93c763398d595b7ff4a51c14f57']());
  AppBaseURL = AppURL.slice(0, 23);
  console.log(String('AppBaseURL = ') + String(AppBaseURL));

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var result2, result, currentDataSource, _currentUser, _storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ A PAGE ENTER JUST HAPPENED!!! ############################');
  _storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
  if (_storedTokenFromCookie != null || _storedTokenFromCookie != 'undefined') {
    _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](_storedTokenFromCookie));
    console.log('### CURRENT USER ###');
    console.log(_currentUser);
    if (_currentUser != false) {
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
      if ((getObjectProperty(___arguments.context.appData, 'currentUser.record.BETAModeEnabled')) == true) {
        ___arguments.context.appData['isBETAEnabled'] = true;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = true;
      } else {
        ___arguments.context.appData['isBETAEnabled'] = false;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = false;
      }
    } else {
      ___arguments.context.appData['CurrentUser'] = null;
    }
  }
  ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['taskBarTop'] = true;
  ___arguments.context.pageData['taskBarBottom'] = false;
  ___arguments.context.pageData['hideButtonsMode'] = true;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onEnter */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onResize */
  /* handler:onPageQuery */
  async ['onPageQuery'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.pageQuery, 'debugMode')) == true && (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'currentUser'))))) {
    ___arguments.context.appData['debugMode'] = true;
  } else {
    ___arguments.context.appData['debugMode'] = false;
  }

  },
  /* handler:onPageQuery */
  /* content */
}))

define('./pages/home-backup_9-17/components/f6c3d992d48fe05b791cfba8a2c9ea19/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 1;
  	video.playbackRate = 1;
  	video.play();
  })();

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 0;
  	video.playbackRate = 1;
  	video.pause();
  })();

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/home-backup_9-17/components/27b9fd37c4233d555444978939bfe4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-backup_9-17/components/4a16f104bfbce399523c5d8152efe8af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-backup_9-17/components/e49eae259f43d5e4ed34fbed4c1690f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '8D6FAC01-F4F5-466C-8D61-4C6395519121';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-backup_9-17/components/d6338723fe754ea845c18574e1db8e3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'B103EFB3-F65C-4F60-A3A7-0CBBB9F80C08';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-backup_9-17/components/fa5129e49d61d9c6b57287189523e39e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '428FA853-8475-41D5-BEAE-0A758818D0BC';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-backup_9-17/components/26ebd15ce2f2c1d6f9813d1a00a26054/bundle.js', [], () => ({
  /* content */
  /* handler:onAction */
  async ['onAction'](___arguments) {
      await (async function() {
  	window.location.reload()
  })();

  },
  /* handler:onAction */
  /* content */
}))

define('./pages/home-backup_9-17/components/54dcab8d080f34d8921bdbb632146cd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();//pageData.currentDataContent;
  	ownerBlock[0].innerHTML = `${sourceContent}`;
  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-backup_9-17/components/c19816bbc89f510c6b0f61af2ce6e8cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-backup_9-17/components/868de2a35dc382de3c1cd8fbad23a403/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  blockObjectID = '4645C476-DE2B-4007-9A54-03BBC0D8B746';
  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
       if ((getObjectProperty(item, 'id')) == blockObjectID) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-backup_9-17/components/4ab52bf14234a3b76ef19002bc343042/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '4087A0EA-27D1-45A5-97A2-9E787C8323E6';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-backup_9-17/components/f84a59cfd95b86ecac0818e2f8369ed1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '5155423A-F695-4B2F-AADB-4D18281D0F89';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-backup_9-17/components/7b1cb0a9932c78bfd8d5b79381e54204/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'A512CA81-3F67-48FE-9F52-1773D57EEC5B';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-backup_9-17/components/8b7ea841affa30d6d4891c06e62e2d89/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogo-mini', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var _currentUser, result2, result, storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.event, 'ctrlKey')) == true && (getObjectProperty(___arguments.event, 'altKey')) == true) {
    ___arguments.context.pageData['hideButtonsMode'] = false;
    storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
    if (storedTokenFromCookie != null || storedTokenFromCookie != '') {
      _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](storedTokenFromCookie));
      if (_currentUser != false) {
        if ((getObjectProperty(_currentUser, 'token')) != '') {
          localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
        }
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
      }
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      ___arguments.context.appData['inAdminMode'] = true;
      ___arguments.context.appData['isLoggedIn'] = true;
      ___arguments.context.pageData['showAdminBar'] = true;
    } else {
      console.log('####### THE COOKIE IS NOT NULL!!! #######');
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
    }
    console.log(___arguments.event);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('####### appData.CurrentUser #######');
  console.log(getObjectProperty(___arguments.context.appData, 'CurrentUser'));
  console.log('####### ISLOGGEDIN: #######');
  console.log(getObjectProperty(___arguments.context.appData, 'isLoggedIn'));
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
    if ((getObjectProperty(___arguments.context.appData, 'CurrentUser')) != false) {
      console.log('####### CHECKING IF USER isWebsiteEditor #######');
      result = (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'CurrentUser'))));
      if (result == true) {
        console.log('####### RETURN FROM isWebsiteEditor FUNCTION #######');
        console.log('isWebsiteEditor = ');
        console.log(result);
        console.log('####### HIDE BUTTONS MODE #######');
        console.log(getObjectProperty(___arguments.context.pageData, 'hideButtonsMode'));
        if ((getObjectProperty(___arguments.context.pageData, 'hideButtonsMode')) == true) {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', true);
        } else {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);
        }
      }
    }
  }

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/home-backup_9-17/components/e18a76e42143485dabe50caddb6fdd6f/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogoCell-right', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/home-backup_9-17/components/3ea61bdd3ad1e562a5185b8204761226/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();
  	pageData.currentDataContent = sourceContent; // added decodeURIComponent for troubleshooting

  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('admin_Webpages').save( ({ 'objectId': (getObjectProperty(___arguments.context.pageData, 'currentDataSource')),'BlockContent': (encodeURIComponent((getObjectProperty(___arguments.context.pageData, 'currentDataContent')))) }) );

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/home-backup_9-17/components/19f2f0dacd13571dc9b931385a463b62/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/home-backup_9-17/components/cc3a9886128a333e4fb5d24ca934c255/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  return (['You are logged on as: ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'CurrentUser')), 'record')), 'name')),' | CTRL + ALT Click on your logo to turn edit mode back on again.'].join(''));

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-backup_9-17/components/0b76d57506286594c0a8661497f83bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'C1F6E9F5-7F62-4DEC-87C0-70A43E04649C';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-backup_9-17/components/226882c510580398880a31741218b794/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('careers', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/home-backup_9-17/components/ac5384a89159966cc8681bfea27aa946/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('industries', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-backup_9-17/components/f96298252c8b58c3630720c3f3968e33/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var result2, result;

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  result = (await (async function(pageData, HTMLSource) {
  	/*
  	
  	// Plugins that we probably will need: mediaembed, export linkchecker?, powerpaste, advtable, editimage, autocorrect, typography, checklist
  	Existing plugins backup: 'tinydrive code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
  	Removed from below: 
  	toolbar_sticky: true,
  	toolbar_mode: 'floating', // Modes: floating, sliding, scrolling, wrap
  	
  	*/
  	
  	const editor = await BackendlessUI.requireModule('https://cdn.tiny.cloud/1/dwt7je7v9gjog7a8oc867xici2xmy80whuw0asnvstr20590/tinymce/8/tinymce.min.js')
  	tinymce.init({ selector: '.TinyMCETextEditor',
  	plugins: 'tinydrive code anchor link charmap codesample emoticons image lists media searchreplace table visualblocks wordcount',
  	toolbar: 'undo redo | blocks fontfamily fontsize | fontsizeselect | forecolor backcolor | bold italic underline strikethrough blockquote | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat | code',
  	font_family_formats: 'Andale Mono="Andale Mono"; Arial=arial; Arial Black="arial black"; Book Antiqua = "book antiqua"; Comic Sans MS="Comic Sans MS"; Courier New=courier new,courier,monospace; Georgia=georgia; Helvetica=helvetica; Impact=impact; Tahoma=tahoma; Terminal=terminal; Times New Roman="times new roman"; Trebuchet MS = "trebuchet ms"; Sans Serif="sans serif"; Segoe UI=segoe ui; Verdana=verdana; Webdings=webdings; Wingdings=wingdings',
  	font_size_formats: "8px 10px 12px 14px 16px 18px 20px 24px 30px 36px 48px 60px 72px 96px",
  	relative_urls : true,
  	remove_script_host : false,
  	document_base_url : 'https://www.accofg.com/',
  	tinydrive_dropbox_app_key: 'zf8ghuzc8e0s3ad',
  	setup: function (editor) {
  	      editor.on('init', function (e) {
  	        editor.setContent(HTMLSource);
  	      });
  	    }
  	
  	}) //#${id}`}) `this was inside a template string`
  	
  	// document.getElementById('btnUpdateContent').addEventListener("click", saveContent)
  	
  	function saveContent() {
  	const myContent = tinymce.activeEditor.getContent()
  	pageData.myContent = myContent
  	}

  })(___arguments.context.pageData, (getObjectProperty(___arguments.context.pageData, 'currentDataContent'))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/home-backup_9-17/components/859df6fc47f553256c989f7c2b88adcc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isOpenModal'))

  },
  /* handler:onDisplayAssignment */
  /* handler:modalVisibilityLogic */
  ['modalVisibilityLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isOpenModal'))

  },
  /* handler:modalVisibilityLogic */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;

  },
  /* handler:onClose */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    var result;


  console.log('Modal: (OnVisibilityChange) Modal Visible | Content Pushed to TinyMCE in the modal__card.OnVisible Event');

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/home-backup_9-17/components/71dd7f53b1157583c11cd04885411f04/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var result;


  result = (await (async function(pageData) {
  	// Create an array by ClassName 'content_editable' and invoke the function (editable) and create an event listener for each index in the array
  	// const runner = { currentDataSource: ""};
  	
  	var loadFromBlock, HTMLSource;
  	loadFromBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource);
  	console.log ('modal__card: OnMounted: The data source has been set to: ' + pageData.currentDataSource);
  	HTMLSource = loadFromBlock[0].innerHTML;
  	// loadFromBlock.currentTarget.getAttribute('data-source')
  	tinymce.activeEditor.setContent(HTMLSource);
  	pageData.currentDataContent = HTMLSource
  })(___arguments.context.pageData));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/home-drawer/components/55343ac7f355e5866b258f56b9374e51/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projects-and-services', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-drawer/components/e3dbcfc8260ddb18fbfa650584ebcb7b/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('about', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-drawer/components/9274dbcfe0ee894416a264e55332b426/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('subcontractors', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-drawer/components/c7db3fda439eae33a98479749c1f6cdc/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('employees', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-drawer/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var WebsiteMode, AppBaseURL, AppURL, _localWebPageDataRoot, _webpageObjectID, _webpageSections;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function unused() {
}


  console.log('############################ AN - ON BEFORE PAGE ENTER - EVENT JUST HAPPENED!!! ############################');
  ___arguments.context.pageData['isPageReady'] = false;
  _webpageObjectID = '3B6B2404-C1AA-47E8-B2BB-AD3C6BB91242';
  ___arguments.context.pageData['WebpageObjectID'] = _webpageObjectID;
  _webpageSections = ['headerBlock1', 'headerBlock2', 'heroBlock1', 'heroBlock2', 'landingBlock1', 'landingBlock2', 'landingBlock3', 'landingBlock4', 'footerBlock1', 'footerBlock2'];
  ___arguments.context.pageData['_webpageSections'] = (_webpageSections.length);
  ___arguments.context.pageData['WebpageSections'] = _webpageSections;
  _localWebPageDataRoot = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accoweb.pockethost.io/api/collections/webpages/records?filter=(objectId=\'',_webpageObjectID,'\')'].join('')))).setEncoding('utf8').send()), 'items'))[0];
  ___arguments.context.pageData['WebpageDataRoot'] = _localWebPageDataRoot;
  ___arguments.context.pageData['WebpageData'] = (getObjectProperty(_localWebPageDataRoot, 'PageContent'));
  ___arguments.context.pageData['isPageReady'] = true;
  ___arguments.context.pageData['BETAItemsVisible'] = false;
  AppURL = (await BackendlessUI.Functions.Custom['fn_7c99d93c763398d595b7ff4a51c14f57']());
  AppBaseURL = AppURL.slice(0, 23);
  console.log(String('AppBaseURL = ') + String(AppBaseURL));

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var result2, result, currentDataSource, _currentUser, _storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ A PAGE ENTER JUST HAPPENED!!! ############################');
  _storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
  if (_storedTokenFromCookie != null || _storedTokenFromCookie != 'undefined') {
    _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](_storedTokenFromCookie));
    console.log('### CURRENT USER ###');
    console.log(_currentUser);
    if (_currentUser != false) {
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
      if ((getObjectProperty(___arguments.context.appData, 'currentUser.record.BETAModeEnabled')) == true) {
        ___arguments.context.appData['isBETAEnabled'] = true;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = true;
      } else {
        ___arguments.context.appData['isBETAEnabled'] = false;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = false;
      }
    } else {
      ___arguments.context.appData['CurrentUser'] = null;
    }
  }
  ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['taskBarTop'] = true;
  ___arguments.context.pageData['taskBarBottom'] = false;
  ___arguments.context.pageData['hideButtonsMode'] = true;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onEnter */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onResize */
  /* handler:onPageQuery */
  async ['onPageQuery'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.pageQuery, 'debugMode')) == true && (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'currentUser'))))) {
    ___arguments.context.appData['debugMode'] = true;
  } else {
    ___arguments.context.appData['debugMode'] = false;
  }

  },
  /* handler:onPageQuery */
  /* content */
}))

define('./pages/home-drawer/components/f6c3d992d48fe05b791cfba8a2c9ea19/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 1;
  	video.playbackRate = 1;
  	video.play();
  })();

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 0;
  	video.playbackRate = 1;
  	video.pause();
  })();

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/home-drawer/components/27b9fd37c4233d555444978939bfe4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-drawer/components/717adc521cbdf7ca7f3db4188da3a5c7/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classesList = ['modal'];
  if (getObjectProperty(___arguments.context.pageData, 'isOpenModal')) {
    addItemToList(classesList, 'open');
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'blockMouseOverEvent')) != true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('717adc521cbdf7ca7f3db4188da3a5c7', true);
    ___arguments.context.pageData['blockMouseOverEvent'] = true;
  }

  },
  /* handler:onMouseOver */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var result;


  result = (await (async function(pageData) {
  	// Create an array by ClassName 'content_editable' and invoke the function (editable) and create an event listener for each index in the array
  	// const runner = { currentDataSource: ""};
  	
  	var loadFromBlock, HTMLSource;
  	loadFromBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource);
  	console.log ('The data source has been set to: ' + pageData.currentDataSource);
  	HTMLSource = loadFromBlock[0].innerHTML;
  	// loadFromBlock.currentTarget.getAttribute('data-source')
  	tinymce.activeEditor.setContent(HTMLSource);
  	pageData.currentDataContent = HTMLSource
  })(___arguments.context.pageData));

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/home-drawer/components/8cd91f8f8d38899143393ed8c8129c7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-drawer/components/e49eae259f43d5e4ed34fbed4c1690f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '8D6FAC01-F4F5-466C-8D61-4C6395519121';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-drawer/components/d6338723fe754ea845c18574e1db8e3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'B103EFB3-F65C-4F60-A3A7-0CBBB9F80C08';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-drawer/components/fa5129e49d61d9c6b57287189523e39e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '428FA853-8475-41D5-BEAE-0A758818D0BC';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-drawer/components/26ebd15ce2f2c1d6f9813d1a00a26054/bundle.js', [], () => ({
  /* content */
  /* handler:onAction */
  async ['onAction'](___arguments) {
      await (async function() {
  	window.location.reload()
  })();

  },
  /* handler:onAction */
  /* content */
}))

define('./pages/home-drawer/components/868de2a35dc382de3c1cd8fbad23a403/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  blockObjectID = '4645C476-DE2B-4007-9A54-03BBC0D8B746';
  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
       if ((getObjectProperty(item, 'id')) == blockObjectID) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-drawer/components/4ab52bf14234a3b76ef19002bc343042/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '4087A0EA-27D1-45A5-97A2-9E787C8323E6';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-drawer/components/f84a59cfd95b86ecac0818e2f8369ed1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '5155423A-F695-4B2F-AADB-4D18281D0F89';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-drawer/components/7b1cb0a9932c78bfd8d5b79381e54204/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'A512CA81-3F67-48FE-9F52-1773D57EEC5B';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-drawer/components/8b7ea841affa30d6d4891c06e62e2d89/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogo-mini', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var _currentUser, result2, result, storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.event, 'ctrlKey')) == true && (getObjectProperty(___arguments.event, 'altKey')) == true) {
    ___arguments.context.pageData['hideButtonsMode'] = false;
    storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
    if (storedTokenFromCookie != null || storedTokenFromCookie != '') {
      _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](storedTokenFromCookie));
      if (_currentUser != false) {
        if ((getObjectProperty(_currentUser, 'token')) != '') {
          localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
        }
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
      }
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      ___arguments.context.appData['inAdminMode'] = true;
      ___arguments.context.appData['isLoggedIn'] = true;
      ___arguments.context.pageData['showAdminBar'] = true;
    } else {
      console.log('####### THE COOKIE IS NOT NULL!!! #######');
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
    }
    console.log(___arguments.event);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('####### appData.CurrentUser #######');
  console.log(getObjectProperty(___arguments.context.appData, 'CurrentUser'));
  console.log('####### ISLOGGEDIN: #######');
  console.log(getObjectProperty(___arguments.context.appData, 'isLoggedIn'));
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
    if ((getObjectProperty(___arguments.context.appData, 'CurrentUser')) != false) {
      console.log('####### CHECKING IF USER isWebsiteEditor #######');
      result = (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'CurrentUser'))));
      if (result == true) {
        console.log('####### RETURN FROM isWebsiteEditor FUNCTION #######');
        console.log('isWebsiteEditor = ');
        console.log(result);
        console.log('####### HIDE BUTTONS MODE #######');
        console.log(getObjectProperty(___arguments.context.pageData, 'hideButtonsMode'));
        if ((getObjectProperty(___arguments.context.pageData, 'hideButtonsMode')) == true) {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', true);
        } else {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);
        }
      }
    }
  }

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/home-drawer/components/e18a76e42143485dabe50caddb6fdd6f/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogoCell-right', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/home-drawer/components/19f2f0dacd13571dc9b931385a463b62/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/home-drawer/components/cc3a9886128a333e4fb5d24ca934c255/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  return (['You are logged on as: ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'CurrentUser')), 'record')), 'name')),' | CTRL + ALT Click on your logo to turn edit mode back on again.'].join(''));

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-drawer/components/0b76d57506286594c0a8661497f83bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'C1F6E9F5-7F62-4DEC-87C0-70A43E04649C';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-drawer/components/226882c510580398880a31741218b794/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('careers', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/home-drawer/components/ac5384a89159966cc8681bfea27aa946/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('industries', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-drawer-quill/components/55343ac7f355e5866b258f56b9374e51/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projects-and-services', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-drawer-quill/components/e3dbcfc8260ddb18fbfa650584ebcb7b/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('about', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-drawer-quill/components/9274dbcfe0ee894416a264e55332b426/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('subcontractors', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-drawer-quill/components/c7db3fda439eae33a98479749c1f6cdc/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('employees', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-drawer-quill/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var WebsiteMode, AppBaseURL, AppURL, _localWebPageDataRoot, _webpageObjectID, _webpageSections;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function unused() {
}


  console.log('############################ AN - ON BEFORE PAGE ENTER - EVENT JUST HAPPENED!!! ############################');
  ___arguments.context.pageData['isPageReady'] = false;
  _webpageObjectID = '3B6B2404-C1AA-47E8-B2BB-AD3C6BB91242';
  ___arguments.context.pageData['WebpageObjectID'] = _webpageObjectID;
  _webpageSections = ['headerBlock1', 'headerBlock2', 'heroBlock1', 'heroBlock2', 'landingBlock1', 'landingBlock2', 'landingBlock3', 'landingBlock4', 'footerBlock1', 'footerBlock2'];
  ___arguments.context.pageData['_webpageSections'] = (_webpageSections.length);
  ___arguments.context.pageData['WebpageSections'] = _webpageSections;
  _localWebPageDataRoot = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accoweb.pockethost.io/api/collections/webpages/records?filter=(objectId=\'',_webpageObjectID,'\')'].join('')))).setEncoding('utf8').send()), 'items'))[0];
  ___arguments.context.pageData['WebpageDataRoot'] = _localWebPageDataRoot;
  ___arguments.context.pageData['WebpageData'] = (getObjectProperty(_localWebPageDataRoot, 'PageContent'));
  ___arguments.context.pageData['isPageReady'] = true;
  ___arguments.context.pageData['BETAItemsVisible'] = false;
  AppURL = (await BackendlessUI.Functions.Custom['fn_7c99d93c763398d595b7ff4a51c14f57']());
  AppBaseURL = AppURL.slice(0, 23);
  console.log(String('AppBaseURL = ') + String(AppBaseURL));

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var result2, result, currentDataSource, _currentUser, _storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ A PAGE ENTER JUST HAPPENED!!! ############################');
  _storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
  if (_storedTokenFromCookie != null || _storedTokenFromCookie != 'undefined') {
    _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](_storedTokenFromCookie));
    console.log('### CURRENT USER ###');
    console.log(_currentUser);
    if (_currentUser != false) {
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
      if ((getObjectProperty(___arguments.context.appData, 'currentUser.record.BETAModeEnabled')) == true) {
        ___arguments.context.appData['isBETAEnabled'] = true;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = true;
      } else {
        ___arguments.context.appData['isBETAEnabled'] = false;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = false;
      }
    } else {
      ___arguments.context.appData['CurrentUser'] = null;
    }
  }
  ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['taskBarTop'] = true;
  ___arguments.context.pageData['taskBarBottom'] = false;
  ___arguments.context.pageData['hideButtonsMode'] = true;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onEnter */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onResize */
  /* handler:onPageQuery */
  async ['onPageQuery'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.pageQuery, 'debugMode')) == true && (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'currentUser'))))) {
    ___arguments.context.appData['debugMode'] = true;
  } else {
    ___arguments.context.appData['debugMode'] = false;
  }

  },
  /* handler:onPageQuery */
  /* content */
}))

define('./pages/home-drawer-quill/components/f6c3d992d48fe05b791cfba8a2c9ea19/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 1;
  	video.playbackRate = 1;
  	video.play();
  })();

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 0;
  	video.playbackRate = 1;
  	video.pause();
  })();

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/home-drawer-quill/components/27b9fd37c4233d555444978939bfe4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-drawer-quill/components/717adc521cbdf7ca7f3db4188da3a5c7/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classesList = ['modal'];
  if (getObjectProperty(___arguments.context.pageData, 'isOpenModal')) {
    addItemToList(classesList, 'open');
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'blockMouseOverEvent')) != true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('717adc521cbdf7ca7f3db4188da3a5c7', true);
    ___arguments.context.pageData['blockMouseOverEvent'] = true;
  }

  },
  /* handler:onMouseOver */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var result;


  result = (await (async function(pageData) {
  	// Create an array by ClassName 'content_editable' and invoke the function (editable) and create an event listener for each index in the array
  	// const runner = { currentDataSource: ""};
  	
  	var loadFromBlock, HTMLSource;
  	loadFromBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource);
  	console.log ('The data source has been set to: ' + pageData.currentDataSource);
  	HTMLSource = loadFromBlock[0].innerHTML;
  	// loadFromBlock.currentTarget.getAttribute('data-source')
  	tinymce.activeEditor.setContent(HTMLSource);
  	pageData.currentDataContent = HTMLSource
  })(___arguments.context.pageData));

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/home-drawer-quill/components/8cd91f8f8d38899143393ed8c8129c7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-drawer-quill/components/e49eae259f43d5e4ed34fbed4c1690f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '8D6FAC01-F4F5-466C-8D61-4C6395519121';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-drawer-quill/components/d6338723fe754ea845c18574e1db8e3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'B103EFB3-F65C-4F60-A3A7-0CBBB9F80C08';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-drawer-quill/components/fa5129e49d61d9c6b57287189523e39e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '428FA853-8475-41D5-BEAE-0A758818D0BC';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-drawer-quill/components/26ebd15ce2f2c1d6f9813d1a00a26054/bundle.js', [], () => ({
  /* content */
  /* handler:onAction */
  async ['onAction'](___arguments) {
      await (async function() {
  	window.location.reload()
  })();

  },
  /* handler:onAction */
  /* content */
}))

define('./pages/home-drawer-quill/components/868de2a35dc382de3c1cd8fbad23a403/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  blockObjectID = '4645C476-DE2B-4007-9A54-03BBC0D8B746';
  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
       if ((getObjectProperty(item, 'id')) == blockObjectID) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-drawer-quill/components/4ab52bf14234a3b76ef19002bc343042/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '4087A0EA-27D1-45A5-97A2-9E787C8323E6';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-drawer-quill/components/f84a59cfd95b86ecac0818e2f8369ed1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '5155423A-F695-4B2F-AADB-4D18281D0F89';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-drawer-quill/components/7b1cb0a9932c78bfd8d5b79381e54204/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'A512CA81-3F67-48FE-9F52-1773D57EEC5B';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-drawer-quill/components/8b7ea841affa30d6d4891c06e62e2d89/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogo-mini', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var _currentUser, result2, result, storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.event, 'ctrlKey')) == true && (getObjectProperty(___arguments.event, 'altKey')) == true) {
    ___arguments.context.pageData['hideButtonsMode'] = false;
    storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
    if (storedTokenFromCookie != null || storedTokenFromCookie != '') {
      _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](storedTokenFromCookie));
      if (_currentUser != false) {
        if ((getObjectProperty(_currentUser, 'token')) != '') {
          localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
        }
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
      }
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      ___arguments.context.appData['inAdminMode'] = true;
      ___arguments.context.appData['isLoggedIn'] = true;
      ___arguments.context.pageData['showAdminBar'] = true;
    } else {
      console.log('####### THE COOKIE IS NOT NULL!!! #######');
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
    }
    console.log(___arguments.event);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('####### appData.CurrentUser #######');
  console.log(getObjectProperty(___arguments.context.appData, 'CurrentUser'));
  console.log('####### ISLOGGEDIN: #######');
  console.log(getObjectProperty(___arguments.context.appData, 'isLoggedIn'));
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
    if ((getObjectProperty(___arguments.context.appData, 'CurrentUser')) != false) {
      console.log('####### CHECKING IF USER isWebsiteEditor #######');
      result = (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'CurrentUser'))));
      if (result == true) {
        console.log('####### RETURN FROM isWebsiteEditor FUNCTION #######');
        console.log('isWebsiteEditor = ');
        console.log(result);
        console.log('####### HIDE BUTTONS MODE #######');
        console.log(getObjectProperty(___arguments.context.pageData, 'hideButtonsMode'));
        if ((getObjectProperty(___arguments.context.pageData, 'hideButtonsMode')) == true) {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', true);
        } else {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);
        }
      }
    }
  }

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/home-drawer-quill/components/e18a76e42143485dabe50caddb6fdd6f/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogoCell-right', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/home-drawer-quill/components/19f2f0dacd13571dc9b931385a463b62/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/home-drawer-quill/components/cc3a9886128a333e4fb5d24ca934c255/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  return (['You are logged on as: ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'CurrentUser')), 'record')), 'name')),' | CTRL + ALT Click on your logo to turn edit mode back on again.'].join(''));

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-drawer-quill/components/0b76d57506286594c0a8661497f83bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'C1F6E9F5-7F62-4DEC-87C0-70A43E04649C';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-drawer-quill/components/226882c510580398880a31741218b794/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('careers', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/home-drawer-quill/components/ac5384a89159966cc8681bfea27aa946/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('industries', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/55343ac7f355e5866b258f56b9374e51/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projects-and-services', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/e3dbcfc8260ddb18fbfa650584ebcb7b/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('about', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/9274dbcfe0ee894416a264e55332b426/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('subcontractors', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/c7db3fda439eae33a98479749c1f6cdc/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('employees', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var WebsiteMode, AppBaseURL, AppURL, _localWebPageDataRoot, _webpageObjectID, _webpageSections;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ AN - ON BEFORE PAGE ENTER - EVENT JUST HAPPENED!!! ############################');
  ___arguments.context.pageData['isPageReady'] = false;
  _webpageObjectID = '3B6B2404-C1AA-47E8-B2BB-AD3C6BB91242';
  ___arguments.context.pageData['WebpageObjectID'] = _webpageObjectID;
  _webpageSections = ['headerBlock1', 'headerBlock2', 'heroBlock1', 'heroBlock2', 'landingBlock1', 'landingBlock2', 'landingBlock3', 'landingBlock4', 'footerBlock1', 'footerBlock2'];
  ___arguments.context.pageData['_webpageSections'] = (_webpageSections.length);
  ___arguments.context.pageData['WebpageSections'] = _webpageSections;
  _localWebPageDataRoot = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accoweb.pockethost.io/api/collections/webpages/records?filter=(objectId=\'',_webpageObjectID,'\')'].join('')))).setEncoding('utf8').send()), 'items'))[0];
  ___arguments.context.pageData['WebpageDataRoot'] = _localWebPageDataRoot;
  ___arguments.context.pageData['WebpageData'] = (getObjectProperty(_localWebPageDataRoot, 'PageContent'));
  ___arguments.context.pageData['isPageReady'] = true;
  ___arguments.context.pageData['BETAItemsVisible'] = false;
  AppURL = (await BackendlessUI.Functions.Custom['fn_7c99d93c763398d595b7ff4a51c14f57']());
  AppBaseURL = AppURL.slice(0, 23);
  console.log(String('AppBaseURL = ') + String(AppBaseURL));

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var result2, result, currentDataSource, _currentUser, _storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ A PAGE ENTER JUST HAPPENED!!! ############################');
  _storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
  if (_storedTokenFromCookie != null || _storedTokenFromCookie != 'undefined') {
    _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](_storedTokenFromCookie));
    console.log('### CURRENT USER ###');
    console.log(_currentUser);
    if (_currentUser != false) {
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
      if ((getObjectProperty(___arguments.context.appData, 'currentUser.record.BETAModeEnabled')) == true) {
        ___arguments.context.appData['isBETAEnabled'] = true;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = true;
      } else {
        ___arguments.context.appData['isBETAEnabled'] = false;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = false;
      }
    } else {
      ___arguments.context.appData['CurrentUser'] = null;
    }
  }
  ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['taskBarTop'] = true;
  ___arguments.context.pageData['taskBarBottom'] = false;
  ___arguments.context.pageData['hideButtonsMode'] = true;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onEnter */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onResize */
  /* handler:onPageQuery */
  async ['onPageQuery'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.pageQuery, 'debugMode')) == true && (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'currentUser'))))) {
    ___arguments.context.appData['debugMode'] = true;
  } else {
    ___arguments.context.appData['debugMode'] = false;
  }

  },
  /* handler:onPageQuery */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/f6c3d992d48fe05b791cfba8a2c9ea19/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 1;
  	video.playbackRate = 1;
  	video.play();
  })();

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 0;
  	video.playbackRate = 1;
  	video.pause();
  })();

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/27b9fd37c4233d555444978939bfe4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/717adc521cbdf7ca7f3db4188da3a5c7/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classesList = ['modal'];
  if (getObjectProperty(___arguments.context.pageData, 'isOpenModal')) {
    addItemToList(classesList, 'open');
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'blockMouseOverEvent')) != true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('717adc521cbdf7ca7f3db4188da3a5c7', true);
    ___arguments.context.pageData['blockMouseOverEvent'] = true;
  }

  },
  /* handler:onMouseOver */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var result;


  if (___arguments.newValue) {
    result = (await (async function(pageData) {
    	// Create an array by ClassName 'content_editable' and invoke the function (editable) and create an event listener for each index in the array
    	// const runner = { currentDataSource: ""};
    	
    	var loadFromBlock, HTMLSource;
    	loadFromBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource);
    	console.log ('The data source has been set to: ' + pageData.currentDataSource);
    	HTMLSource = loadFromBlock[0].innerHTML;
    	// loadFromBlock.currentTarget.getAttribute('data-source')
    	tinymce.activeEditor.setContent(HTMLSource);
    	pageData.currentDataContent = HTMLSource
    })(___arguments.context.pageData));
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/8cd91f8f8d38899143393ed8c8129c7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/4a16f104bfbce399523c5d8152efe8af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/e49eae259f43d5e4ed34fbed4c1690f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '8D6FAC01-F4F5-466C-8D61-4C6395519121';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/d6338723fe754ea845c18574e1db8e3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'B103EFB3-F65C-4F60-A3A7-0CBBB9F80C08';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/fa5129e49d61d9c6b57287189523e39e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '428FA853-8475-41D5-BEAE-0A758818D0BC';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/26ebd15ce2f2c1d6f9813d1a00a26054/bundle.js', [], () => ({
  /* content */
  /* handler:onAction */
  async ['onAction'](___arguments) {
      await (async function() {
  	window.location.reload()
  })();

  },
  /* handler:onAction */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/54dcab8d080f34d8921bdbb632146cd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();//pageData.currentDataContent;
  	ownerBlock[0].innerHTML = `${sourceContent}`;
  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/c19816bbc89f510c6b0f61af2ce6e8cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/868de2a35dc382de3c1cd8fbad23a403/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  blockObjectID = '4645C476-DE2B-4007-9A54-03BBC0D8B746';
  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
       if ((getObjectProperty(item, 'id')) == blockObjectID) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/4ab52bf14234a3b76ef19002bc343042/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '4087A0EA-27D1-45A5-97A2-9E787C8323E6';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/f84a59cfd95b86ecac0818e2f8369ed1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '5155423A-F695-4B2F-AADB-4D18281D0F89';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/7b1cb0a9932c78bfd8d5b79381e54204/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'A512CA81-3F67-48FE-9F52-1773D57EEC5B';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/8b7ea841affa30d6d4891c06e62e2d89/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogo-mini', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var _currentUser, result2, result, storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.event, 'ctrlKey')) == true && (getObjectProperty(___arguments.event, 'altKey')) == true) {
    ___arguments.context.pageData['hideButtonsMode'] = false;
    storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
    if (storedTokenFromCookie != null || storedTokenFromCookie != '') {
      _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](storedTokenFromCookie));
      if (_currentUser != false) {
        if ((getObjectProperty(_currentUser, 'token')) != '') {
          localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
        }
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
      }
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      ___arguments.context.appData['inAdminMode'] = true;
      ___arguments.context.appData['isLoggedIn'] = true;
      ___arguments.context.pageData['showAdminBar'] = true;
    } else {
      console.log('####### THE COOKIE IS NOT NULL!!! #######');
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
    }
    console.log(___arguments.event);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('####### appData.CurrentUser #######');
  console.log(getObjectProperty(___arguments.context.appData, 'CurrentUser'));
  console.log('####### ISLOGGEDIN: #######');
  console.log(getObjectProperty(___arguments.context.appData, 'isLoggedIn'));
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
    if ((getObjectProperty(___arguments.context.appData, 'CurrentUser')) != false) {
      console.log('####### CHECKING IF USER isWebsiteEditor #######');
      result = (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'CurrentUser'))));
      if (result == true) {
        console.log('####### RETURN FROM isWebsiteEditor FUNCTION #######');
        console.log('isWebsiteEditor = ');
        console.log(result);
        console.log('####### HIDE BUTTONS MODE #######');
        console.log(getObjectProperty(___arguments.context.pageData, 'hideButtonsMode'));
        if ((getObjectProperty(___arguments.context.pageData, 'hideButtonsMode')) == true) {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', true);
        } else {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);
        }
      }
    }
  }

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/e18a76e42143485dabe50caddb6fdd6f/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogoCell-right', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/3ea61bdd3ad1e562a5185b8204761226/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();
  	pageData.currentDataContent = sourceContent; // added decodeURIComponent for troubleshooting

  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('admin_Webpages').save( ({ 'objectId': (getObjectProperty(___arguments.context.pageData, 'currentDataSource')),'BlockContent': (encodeURIComponent((getObjectProperty(___arguments.context.pageData, 'currentDataContent')))) }) );

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/19f2f0dacd13571dc9b931385a463b62/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/cc3a9886128a333e4fb5d24ca934c255/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  return (['You are logged on as: ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'CurrentUser')), 'record')), 'name')),' | CTRL + ALT Click on your logo to turn edit mode back on again.'].join(''));

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/0b76d57506286594c0a8661497f83bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'C1F6E9F5-7F62-4DEC-87C0-70A43E04649C';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/226882c510580398880a31741218b794/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('careers', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/home-old-tinyMCE/components/ac5384a89159966cc8681bfea27aa946/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('industries', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-previous_9-17/components/55343ac7f355e5866b258f56b9374e51/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projects-and-services', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-previous_9-17/components/e3dbcfc8260ddb18fbfa650584ebcb7b/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('about', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-previous_9-17/components/9274dbcfe0ee894416a264e55332b426/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('subcontractors', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-previous_9-17/components/c7db3fda439eae33a98479749c1f6cdc/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('employees', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-previous_9-17/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var WebsiteMode, AppBaseURL, AppURL, _localWebPageDataRoot, _webpageObjectID, _webpageSections;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ AN - ON BEFORE PAGE ENTER - EVENT JUST HAPPENED!!! ############################');
  ___arguments.context.pageData['isPageReady'] = false;
  _webpageObjectID = '3B6B2404-C1AA-47E8-B2BB-AD3C6BB91242';
  ___arguments.context.pageData['WebpageObjectID'] = _webpageObjectID;
  _webpageSections = ['headerBlock1', 'headerBlock2', 'heroBlock1', 'heroBlock2', 'landingBlock1', 'landingBlock2', 'landingBlock3', 'landingBlock4', 'footerBlock1', 'footerBlock2'];
  ___arguments.context.pageData['_webpageSections'] = (_webpageSections.length);
  ___arguments.context.pageData['WebpageSections'] = _webpageSections;
  _localWebPageDataRoot = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accoweb.pockethost.io/api/collections/webpages/records?filter=(objectId=\'',_webpageObjectID,'\')'].join('')))).setEncoding('utf8').send()), 'items'))[0];
  ___arguments.context.pageData['WebpageDataRoot'] = _localWebPageDataRoot;
  ___arguments.context.pageData['WebpageData'] = (getObjectProperty(_localWebPageDataRoot, 'PageContent'));
  ___arguments.context.pageData['isPageReady'] = true;
  ___arguments.context.pageData['BETAItemsVisible'] = false;
  AppURL = (await BackendlessUI.Functions.Custom['fn_7c99d93c763398d595b7ff4a51c14f57']());
  AppBaseURL = AppURL.slice(0, 23);
  console.log(String('AppBaseURL = ') + String(AppBaseURL));

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var result2, result, currentDataSource, _currentUser, _storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ A PAGE ENTER JUST HAPPENED!!! ############################');
  _storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
  if (_storedTokenFromCookie != null || _storedTokenFromCookie != 'undefined') {
    _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](_storedTokenFromCookie));
    console.log('### CURRENT USER ###');
    console.log(_currentUser);
    if (_currentUser != false) {
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
      if ((getObjectProperty(___arguments.context.appData, 'currentUser.record.BETAModeEnabled')) == true) {
        ___arguments.context.appData['isBETAEnabled'] = true;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = true;
      } else {
        ___arguments.context.appData['isBETAEnabled'] = false;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = false;
      }
    } else {
      ___arguments.context.appData['CurrentUser'] = null;
    }
  }
  ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['taskBarTop'] = true;
  ___arguments.context.pageData['taskBarBottom'] = false;
  ___arguments.context.pageData['hideButtonsMode'] = true;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onEnter */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onResize */
  /* handler:onPageQuery */
  async ['onPageQuery'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.pageQuery, 'debugMode')) == true && (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'currentUser'))))) {
    ___arguments.context.appData['debugMode'] = true;
  } else {
    ___arguments.context.appData['debugMode'] = false;
  }

  },
  /* handler:onPageQuery */
  /* content */
}))

define('./pages/home-previous_9-17/components/f6c3d992d48fe05b791cfba8a2c9ea19/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 1;
  	video.playbackRate = 1;
  	video.play();
  })();

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 0;
  	video.playbackRate = 1;
  	video.pause();
  })();

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/home-previous_9-17/components/27b9fd37c4233d555444978939bfe4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-previous_9-17/components/4a16f104bfbce399523c5d8152efe8af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-previous_9-17/components/e49eae259f43d5e4ed34fbed4c1690f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '8D6FAC01-F4F5-466C-8D61-4C6395519121';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-previous_9-17/components/d6338723fe754ea845c18574e1db8e3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'B103EFB3-F65C-4F60-A3A7-0CBBB9F80C08';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-previous_9-17/components/fa5129e49d61d9c6b57287189523e39e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '428FA853-8475-41D5-BEAE-0A758818D0BC';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-previous_9-17/components/26ebd15ce2f2c1d6f9813d1a00a26054/bundle.js', [], () => ({
  /* content */
  /* handler:onAction */
  async ['onAction'](___arguments) {
      await (async function() {
  	window.location.reload()
  })();

  },
  /* handler:onAction */
  /* content */
}))

define('./pages/home-previous_9-17/components/54dcab8d080f34d8921bdbb632146cd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();//pageData.currentDataContent;
  	ownerBlock[0].innerHTML = `${sourceContent}`;
  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-previous_9-17/components/c19816bbc89f510c6b0f61af2ce6e8cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-previous_9-17/components/868de2a35dc382de3c1cd8fbad23a403/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  blockObjectID = '4645C476-DE2B-4007-9A54-03BBC0D8B746';
  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
       if ((getObjectProperty(item, 'id')) == blockObjectID) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-previous_9-17/components/4ab52bf14234a3b76ef19002bc343042/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '4087A0EA-27D1-45A5-97A2-9E787C8323E6';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-previous_9-17/components/f84a59cfd95b86ecac0818e2f8369ed1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '5155423A-F695-4B2F-AADB-4D18281D0F89';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-previous_9-17/components/7b1cb0a9932c78bfd8d5b79381e54204/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'A512CA81-3F67-48FE-9F52-1773D57EEC5B';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-previous_9-17/components/8b7ea841affa30d6d4891c06e62e2d89/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogo-mini', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var _currentUser, result2, result, storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.event, 'ctrlKey')) == true && (getObjectProperty(___arguments.event, 'altKey')) == true) {
    ___arguments.context.pageData['hideButtonsMode'] = false;
    storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
    if (storedTokenFromCookie != null || storedTokenFromCookie != '') {
      _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](storedTokenFromCookie));
      if (_currentUser != false) {
        if ((getObjectProperty(_currentUser, 'token')) != '') {
          localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
        }
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
      }
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      ___arguments.context.appData['inAdminMode'] = true;
      ___arguments.context.appData['isLoggedIn'] = true;
      ___arguments.context.pageData['showAdminBar'] = true;
    } else {
      console.log('####### THE COOKIE IS NOT NULL!!! #######');
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
    }
    console.log(___arguments.event);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('####### appData.CurrentUser #######');
  console.log(getObjectProperty(___arguments.context.appData, 'CurrentUser'));
  console.log('####### ISLOGGEDIN: #######');
  console.log(getObjectProperty(___arguments.context.appData, 'isLoggedIn'));
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
    if ((getObjectProperty(___arguments.context.appData, 'CurrentUser')) != false) {
      console.log('####### CHECKING IF USER isWebsiteEditor #######');
      result = (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'CurrentUser'))));
      if (result == true) {
        console.log('####### RETURN FROM isWebsiteEditor FUNCTION #######');
        console.log('isWebsiteEditor = ');
        console.log(result);
        console.log('####### HIDE BUTTONS MODE #######');
        console.log(getObjectProperty(___arguments.context.pageData, 'hideButtonsMode'));
        if ((getObjectProperty(___arguments.context.pageData, 'hideButtonsMode')) == true) {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', true);
        } else {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);
        }
      }
    }
  }

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/home-previous_9-17/components/e18a76e42143485dabe50caddb6fdd6f/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogoCell-right', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/home-previous_9-17/components/3ea61bdd3ad1e562a5185b8204761226/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();
  	pageData.currentDataContent = sourceContent; // added decodeURIComponent for troubleshooting

  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('admin_Webpages').save( ({ 'objectId': (getObjectProperty(___arguments.context.pageData, 'currentDataSource')),'BlockContent': (encodeURIComponent((getObjectProperty(___arguments.context.pageData, 'currentDataContent')))) }) );

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/home-previous_9-17/components/19f2f0dacd13571dc9b931385a463b62/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/home-previous_9-17/components/cc3a9886128a333e4fb5d24ca934c255/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  return (['You are logged on as: ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'CurrentUser')), 'record')), 'name')),' | CTRL + ALT Click on your logo to turn edit mode back on again.'].join(''));

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-previous_9-17/components/0b76d57506286594c0a8661497f83bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'C1F6E9F5-7F62-4DEC-87C0-70A43E04649C';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-previous_9-17/components/226882c510580398880a31741218b794/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('careers', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/home-previous_9-17/components/ac5384a89159966cc8681bfea27aa946/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('industries', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-previous_9-17/components/f96298252c8b58c3630720c3f3968e33/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var result2, result;

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  result = (await (async function(pageData, HTMLSource) {
  	/*
  	
  	// Plugins that we probably will need: mediaembed, export linkchecker?, powerpaste, advtable, editimage, autocorrect, typography, checklist
  	Existing plugins backup: 'tinydrive code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
  	Removed from below: 
  	toolbar_sticky: true,
  	toolbar_mode: 'floating', // Modes: floating, sliding, scrolling, wrap
  	
  	*/
  	
  	const editor = await BackendlessUI.requireModule('https://cdn.tiny.cloud/1/dwt7je7v9gjog7a8oc867xici2xmy80whuw0asnvstr20590/tinymce/8/tinymce.min.js')
  	tinymce.init({ selector: '.TinyMCETextEditor',
  	plugins: 'tinydrive code anchor link charmap codesample emoticons image lists media searchreplace table visualblocks wordcount',
  	toolbar: 'undo redo | blocks fontfamily fontsize | fontsizeselect | forecolor backcolor | bold italic underline strikethrough blockquote | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat | code',
  	font_family_formats: 'Andale Mono="Andale Mono"; Arial=arial; Arial Black="arial black"; Book Antiqua = "book antiqua"; Comic Sans MS="Comic Sans MS"; Courier New=courier new,courier,monospace; Georgia=georgia; Helvetica=helvetica; Impact=impact; Tahoma=tahoma; Terminal=terminal; Times New Roman="times new roman"; Trebuchet MS = "trebuchet ms"; Sans Serif="sans serif"; Segoe UI=segoe ui; Verdana=verdana; Webdings=webdings; Wingdings=wingdings',
  	font_size_formats: "8px 10px 12px 14px 16px 18px 20px 24px 30px 36px 48px 60px 72px 96px",
  	relative_urls : true,
  	remove_script_host : false,
  	document_base_url : 'https://www.accofg.com/',
  	tinydrive_dropbox_app_key: 'zf8ghuzc8e0s3ad',
  	setup: function (editor) {
  	      editor.on('init', function (e) {
  	        editor.setContent(HTMLSource);
  	      });
  	    }
  	
  	}) //#${id}`}) `this was inside a template string`
  	
  	// document.getElementById('btnUpdateContent').addEventListener("click", saveContent)
  	
  	function saveContent() {
  	const myContent = tinymce.activeEditor.getContent()
  	pageData.myContent = myContent
  	}

  })(___arguments.context.pageData, (getObjectProperty(___arguments.context.pageData, 'currentDataContent'))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/home-previous_9-17/components/859df6fc47f553256c989f7c2b88adcc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isOpenModal'))

  },
  /* handler:onDisplayAssignment */
  /* handler:modalVisibilityLogic */
  ['modalVisibilityLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isOpenModal'))

  },
  /* handler:modalVisibilityLogic */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;

  },
  /* handler:onClose */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    var result;


  console.log('Modal: (OnVisibilityChange) Modal Visible | Content Pushed to TinyMCE in the modal__card.OnVisible Event');

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/home-previous_9-17/components/71dd7f53b1157583c11cd04885411f04/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var result;


  result = (await (async function(pageData) {
  	// Create an array by ClassName 'content_editable' and invoke the function (editable) and create an event listener for each index in the array
  	// const runner = { currentDataSource: ""};
  	
  	var loadFromBlock, HTMLSource;
  	loadFromBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource);
  	console.log ('modal__card: OnMounted: The data source has been set to: ' + pageData.currentDataSource);
  	HTMLSource = loadFromBlock[0].innerHTML;
  	// loadFromBlock.currentTarget.getAttribute('data-source')
  	tinymce.activeEditor.setContent(HTMLSource);
  	pageData.currentDataContent = HTMLSource
  })(___arguments.context.pageData));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/home-redesign/components/55343ac7f355e5866b258f56b9374e51/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'white';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projects-and-services', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-redesign/components/e3dbcfc8260ddb18fbfa650584ebcb7b/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'white';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('about', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-redesign/components/9274dbcfe0ee894416a264e55332b426/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'white';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('subcontractors', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-redesign/components/c7db3fda439eae33a98479749c1f6cdc/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'white';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('employees', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-redesign/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var WebsiteMode, AppBaseURL, AppURL, _localWebPageDataRoot, _webpageObjectID, _webpageSections;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ AN - ON BEFORE PAGE ENTER - EVENT JUST HAPPENED!!! ############################');
  ___arguments.context.pageData['isPageReady'] = false;
  _webpageObjectID = '3B6B2404-C1AA-47E8-B2BB-AD3C6BB91242';
  ___arguments.context.pageData['WebpageObjectID'] = _webpageObjectID;
  _webpageSections = ['headerBlock1', 'headerBlock2', 'heroBlock1', 'heroBlock2', 'landingBlock1', 'landingBlock2', 'landingBlock3', 'landingBlock4', 'footerBlock1', 'footerBlock2'];
  ___arguments.context.pageData['_webpageSections'] = (_webpageSections.length);
  ___arguments.context.pageData['WebpageSections'] = _webpageSections;
  _localWebPageDataRoot = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accoweb.pockethost.io/api/collections/webpages/records?filter=(objectId=\'',_webpageObjectID,'\')'].join('')))).setEncoding('utf8').send()), 'items'))[0];
  ___arguments.context.pageData['WebpageDataRoot'] = _localWebPageDataRoot;
  ___arguments.context.pageData['WebpageData'] = (getObjectProperty(_localWebPageDataRoot, 'PageContent'));
  ___arguments.context.pageData['isPageReady'] = true;
  ___arguments.context.pageData['BETAItemsVisible'] = false;
  AppURL = (await BackendlessUI.Functions.Custom['fn_7c99d93c763398d595b7ff4a51c14f57']());
  AppBaseURL = AppURL.slice(0, 23);
  console.log(String('AppBaseURL = ') + String(AppBaseURL));

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var result2, result, currentDataSource, _currentUser, _storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ A PAGE ENTER JUST HAPPENED!!! ############################');
  _storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
  if (_storedTokenFromCookie != null || _storedTokenFromCookie != 'undefined') {
    _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](_storedTokenFromCookie));
    console.log('### CURRENT USER ###');
    console.log(_currentUser);
    if (_currentUser != false) {
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
      if ((getObjectProperty(___arguments.context.appData, 'currentUser.record.BETAModeEnabled')) == true) {
        ___arguments.context.appData['isBETAEnabled'] = true;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = true;
      } else {
        ___arguments.context.appData['isBETAEnabled'] = false;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = false;
      }
    } else {
      ___arguments.context.appData['CurrentUser'] = null;
    }
  }
  ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['taskBarTop'] = true;
  ___arguments.context.pageData['taskBarBottom'] = false;
  ___arguments.context.pageData['hideButtonsMode'] = true;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onEnter */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onResize */
  /* handler:onPageQuery */
  async ['onPageQuery'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.pageQuery, 'debugMode')) == true && (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'currentUser'))))) {
    ___arguments.context.appData['debugMode'] = true;
  } else {
    ___arguments.context.appData['debugMode'] = false;
  }

  },
  /* handler:onPageQuery */
  /* content */
}))

define('./pages/home-redesign/components/f6c3d992d48fe05b791cfba8a2c9ea19/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 1;
  	video.playbackRate = 1;
  	video.play();
  })();

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 0;
  	video.playbackRate = 1;
  	video.pause();
  })();

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/home-redesign/components/27b9fd37c4233d555444978939bfe4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-redesign/components/4a16f104bfbce399523c5d8152efe8af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-redesign/components/e49eae259f43d5e4ed34fbed4c1690f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '8D6FAC01-F4F5-466C-8D61-4C6395519121';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-redesign/components/d6338723fe754ea845c18574e1db8e3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'B103EFB3-F65C-4F60-A3A7-0CBBB9F80C08';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-redesign/components/fa5129e49d61d9c6b57287189523e39e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '428FA853-8475-41D5-BEAE-0A758818D0BC';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-redesign/components/26ebd15ce2f2c1d6f9813d1a00a26054/bundle.js', [], () => ({
  /* content */
  /* handler:onAction */
  async ['onAction'](___arguments) {
      await (async function() {
  	window.location.reload()
  })();

  },
  /* handler:onAction */
  /* content */
}))

define('./pages/home-redesign/components/54dcab8d080f34d8921bdbb632146cd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();//pageData.currentDataContent;
  	ownerBlock[0].innerHTML = `${sourceContent}`;
  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-redesign/components/c19816bbc89f510c6b0f61af2ce6e8cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-redesign/components/868de2a35dc382de3c1cd8fbad23a403/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  blockObjectID = '4645C476-DE2B-4007-9A54-03BBC0D8B746';
  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
       if ((getObjectProperty(item, 'id')) == blockObjectID) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-redesign/components/4ab52bf14234a3b76ef19002bc343042/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '4087A0EA-27D1-45A5-97A2-9E787C8323E6';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-redesign/components/f84a59cfd95b86ecac0818e2f8369ed1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '5155423A-F695-4B2F-AADB-4D18281D0F89';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-redesign/components/7b1cb0a9932c78bfd8d5b79381e54204/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'A512CA81-3F67-48FE-9F52-1773D57EEC5B';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-redesign/components/8b7ea841affa30d6d4891c06e62e2d89/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogo-mini', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var _currentUser, result2, result, storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.event, 'ctrlKey')) == true && (getObjectProperty(___arguments.event, 'altKey')) == true) {
    ___arguments.context.pageData['hideButtonsMode'] = false;
    storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
    if (storedTokenFromCookie != null || storedTokenFromCookie != '') {
      _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](storedTokenFromCookie));
      if (_currentUser != false) {
        if ((getObjectProperty(_currentUser, 'token')) != '') {
          localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
        }
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
      }
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      ___arguments.context.appData['inAdminMode'] = true;
      ___arguments.context.appData['isLoggedIn'] = true;
      ___arguments.context.pageData['showAdminBar'] = true;
    } else {
      console.log('####### THE COOKIE IS NOT NULL!!! #######');
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
    }
    console.log(___arguments.event);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('####### appData.CurrentUser #######');
  console.log(getObjectProperty(___arguments.context.appData, 'CurrentUser'));
  console.log('####### ISLOGGEDIN: #######');
  console.log(getObjectProperty(___arguments.context.appData, 'isLoggedIn'));
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
    if ((getObjectProperty(___arguments.context.appData, 'CurrentUser')) != false) {
      console.log('####### CHECKING IF USER isWebsiteEditor #######');
      result = (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'CurrentUser'))));
      if (result == true) {
        console.log('####### RETURN FROM isWebsiteEditor FUNCTION #######');
        console.log('isWebsiteEditor = ');
        console.log(result);
        console.log('####### HIDE BUTTONS MODE #######');
        console.log(getObjectProperty(___arguments.context.pageData, 'hideButtonsMode'));
        if ((getObjectProperty(___arguments.context.pageData, 'hideButtonsMode')) == true) {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', true);
        } else {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);
        }
      }
    }
  }

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/home-redesign/components/e18a76e42143485dabe50caddb6fdd6f/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogoCell-right', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/home-redesign/components/3ea61bdd3ad1e562a5185b8204761226/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();
  	pageData.currentDataContent = sourceContent; // added decodeURIComponent for troubleshooting

  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('admin_Webpages').save( ({ 'objectId': (getObjectProperty(___arguments.context.pageData, 'currentDataSource')),'BlockContent': (encodeURIComponent((getObjectProperty(___arguments.context.pageData, 'currentDataContent')))) }) );

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/home-redesign/components/19f2f0dacd13571dc9b931385a463b62/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/home-redesign/components/cc3a9886128a333e4fb5d24ca934c255/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  return (['You are logged on as: ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'CurrentUser')), 'record')), 'name')),' | CTRL + ALT Click on your logo to turn edit mode back on again.'].join(''));

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-redesign/components/0b76d57506286594c0a8661497f83bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'C1F6E9F5-7F62-4DEC-87C0-70A43E04649C';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-redesign/components/226882c510580398880a31741218b794/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('careers', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'white';

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/home-redesign/components/ac5384a89159966cc8681bfea27aa946/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'white';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('industries', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-redesign/components/f96298252c8b58c3630720c3f3968e33/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var result2, result;

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  result = (await (async function(pageData, HTMLSource) {
  	/*
  	
  	// Plugins that we probably will need: mediaembed, export linkchecker?, powerpaste, advtable, editimage, autocorrect, typography, checklist
  	Existing plugins backup: 'tinydrive code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
  	Removed from below: 
  	toolbar_sticky: true,
  	toolbar_mode: 'floating', // Modes: floating, sliding, scrolling, wrap
  	
  	*/
  	
  	const editor = await BackendlessUI.requireModule('https://cdn.tiny.cloud/1/dwt7je7v9gjog7a8oc867xici2xmy80whuw0asnvstr20590/tinymce/8/tinymce.min.js')
  	tinymce.init({ selector: '.TinyMCETextEditor',
  	plugins: 'tinydrive code anchor link charmap codesample emoticons image lists media searchreplace table visualblocks wordcount',
  	toolbar: 'undo redo | blocks fontfamily fontsize | fontsizeselect | forecolor backcolor | bold italic underline strikethrough blockquote | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat | code',
  	font_family_formats: 'Andale Mono="Andale Mono"; Arial=arial; Arial Black="arial black"; Book Antiqua = "book antiqua"; Comic Sans MS="Comic Sans MS"; Courier New=courier new,courier,monospace; Georgia=georgia; Helvetica=helvetica; Impact=impact; Tahoma=tahoma; Terminal=terminal; Times New Roman="times new roman"; Trebuchet MS = "trebuchet ms"; Sans Serif="sans serif"; Segoe UI=segoe ui; Verdana=verdana; Webdings=webdings; Wingdings=wingdings',
  	font_size_formats: "8px 10px 12px 14px 16px 18px 20px 24px 30px 36px 48px 60px 72px 96px",
  	relative_urls : true,
  	remove_script_host : false,
  	document_base_url : 'https://www.accofg.com/',
  	tinydrive_dropbox_app_key: 'zf8ghuzc8e0s3ad',
  	setup: function (editor) {
  	      editor.on('init', function (e) {
  	        editor.setContent(HTMLSource);
  	      });
  	    }
  	
  	}) //#${id}`}) `this was inside a template string`
  	
  	// document.getElementById('btnUpdateContent').addEventListener("click", saveContent)
  	
  	function saveContent() {
  	const myContent = tinymce.activeEditor.getContent()
  	pageData.myContent = myContent
  	}

  })(___arguments.context.pageData, (getObjectProperty(___arguments.context.pageData, 'currentDataContent'))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/home-redesign/components/859df6fc47f553256c989f7c2b88adcc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isOpenModal'))

  },
  /* handler:onDisplayAssignment */
  /* handler:modalVisibilityLogic */
  ['modalVisibilityLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isOpenModal'))

  },
  /* handler:modalVisibilityLogic */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;

  },
  /* handler:onClose */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    var result;


  console.log('Modal: (OnVisibilityChange) Modal Visible | Content Pushed to TinyMCE in the modal__card.OnVisible Event');

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/home-redesign/components/71dd7f53b1157583c11cd04885411f04/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var result;


  result = (await (async function(pageData) {
  	// Create an array by ClassName 'content_editable' and invoke the function (editable) and create an event listener for each index in the array
  	// const runner = { currentDataSource: ""};
  	
  	var loadFromBlock, HTMLSource;
  	loadFromBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource);
  	console.log ('modal__card: OnMounted: The data source has been set to: ' + pageData.currentDataSource);
  	HTMLSource = loadFromBlock[0].innerHTML;
  	// loadFromBlock.currentTarget.getAttribute('data-source')
  	tinymce.activeEditor.setContent(HTMLSource);
  	pageData.currentDataContent = HTMLSource
  })(___arguments.context.pageData));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/home-redesign-2/components/55343ac7f355e5866b258f56b9374e51/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'white';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projects-and-services', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-redesign-2/components/e3dbcfc8260ddb18fbfa650584ebcb7b/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'white';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('about', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-redesign-2/components/9274dbcfe0ee894416a264e55332b426/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'white';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('subcontractors', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-redesign-2/components/c7db3fda439eae33a98479749c1f6cdc/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'white';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('employees', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-redesign-2/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var WebsiteMode, AppBaseURL, AppURL, _localWebPageDataRoot, _webpageObjectID, _webpageSections;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ AN - ON BEFORE PAGE ENTER - EVENT JUST HAPPENED!!! ############################');
  ___arguments.context.pageData['isPageReady'] = false;
  _webpageObjectID = '3B6B2404-C1AA-47E8-B2BB-AD3C6BB91242';
  ___arguments.context.pageData['WebpageObjectID'] = _webpageObjectID;
  _webpageSections = ['headerBlock1', 'headerBlock2', 'heroBlock1', 'heroBlock2', 'landingBlock1', 'landingBlock2', 'landingBlock3', 'landingBlock4', 'footerBlock1', 'footerBlock2'];
  ___arguments.context.pageData['_webpageSections'] = (_webpageSections.length);
  ___arguments.context.pageData['WebpageSections'] = _webpageSections;
  _localWebPageDataRoot = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accoweb.pockethost.io/api/collections/webpages/records?filter=(objectId=\'',_webpageObjectID,'\')'].join('')))).setEncoding('utf8').send()), 'items'))[0];
  ___arguments.context.pageData['WebpageDataRoot'] = _localWebPageDataRoot;
  ___arguments.context.pageData['WebpageData'] = (getObjectProperty(_localWebPageDataRoot, 'PageContent'));
  ___arguments.context.pageData['isPageReady'] = true;
  ___arguments.context.pageData['BETAItemsVisible'] = false;
  AppURL = (await BackendlessUI.Functions.Custom['fn_7c99d93c763398d595b7ff4a51c14f57']());
  AppBaseURL = AppURL.slice(0, 23);
  console.log(String('AppBaseURL = ') + String(AppBaseURL));

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var result2, result, currentDataSource, _currentUser, _storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ A PAGE ENTER JUST HAPPENED!!! ############################');
  _storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
  if (_storedTokenFromCookie != null || _storedTokenFromCookie != 'undefined') {
    _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](_storedTokenFromCookie));
    console.log('### CURRENT USER ###');
    console.log(_currentUser);
    if (_currentUser != false) {
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
      if ((getObjectProperty(___arguments.context.appData, 'currentUser.record.BETAModeEnabled')) == true) {
        ___arguments.context.appData['isBETAEnabled'] = true;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = true;
      } else {
        ___arguments.context.appData['isBETAEnabled'] = false;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = false;
      }
    } else {
      ___arguments.context.appData['CurrentUser'] = null;
    }
  }
  ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['taskBarTop'] = true;
  ___arguments.context.pageData['taskBarBottom'] = false;
  ___arguments.context.pageData['hideButtonsMode'] = true;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onEnter */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onResize */
  /* handler:onPageQuery */
  async ['onPageQuery'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.pageQuery, 'debugMode')) == true && (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'currentUser'))))) {
    ___arguments.context.appData['debugMode'] = true;
  } else {
    ___arguments.context.appData['debugMode'] = false;
  }

  },
  /* handler:onPageQuery */
  /* content */
}))

define('./pages/home-redesign-2/components/f6c3d992d48fe05b791cfba8a2c9ea19/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 1;
  	video.playbackRate = 1;
  	video.play();
  })();

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 0;
  	video.playbackRate = 1;
  	video.pause();
  })();

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/home-redesign-2/components/27b9fd37c4233d555444978939bfe4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-redesign-2/components/4a16f104bfbce399523c5d8152efe8af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-redesign-2/components/e49eae259f43d5e4ed34fbed4c1690f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '8D6FAC01-F4F5-466C-8D61-4C6395519121';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-redesign-2/components/d6338723fe754ea845c18574e1db8e3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'B103EFB3-F65C-4F60-A3A7-0CBBB9F80C08';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-redesign-2/components/fa5129e49d61d9c6b57287189523e39e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '428FA853-8475-41D5-BEAE-0A758818D0BC';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-redesign-2/components/26ebd15ce2f2c1d6f9813d1a00a26054/bundle.js', [], () => ({
  /* content */
  /* handler:onAction */
  async ['onAction'](___arguments) {
      await (async function() {
  	window.location.reload()
  })();

  },
  /* handler:onAction */
  /* content */
}))

define('./pages/home-redesign-2/components/54dcab8d080f34d8921bdbb632146cd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();//pageData.currentDataContent;
  	ownerBlock[0].innerHTML = `${sourceContent}`;
  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-redesign-2/components/c19816bbc89f510c6b0f61af2ce6e8cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-redesign-2/components/868de2a35dc382de3c1cd8fbad23a403/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  blockObjectID = '4645C476-DE2B-4007-9A54-03BBC0D8B746';
  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
       if ((getObjectProperty(item, 'id')) == blockObjectID) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-redesign-2/components/4ab52bf14234a3b76ef19002bc343042/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '4087A0EA-27D1-45A5-97A2-9E787C8323E6';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-redesign-2/components/f84a59cfd95b86ecac0818e2f8369ed1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '5155423A-F695-4B2F-AADB-4D18281D0F89';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-redesign-2/components/7b1cb0a9932c78bfd8d5b79381e54204/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'A512CA81-3F67-48FE-9F52-1773D57EEC5B';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-redesign-2/components/8b7ea841affa30d6d4891c06e62e2d89/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogo-mini', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var _currentUser, result2, result, storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.event, 'ctrlKey')) == true && (getObjectProperty(___arguments.event, 'altKey')) == true) {
    ___arguments.context.pageData['hideButtonsMode'] = false;
    storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
    if (storedTokenFromCookie != null || storedTokenFromCookie != '') {
      _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](storedTokenFromCookie));
      if (_currentUser != false) {
        if ((getObjectProperty(_currentUser, 'token')) != '') {
          localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
        }
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
      }
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      ___arguments.context.appData['inAdminMode'] = true;
      ___arguments.context.appData['isLoggedIn'] = true;
      ___arguments.context.pageData['showAdminBar'] = true;
    } else {
      console.log('####### THE COOKIE IS NOT NULL!!! #######');
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
    }
    console.log(___arguments.event);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('####### appData.CurrentUser #######');
  console.log(getObjectProperty(___arguments.context.appData, 'CurrentUser'));
  console.log('####### ISLOGGEDIN: #######');
  console.log(getObjectProperty(___arguments.context.appData, 'isLoggedIn'));
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
    if ((getObjectProperty(___arguments.context.appData, 'CurrentUser')) != false) {
      console.log('####### CHECKING IF USER isWebsiteEditor #######');
      result = (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'CurrentUser'))));
      if (result == true) {
        console.log('####### RETURN FROM isWebsiteEditor FUNCTION #######');
        console.log('isWebsiteEditor = ');
        console.log(result);
        console.log('####### HIDE BUTTONS MODE #######');
        console.log(getObjectProperty(___arguments.context.pageData, 'hideButtonsMode'));
        if ((getObjectProperty(___arguments.context.pageData, 'hideButtonsMode')) == true) {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', true);
        } else {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);
        }
      }
    }
  }

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/home-redesign-2/components/e18a76e42143485dabe50caddb6fdd6f/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogoCell-right', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/home-redesign-2/components/3ea61bdd3ad1e562a5185b8204761226/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();
  	pageData.currentDataContent = sourceContent; // added decodeURIComponent for troubleshooting

  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('admin_Webpages').save( ({ 'objectId': (getObjectProperty(___arguments.context.pageData, 'currentDataSource')),'BlockContent': (encodeURIComponent((getObjectProperty(___arguments.context.pageData, 'currentDataContent')))) }) );

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/home-redesign-2/components/19f2f0dacd13571dc9b931385a463b62/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/home-redesign-2/components/cc3a9886128a333e4fb5d24ca934c255/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  return (['You are logged on as: ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'CurrentUser')), 'record')), 'name')),' | CTRL + ALT Click on your logo to turn edit mode back on again.'].join(''));

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-redesign-2/components/0b76d57506286594c0a8661497f83bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'C1F6E9F5-7F62-4DEC-87C0-70A43E04649C';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-redesign-2/components/226882c510580398880a31741218b794/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('careers', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'white';

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/home-redesign-2/components/ac5384a89159966cc8681bfea27aa946/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'white';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('industries', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/home-redesign-2/components/f96298252c8b58c3630720c3f3968e33/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var result2, result;

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  result = (await (async function(pageData, HTMLSource) {
  	/*
  	
  	// Plugins that we probably will need: mediaembed, export linkchecker?, powerpaste, advtable, editimage, autocorrect, typography, checklist
  	Existing plugins backup: 'tinydrive code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
  	Removed from below: 
  	toolbar_sticky: true,
  	toolbar_mode: 'floating', // Modes: floating, sliding, scrolling, wrap
  	
  	*/
  	
  	const editor = await BackendlessUI.requireModule('https://cdn.tiny.cloud/1/dwt7je7v9gjog7a8oc867xici2xmy80whuw0asnvstr20590/tinymce/8/tinymce.min.js')
  	tinymce.init({ selector: '.TinyMCETextEditor',
  	plugins: 'tinydrive code anchor link charmap codesample emoticons image lists media searchreplace table visualblocks wordcount',
  	toolbar: 'undo redo | blocks fontfamily fontsize | fontsizeselect | forecolor backcolor | bold italic underline strikethrough blockquote | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat | code',
  	font_family_formats: 'Andale Mono="Andale Mono"; Arial=arial; Arial Black="arial black"; Book Antiqua = "book antiqua"; Comic Sans MS="Comic Sans MS"; Courier New=courier new,courier,monospace; Georgia=georgia; Helvetica=helvetica; Impact=impact; Tahoma=tahoma; Terminal=terminal; Times New Roman="times new roman"; Trebuchet MS = "trebuchet ms"; Sans Serif="sans serif"; Segoe UI=segoe ui; Verdana=verdana; Webdings=webdings; Wingdings=wingdings',
  	font_size_formats: "8px 10px 12px 14px 16px 18px 20px 24px 30px 36px 48px 60px 72px 96px",
  	relative_urls : true,
  	remove_script_host : false,
  	document_base_url : 'https://www.accofg.com/',
  	tinydrive_dropbox_app_key: 'zf8ghuzc8e0s3ad',
  	setup: function (editor) {
  	      editor.on('init', function (e) {
  	        editor.setContent(HTMLSource);
  	      });
  	    }
  	
  	}) //#${id}`}) `this was inside a template string`
  	
  	// document.getElementById('btnUpdateContent').addEventListener("click", saveContent)
  	
  	function saveContent() {
  	const myContent = tinymce.activeEditor.getContent()
  	pageData.myContent = myContent
  	}

  })(___arguments.context.pageData, (getObjectProperty(___arguments.context.pageData, 'currentDataContent'))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/home-redesign-2/components/859df6fc47f553256c989f7c2b88adcc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isOpenModal'))

  },
  /* handler:onDisplayAssignment */
  /* handler:modalVisibilityLogic */
  ['modalVisibilityLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isOpenModal'))

  },
  /* handler:modalVisibilityLogic */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;

  },
  /* handler:onClose */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    var result;


  console.log('Modal: (OnVisibilityChange) Modal Visible | Content Pushed to TinyMCE in the modal__card.OnVisible Event');

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/home-redesign-2/components/71dd7f53b1157583c11cd04885411f04/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var result;


  result = (await (async function(pageData) {
  	// Create an array by ClassName 'content_editable' and invoke the function (editable) and create an event listener for each index in the array
  	// const runner = { currentDataSource: ""};
  	
  	var loadFromBlock, HTMLSource;
  	loadFromBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource);
  	console.log ('modal__card: OnMounted: The data source has been set to: ' + pageData.currentDataSource);
  	HTMLSource = loadFromBlock[0].innerHTML;
  	// loadFromBlock.currentTarget.getAttribute('data-source')
  	tinymce.activeEditor.setContent(HTMLSource);
  	pageData.currentDataContent = HTMLSource
  })(___arguments.context.pageData));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/home-redesign-old/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var WebsiteMode, AppBaseURL, AppURL, _localWebPageDataRoot, _webpageObjectID, _webpageSections;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isPageReady'] = false;
  _webpageObjectID = '3B6B2404-C1AA-47E8-B2BB-AD3C6BB91242';
  ___arguments.context.pageData['WebpageObjectID'] = _webpageObjectID;
  _webpageSections = ['headerBlock1', 'headerBlock2', 'heroBlock1', 'heroBlock2', 'landingBlock1', 'landingBlock2', 'landingBlock3', 'landingBlock4', 'footerBlock1', 'footerBlock2'];
  ___arguments.context.pageData['_webpageSections'] = (_webpageSections.length);
  ___arguments.context.pageData['WebpageSections'] = _webpageSections;
  _localWebPageDataRoot = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accoweb.pockethost.io/api/collections/webpages/records?filter=(objectId=\'',_webpageObjectID,'\')'].join('')))).setEncoding('utf8').send()), 'items'))[0];
  ___arguments.context.pageData['WebpageDataRoot'] = _localWebPageDataRoot;
  ___arguments.context.pageData['WebpageData'] = (getObjectProperty(_localWebPageDataRoot, 'PageContent'));
  ___arguments.context.pageData['isPageReady'] = true;
  ___arguments.context.pageData['BETAItemsVisible'] = false;
  AppURL = (await BackendlessUI.Functions.Custom['fn_7c99d93c763398d595b7ff4a51c14f57']());
  AppBaseURL = AppURL.slice(0, 23);
  console.log(String('AppBaseURL = ') + String(AppBaseURL));

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var result2, result, currentDataSource, _currentUser, _storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ A PAGE ENTER JUST HAPPENED!!! ############################');
  _storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
  if (_storedTokenFromCookie != null || _storedTokenFromCookie != 'undefined') {
    _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](_storedTokenFromCookie));
    console.log('### CURRENT USER ###');
    console.log(_currentUser);
    if (_currentUser != false) {
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
      if ((getObjectProperty(___arguments.context.appData, 'currentUser.record.BETAModeEnabled')) == true) {
        ___arguments.context.appData['isBETAEnabled'] = true;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = true;
      } else {
        ___arguments.context.appData['isBETAEnabled'] = false;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = false;
      }
    } else {
      ___arguments.context.appData['CurrentUser'] = null;
    }
  }
  ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['taskBarTop'] = true;
  ___arguments.context.pageData['taskBarBottom'] = false;
  ___arguments.context.pageData['hideButtonsMode'] = true;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onEnter */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onResize */
  /* handler:onPageQuery */
  async ['onPageQuery'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.pageQuery, 'debugMode')) == true && (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'currentUser'))))) {
    ___arguments.context.appData['debugMode'] = true;
  } else {
    ___arguments.context.appData['debugMode'] = false;
  }

  },
  /* handler:onPageQuery */
  /* content */
}))

define('./pages/home-redesign-old/components/f6c3d992d48fe05b791cfba8a2c9ea19/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 1;
  	video.playbackRate = 1;
  	video.play();
  })();

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 0;
  	video.playbackRate = 1;
  	video.pause();
  })();

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/home-redesign-old/components/27b9fd37c4233d555444978939bfe4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-redesign-old/components/717adc521cbdf7ca7f3db4188da3a5c7/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classesList = ['modal'];
  if (getObjectProperty(___arguments.context.pageData, 'isOpenModal')) {
    addItemToList(classesList, 'open');
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'blockMouseOverEvent')) != true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('717adc521cbdf7ca7f3db4188da3a5c7', true);
    ___arguments.context.pageData['blockMouseOverEvent'] = true;
  }

  },
  /* handler:onMouseOver */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var result;


  result = (await (async function(pageData) {
  	// Create an array by ClassName 'content_editable' and invoke the function (editable) and create an event listener for each index in the array
  	// const runner = { currentDataSource: ""};
  	
  	var loadFromBlock, HTMLSource;
  	loadFromBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource);
  	console.log ('The data source has been set to: ' + pageData.currentDataSource);
  	HTMLSource = loadFromBlock[0].innerHTML;
  	// loadFromBlock.currentTarget.getAttribute('data-source')
  	tinymce.activeEditor.setContent(HTMLSource);
  	pageData.currentDataContent = HTMLSource
  })(___arguments.context.pageData));

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/home-redesign-old/components/8cd91f8f8d38899143393ed8c8129c7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-redesign-old/components/4a16f104bfbce399523c5d8152efe8af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-redesign-old/components/e49eae259f43d5e4ed34fbed4c1690f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '8D6FAC01-F4F5-466C-8D61-4C6395519121';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-redesign-old/components/d6338723fe754ea845c18574e1db8e3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'B103EFB3-F65C-4F60-A3A7-0CBBB9F80C08';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-redesign-old/components/fa5129e49d61d9c6b57287189523e39e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '428FA853-8475-41D5-BEAE-0A758818D0BC';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-redesign-old/components/26ebd15ce2f2c1d6f9813d1a00a26054/bundle.js', [], () => ({
  /* content */
  /* handler:onAction */
  async ['onAction'](___arguments) {
    var WebsiteMode, AppBaseURL, AppURL, _localWebPageDataRoot, _webpageObjectID, _webpageSections;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isPageReady'] = false;
  _webpageObjectID = (getObjectProperty(___arguments.context.pageData, 'WebpageObjectID'));
  ___arguments.context.pageData['WebpageObjectID'] = _webpageObjectID;
  _webpageSections = ['headerBlock1', 'headerBlock2', 'heroBlock1', 'heroBlock2', 'landingBlock1', 'landingBlock2', 'landingBlock3', 'landingBlock4', 'footerBlock1', 'footerBlock2'];
  ___arguments.context.pageData['_webpageSections'] = (_webpageSections.length);
  ___arguments.context.pageData['WebpageSections'] = _webpageSections;
  _localWebPageDataRoot = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accoweb.pockethost.io/api/collections/webpages/records?filter=(objectId=\'',_webpageObjectID,'\')'].join('')))).setEncoding('utf8').send()), 'items'))[0];
  ___arguments.context.pageData['WebpageDataRoot'] = _localWebPageDataRoot;
  ___arguments.context.pageData['WebpageData'] = (getObjectProperty(_localWebPageDataRoot, 'PageContent'));
  ___arguments.context.pageData['isPageReady'] = true;
  ___arguments.context.pageData['BETAItemsVisible'] = false;
  AppURL = (await BackendlessUI.Functions.Custom['fn_7c99d93c763398d595b7ff4a51c14f57']());
  AppBaseURL = AppURL.slice(0, 23);
  console.log(String('AppBaseURL = ') + String(AppBaseURL));

  },
  /* handler:onAction */
  /* content */
}))

define('./pages/home-redesign-old/components/54dcab8d080f34d8921bdbb632146cd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();//pageData.currentDataContent;
  	ownerBlock[0].innerHTML = `${sourceContent}`;
  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-redesign-old/components/c19816bbc89f510c6b0f61af2ce6e8cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home-redesign-old/components/868de2a35dc382de3c1cd8fbad23a403/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  blockObjectID = '4645C476-DE2B-4007-9A54-03BBC0D8B746';
  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
       if ((getObjectProperty(item, 'id')) == blockObjectID) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-redesign-old/components/4ab52bf14234a3b76ef19002bc343042/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '4087A0EA-27D1-45A5-97A2-9E787C8323E6';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-redesign-old/components/f84a59cfd95b86ecac0818e2f8369ed1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '5155423A-F695-4B2F-AADB-4D18281D0F89';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-redesign-old/components/7b1cb0a9932c78bfd8d5b79381e54204/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'A512CA81-3F67-48FE-9F52-1773D57EEC5B';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-redesign-old/components/8b7ea841affa30d6d4891c06e62e2d89/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogo-mini', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var _currentUser, result2, result, storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.event, 'ctrlKey')) == true && (getObjectProperty(___arguments.event, 'altKey')) == true) {
    ___arguments.context.pageData['hideButtonsMode'] = false;
    storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
    if (storedTokenFromCookie != null || storedTokenFromCookie != '') {
      _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](storedTokenFromCookie));
      if (_currentUser != false) {
        if ((getObjectProperty(_currentUser, 'token')) != '') {
          localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
        }
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
      }
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      ___arguments.context.appData['inAdminMode'] = true;
      ___arguments.context.appData['isLoggedIn'] = true;
      ___arguments.context.pageData['showAdminBar'] = true;
      if ((getObjectProperty(___arguments.context.appData, 'inAdminMode')) == true) {
        result = (await (async function(pageData) {
        	var myFunction = (e)=> {
        	  // console.log(e.currentTarget.getAttribute('data-source'));
        	  e.currentTarget.setAttribute('data-modified','true');
        	  console.log('This element has been marked as data-modified: ' + e.currentTarget.getAttribute('data-source'));
        	}
        	
        	Array.from(document.getElementsByClassName('content_editable')).forEach((editable) => {
        	  // editable.addEventListener('click', myFunction);
        	  editable.addEventListener('click', myFunction);
        	  
        	});
        })(___arguments.context.pageData));
      }
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
    }
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('####### appData.CurrentUser #######');
  console.log(getObjectProperty(___arguments.context.appData, 'CurrentUser'));
  console.log('####### ISLOGGEDIN: #######');
  console.log(getObjectProperty(___arguments.context.appData, 'isLoggedIn'));
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
    if ((getObjectProperty(___arguments.context.appData, 'CurrentUser')) != false) {
      console.log('####### CHECKING IF USER isWebsiteEditor #######');
      result = (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'CurrentUser'))));
      if (result == true) {
        console.log('####### RETURN FROM isWebsiteEditor FUNCTION #######');
        console.log('isWebsiteEditor = ');
        console.log(result);
        console.log('####### HIDE BUTTONS MODE #######');
        console.log(getObjectProperty(___arguments.context.pageData, 'hideButtonsMode'));
        if ((getObjectProperty(___arguments.context.pageData, 'hideButtonsMode')) == true) {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', true);
        } else {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);
        }
      }
    }
  }

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/home-redesign-old/components/3ea61bdd3ad1e562a5185b8204761226/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();
  	pageData.currentDataContent = sourceContent; // added decodeURIComponent for troubleshooting

  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('admin_Webpages').save( ({ 'objectId': (getObjectProperty(___arguments.context.pageData, 'currentDataSource')),'BlockContent': (encodeURIComponent((getObjectProperty(___arguments.context.pageData, 'currentDataContent')))) }) );

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/home-redesign-old/components/19f2f0dacd13571dc9b931385a463b62/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/home-redesign-old/components/cc3a9886128a333e4fb5d24ca934c255/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  return (['You are logged on as: ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'CurrentUser')), 'record')), 'name')),' | CTRL + ALT Click on your logo to turn edit mode back on again.'].join(''));

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home-redesign-old/components/0b76d57506286594c0a8661497f83bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'C1F6E9F5-7F62-4DEC-87C0-70A43E04649C';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/industries/components/55343ac7f355e5866b258f56b9374e51/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projects-and-services', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/industries/components/e3dbcfc8260ddb18fbfa650584ebcb7b/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('about', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/industries/components/9274dbcfe0ee894416a264e55332b426/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('subcontractors', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/industries/components/c7db3fda439eae33a98479749c1f6cdc/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('employees', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/industries/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var WebsiteMode, AppBaseURL, AppURL, _localWebPageDataRoot, _webpageObjectID, _webpageSections;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ AN - ON BEFORE PAGE ENTER - EVENT JUST HAPPENED!!! ############################');
  ___arguments.context.pageData['isPageReady'] = false;
  _webpageObjectID = 'a9548378-b9e8-8908-be2a-6c131023b17b';
  ___arguments.context.pageData['WebpageObjectID'] = _webpageObjectID;
  _webpageSections = ['headerBlock1', 'headerBlock2', 'heroBlock1', 'heroBlock2', 'landingBlock1', 'landingBlock2', 'landingBlock3', 'landingBlock4', 'footerBlock1', 'footerBlock2'];
  ___arguments.context.pageData['_webpageSections'] = (_webpageSections.length);
  ___arguments.context.pageData['WebpageSections'] = _webpageSections;
  _localWebPageDataRoot = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accoweb.pockethost.io/api/collections/webpages/records?filter=(objectId=\'',_webpageObjectID,'\')'].join('')))).setEncoding('utf8').send()), 'items'))[0];
  ___arguments.context.pageData['WebpageDataRoot'] = _localWebPageDataRoot;
  ___arguments.context.pageData['WebpageData'] = (getObjectProperty(_localWebPageDataRoot, 'PageContent'));
  ___arguments.context.pageData['isPageReady'] = true;
  ___arguments.context.pageData['BETAItemsVisible'] = false;
  AppURL = (await BackendlessUI.Functions.Custom['fn_7c99d93c763398d595b7ff4a51c14f57']());
  AppBaseURL = AppURL.slice(0, 23);
  console.log(String('AppBaseURL = ') + String(AppBaseURL));

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var result2, result, currentDataSource, _currentUser, _storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ A PAGE ENTER JUST HAPPENED!!! ############################');
  _storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
  if (_storedTokenFromCookie != null || _storedTokenFromCookie != 'undefined') {
    _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](_storedTokenFromCookie));
    console.log('### CURRENT USER ###');
    console.log(_currentUser);
    if (_currentUser != false) {
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
      if ((getObjectProperty(___arguments.context.appData, 'currentUser.record.BETAModeEnabled')) == true) {
        ___arguments.context.appData['isBETAEnabled'] = true;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = true;
      } else {
        ___arguments.context.appData['isBETAEnabled'] = false;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = false;
      }
    } else {
      ___arguments.context.appData['CurrentUser'] = null;
    }
  }
  ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['taskBarTop'] = true;
  ___arguments.context.pageData['taskBarBottom'] = false;
  ___arguments.context.pageData['hideButtonsMode'] = true;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onEnter */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onResize */
  /* handler:onPageQuery */
  async ['onPageQuery'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.pageQuery, 'debugMode')) == true && (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'currentUser'))))) {
    ___arguments.context.appData['debugMode'] = true;
  } else {
    ___arguments.context.appData['debugMode'] = false;
  }

  },
  /* handler:onPageQuery */
  /* content */
}))

define('./pages/industries/components/f6c3d992d48fe05b791cfba8a2c9ea19/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 1;
  	video.playbackRate = 1;
  	video.play();
  })();

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 0;
  	video.playbackRate = 1;
  	video.pause();
  })();

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/industries/components/27b9fd37c4233d555444978939bfe4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/industries/components/4a16f104bfbce399523c5d8152efe8af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/industries/components/e49eae259f43d5e4ed34fbed4c1690f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '8D6FAC01-F4F5-466C-8D61-4C6395519121';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/industries/components/d6338723fe754ea845c18574e1db8e3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'B103EFB3-F65C-4F60-A3A7-0CBBB9F80C08';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/industries/components/fa5129e49d61d9c6b57287189523e39e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '428FA853-8475-41D5-BEAE-0A758818D0BC';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/industries/components/26ebd15ce2f2c1d6f9813d1a00a26054/bundle.js', [], () => ({
  /* content */
  /* handler:onAction */
  async ['onAction'](___arguments) {
      await (async function() {
  	window.location.reload()
  })();

  },
  /* handler:onAction */
  /* content */
}))

define('./pages/industries/components/54dcab8d080f34d8921bdbb632146cd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();//pageData.currentDataContent;
  	ownerBlock[0].innerHTML = `${sourceContent}`;
  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/industries/components/c19816bbc89f510c6b0f61af2ce6e8cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/industries/components/868de2a35dc382de3c1cd8fbad23a403/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  blockObjectID = '4645C476-DE2B-4007-9A54-03BBC0D8B746';
  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
       if ((getObjectProperty(item, 'id')) == blockObjectID) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/industries/components/4ab52bf14234a3b76ef19002bc343042/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '4087A0EA-27D1-45A5-97A2-9E787C8323E6';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/industries/components/f84a59cfd95b86ecac0818e2f8369ed1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '5155423A-F695-4B2F-AADB-4D18281D0F89';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/industries/components/7b1cb0a9932c78bfd8d5b79381e54204/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'A512CA81-3F67-48FE-9F52-1773D57EEC5B';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/industries/components/8b7ea841affa30d6d4891c06e62e2d89/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogo-mini', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var _currentUser, result2, result, storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.event, 'ctrlKey')) == true && (getObjectProperty(___arguments.event, 'altKey')) == true) {
    ___arguments.context.pageData['hideButtonsMode'] = false;
    storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
    if (storedTokenFromCookie != null || storedTokenFromCookie != '') {
      _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](storedTokenFromCookie));
      if (_currentUser != false) {
        if ((getObjectProperty(_currentUser, 'token')) != '') {
          localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
        }
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
      }
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      ___arguments.context.appData['inAdminMode'] = true;
      ___arguments.context.appData['isLoggedIn'] = true;
      ___arguments.context.pageData['showAdminBar'] = true;
    } else {
      console.log('####### THE COOKIE IS NOT NULL!!! #######');
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
    }
    console.log(___arguments.event);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('####### appData.CurrentUser #######');
  console.log(getObjectProperty(___arguments.context.appData, 'CurrentUser'));
  console.log('####### ISLOGGEDIN: #######');
  console.log(getObjectProperty(___arguments.context.appData, 'isLoggedIn'));
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
    if ((getObjectProperty(___arguments.context.appData, 'CurrentUser')) != false) {
      console.log('####### CHECKING IF USER isWebsiteEditor #######');
      result = (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'CurrentUser'))));
      if (result == true) {
        console.log('####### RETURN FROM isWebsiteEditor FUNCTION #######');
        console.log('isWebsiteEditor = ');
        console.log(result);
        console.log('####### HIDE BUTTONS MODE #######');
        console.log(getObjectProperty(___arguments.context.pageData, 'hideButtonsMode'));
        if ((getObjectProperty(___arguments.context.pageData, 'hideButtonsMode')) == true) {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', true);
        } else {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);
        }
      }
    }
  }

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/industries/components/e18a76e42143485dabe50caddb6fdd6f/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogoCell-right', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/industries/components/3ea61bdd3ad1e562a5185b8204761226/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();
  	pageData.currentDataContent = sourceContent; // added decodeURIComponent for troubleshooting

  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('admin_Webpages').save( ({ 'objectId': (getObjectProperty(___arguments.context.pageData, 'currentDataSource')),'BlockContent': (encodeURIComponent((getObjectProperty(___arguments.context.pageData, 'currentDataContent')))) }) );

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/industries/components/19f2f0dacd13571dc9b931385a463b62/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/industries/components/cc3a9886128a333e4fb5d24ca934c255/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  return (['You are logged on as: ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'CurrentUser')), 'record')), 'name')),' | CTRL + ALT Click on your logo to turn edit mode back on again.'].join(''));

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/industries/components/0b76d57506286594c0a8661497f83bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'C1F6E9F5-7F62-4DEC-87C0-70A43E04649C';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/industries/components/226882c510580398880a31741218b794/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('careers', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/industries/components/ac5384a89159966cc8681bfea27aa946/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) == 'industries') {
    if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
      return ['easeInAndOut', 'underline', 'red'];
    } else {
      return ['hide-beta', 'easeInAndOut', 'underline', 'red'];
    }
  } else if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) != 'industries') {
    if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
      return ['easeInAndOut', 'black'];
    } else {
      return ['hide-beta', 'easeInAndOut'];
    }
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    
  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('industries', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/industries/components/f96298252c8b58c3630720c3f3968e33/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var result2, result;

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  result = (await (async function(pageData, HTMLSource, tinydrive_dropbox_app_key, created_jwt_token) {
  	/*
  	
  	// Plugins that we probably will need: mediaembed, export linkchecker?, powerpaste, advtable, editimage, autocorrect, typography, checklist
  	Existing plugins backup: 'tinydrive code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
  	Removed from below: 
  	toolbar_sticky: true,
  	toolbar_mode: 'floating', // Modes: floating, sliding, scrolling, wrap
  	
  	*/
  	
  	const editor = await BackendlessUI.requireModule('https://cdn.tiny.cloud/1/dwt7je7v9gjog7a8oc867xici2xmy80whuw0asnvstr20590/tinymce/8/tinymce.min.js')
  	tinymce.init({ selector: '.TinyMCETextEditor',
  	plugins: 'tinydrive code anchor link charmap codesample emoticons image lists media searchreplace table visualblocks wordcount',
  	toolbar: 'undo redo | blocks fontfamily fontsize | fontsizeselect | forecolor backcolor | bold italic underline strikethrough blockquote | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat | code',
  	font_family_formats: 'Andale Mono="Andale Mono"; Arial=arial; Arial Black="arial black"; Book Antiqua = "book antiqua"; Comic Sans MS="Comic Sans MS"; Courier New=courier new,courier,monospace; Georgia=georgia; Helvetica=helvetica; Impact=impact; Tahoma=tahoma; Terminal=terminal; Times New Roman="times new roman"; Trebuchet MS = "trebuchet ms"; Sans Serif="sans serif"; Segoe UI=segoe ui; Verdana=verdana; Webdings=webdings; Wingdings=wingdings',
  	font_size_formats: "8px 10px 12px 14px 16px 18px 20px 24px 30px 36px 48px 60px 72px 96px",
  	relative_urls : true,
  	remove_script_host : false,
  	document_base_url : 'https://www.accofg.com/',
  	tinydrive_dropbox_app_key: tinydrive_dropbox_app_key,
  	tinydrive_token_provider: (success, failure) => {
  	        success({ token:  created_jwt_token });
  	  },
  	setup: function (editor) {
  	      editor.on('init', function (e) {
  	        editor.setContent(HTMLSource);
  	      });
  	  }
  	
  	}) //#${id}`}) `this was inside a template string`
  	
  	// document.getElementById('btnUpdateContent').addEventListener("click", saveContent)
  	
  	function saveContent() {
  	const myContent = tinymce.activeEditor.getContent()
  	pageData.myContent = myContent
  	}

  })(___arguments.context.pageData, (getObjectProperty(___arguments.context.pageData, 'currentDataContent')), '7svncuz1u3xumyc', (getObjectProperty(((function () { return BackendlessUI.getCustomSettings() })()), 'created_jwt_token'))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/industries/components/859df6fc47f553256c989f7c2b88adcc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isOpenModal'))

  },
  /* handler:onDisplayAssignment */
  /* handler:modalVisibilityLogic */
  ['modalVisibilityLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isOpenModal'))

  },
  /* handler:modalVisibilityLogic */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;

  },
  /* handler:onClose */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    var result;


  console.log('Modal: (OnVisibilityChange) Modal Visible | Content Pushed to TinyMCE in the modal__card.OnVisible Event');

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/industries/components/71dd7f53b1157583c11cd04885411f04/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var result;


  result = (await (async function(pageData) {
  	// Create an array by ClassName 'content_editable' and invoke the function (editable) and create an event listener for each index in the array
  	// const runner = { currentDataSource: ""};
  	
  	var loadFromBlock, HTMLSource;
  	loadFromBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource);
  	console.log ('modal__card: OnMounted: The data source has been set to: ' + pageData.currentDataSource);
  	HTMLSource = loadFromBlock[0].innerHTML;
  	// loadFromBlock.currentTarget.getAttribute('data-source')
  	tinymce.activeEditor.setContent(HTMLSource);
  	pageData.currentDataContent = HTMLSource
  })(___arguments.context.pageData));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/joblisting/components/caee238c2f78b361364ba26ca6dd358d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('industries', undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('caee238c2f78b361364ba26ca6dd358d'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('caee238c2f78b361364ba26ca6dd358d'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/joblisting/components/55343ac7f355e5866b258f56b9374e51/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projects-and-services', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/joblisting/components/e3dbcfc8260ddb18fbfa650584ebcb7b/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('about', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/joblisting/components/9274dbcfe0ee894416a264e55332b426/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('careers', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/joblisting/components/c7db3fda439eae33a98479749c1f6cdc/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('employees', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/joblisting/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var WebsiteMode, AppBaseURL, AppURL, _localWebPageDataRoot, _webpageObjectID, _webpageSections;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isPageReady'] = false;
  _webpageObjectID = '0281d4d8-f268-9912-25c4-a9b3245841b8';
  ___arguments.context.pageData['WebpageObjectID'] = _webpageObjectID;
  _webpageSections = ['headerBlock1', 'headerBlock2', 'heroBlock1', 'heroBlock2', 'landingBlock1', 'landingBlock2', 'landingBlock3', 'landingBlock4', 'footerBlock1', 'footerBlock2'];
  ___arguments.context.pageData['_webpageSections'] = (_webpageSections.length);
  ___arguments.context.pageData['WebpageSections'] = _webpageSections;
  _localWebPageDataRoot = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accoweb.pockethost.io/api/collections/webpages/records?filter=(objectId=\'',_webpageObjectID,'\')'].join('')))).setEncoding('utf8').send()), 'items'))[0];
  ___arguments.context.pageData['WebpageDataRoot'] = _localWebPageDataRoot;
  ___arguments.context.pageData['WebpageData'] = (getObjectProperty(_localWebPageDataRoot, 'PageContent'));
  ___arguments.context.pageData['isPageReady'] = true;
  ___arguments.context.pageData['BETAItemsVisible'] = false;
  AppURL = (await BackendlessUI.Functions.Custom['fn_7c99d93c763398d595b7ff4a51c14f57']());
  AppBaseURL = AppURL.slice(0, 23);
  console.log(String('AppBaseURL = ') + String(AppBaseURL));

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var result2, result, currentDataSource, _currentUser, _storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ A PAGE ENTER JUST HAPPENED!!! ############################');
  _storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
  if (_storedTokenFromCookie != null || _storedTokenFromCookie != 'undefined') {
    _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](_storedTokenFromCookie));
    console.log('### CURRENT USER ###');
    console.log(_currentUser);
    if (_currentUser != false) {
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
      if ((getObjectProperty(___arguments.context.appData, 'currentUser.record.BETAModeEnabled')) == true) {
        ___arguments.context.appData['isBETAEnabled'] = true;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = true;
      } else {
        ___arguments.context.appData['isBETAEnabled'] = false;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = false;
      }
    } else {
      ___arguments.context.appData['CurrentUser'] = null;
    }
  }
  ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['taskBarTop'] = true;
  ___arguments.context.pageData['taskBarBottom'] = false;
  ___arguments.context.pageData['hideButtonsMode'] = true;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onEnter */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onResize */
  /* handler:onPageQuery */
  async ['onPageQuery'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.pageQuery, 'debugMode')) == true && (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'currentUser'))))) {
    ___arguments.context.appData['debugMode'] = true;
  } else {
    ___arguments.context.appData['debugMode'] = false;
  }

  },
  /* handler:onPageQuery */
  /* content */
}))

define('./pages/joblisting/components/f6c3d992d48fe05b791cfba8a2c9ea19/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    
  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    
  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/joblisting/components/27b9fd37c4233d555444978939bfe4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/joblisting/components/717adc521cbdf7ca7f3db4188da3a5c7/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classesList = ['modal'];
  if (getObjectProperty(___arguments.context.pageData, 'isOpenModal')) {
    addItemToList(classesList, 'open');
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'blockMouseOverEvent')) != true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('717adc521cbdf7ca7f3db4188da3a5c7', true);
    ___arguments.context.pageData['blockMouseOverEvent'] = true;
  }

  },
  /* handler:onMouseOver */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var result;


  result = (await (async function(pageData) {
  	// Create an array by ClassName 'content_editable' and invoke the function (editable) and create an event listener for each index in the array
  	// const runner = { currentDataSource: ""};
  	
  	var loadFromBlock, HTMLSource;
  	loadFromBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource);
  	console.log ('The data source has been set to: ' + pageData.currentDataSource);
  	HTMLSource = loadFromBlock[0].innerHTML;
  	// loadFromBlock.currentTarget.getAttribute('data-source')
  	tinymce.activeEditor.setContent(HTMLSource);
  	pageData.currentDataContent = HTMLSource
  })(___arguments.context.pageData));

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/joblisting/components/8cd91f8f8d38899143393ed8c8129c7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/joblisting/components/4a16f104bfbce399523c5d8152efe8af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/joblisting/components/e49eae259f43d5e4ed34fbed4c1690f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '8D6FAC01-F4F5-466C-8D61-4C6395519121';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/joblisting/components/d6338723fe754ea845c18574e1db8e3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'B103EFB3-F65C-4F60-A3A7-0CBBB9F80C08';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/joblisting/components/fa5129e49d61d9c6b57287189523e39e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '428FA853-8475-41D5-BEAE-0A758818D0BC';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/joblisting/components/26ebd15ce2f2c1d6f9813d1a00a26054/bundle.js', [], () => ({
  /* content */
  /* handler:onAction */
  async ['onAction'](___arguments) {
    var WebsiteMode, AppBaseURL, AppURL, _localWebPageDataRoot, _webpageObjectID, _webpageSections;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isPageReady'] = false;
  _webpageObjectID = (getObjectProperty(___arguments.context.pageData, 'WebpageObjectID'));
  ___arguments.context.pageData['WebpageObjectID'] = _webpageObjectID;
  _webpageSections = ['headerBlock1', 'headerBlock2', 'heroBlock1', 'heroBlock2', 'landingBlock1', 'landingBlock2', 'landingBlock3', 'landingBlock4', 'footerBlock1', 'footerBlock2'];
  ___arguments.context.pageData['_webpageSections'] = (_webpageSections.length);
  ___arguments.context.pageData['WebpageSections'] = _webpageSections;
  _localWebPageDataRoot = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accoweb.pockethost.io/api/collections/webpages/records?filter=(objectId=\'',_webpageObjectID,'\')'].join('')))).setEncoding('utf8').send()), 'items'))[0];
  ___arguments.context.pageData['WebpageDataRoot'] = _localWebPageDataRoot;
  ___arguments.context.pageData['WebpageData'] = (getObjectProperty(_localWebPageDataRoot, 'PageContent'));
  ___arguments.context.pageData['isPageReady'] = true;
  ___arguments.context.pageData['BETAItemsVisible'] = false;
  AppURL = (await BackendlessUI.Functions.Custom['fn_7c99d93c763398d595b7ff4a51c14f57']());
  AppBaseURL = AppURL.slice(0, 23);
  console.log(String('AppBaseURL = ') + String(AppBaseURL));

  },
  /* handler:onAction */
  /* content */
}))

define('./pages/joblisting/components/54dcab8d080f34d8921bdbb632146cd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();//pageData.currentDataContent;
  	ownerBlock[0].innerHTML = `${sourceContent}`;
  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/joblisting/components/c19816bbc89f510c6b0f61af2ce6e8cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/joblisting/components/868de2a35dc382de3c1cd8fbad23a403/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  blockObjectID = '4645C476-DE2B-4007-9A54-03BBC0D8B746';
  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
       if ((getObjectProperty(item, 'id')) == blockObjectID) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/joblisting/components/f84a59cfd95b86ecac0818e2f8369ed1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '5155423A-F695-4B2F-AADB-4D18281D0F89';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/joblisting/components/7b1cb0a9932c78bfd8d5b79381e54204/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'A512CA81-3F67-48FE-9F52-1773D57EEC5B';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/joblisting/components/8b7ea841affa30d6d4891c06e62e2d89/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogo-mini', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var _currentUser, result2, result, storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.event, 'ctrlKey')) == true && (getObjectProperty(___arguments.event, 'altKey')) == true) {
    ___arguments.context.pageData['hideButtonsMode'] = false;
    storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
    if (storedTokenFromCookie != null || storedTokenFromCookie != '') {
      _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](storedTokenFromCookie));
      if (_currentUser != false) {
        if ((getObjectProperty(_currentUser, 'token')) != '') {
          localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
        }
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
      }
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      ___arguments.context.appData['inAdminMode'] = true;
      ___arguments.context.appData['isLoggedIn'] = true;
      ___arguments.context.pageData['showAdminBar'] = true;
      if ((getObjectProperty(___arguments.context.appData, 'inAdminMode')) == true) {
        result = (await (async function(pageData) {
        	var myFunction = (e)=> {
        	  // console.log(e.currentTarget.getAttribute('data-source'));
        	  e.currentTarget.setAttribute('data-modified','true');
        	  console.log('This element has been marked as data-modified: ' + e.currentTarget.getAttribute('data-source'));
        	}
        	
        	Array.from(document.getElementsByClassName('content_editable')).forEach((editable) => {
        	  // editable.addEventListener('click', myFunction);
        	  editable.addEventListener('click', myFunction);
        	  
        	});
        })(___arguments.context.pageData));
      }
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
    }
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('####### appData.CurrentUser #######');
  console.log(getObjectProperty(___arguments.context.appData, 'CurrentUser'));
  console.log('####### ISLOGGEDIN: #######');
  console.log(getObjectProperty(___arguments.context.appData, 'isLoggedIn'));
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
    if ((getObjectProperty(___arguments.context.appData, 'CurrentUser')) != false) {
      console.log('####### CHECKING IF USER isWebsiteEditor #######');
      result = (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'CurrentUser'))));
      if (result == true) {
        console.log('####### RETURN FROM isWebsiteEditor FUNCTION #######');
        console.log('isWebsiteEditor = ');
        console.log(result);
        console.log('####### HIDE BUTTONS MODE #######');
        console.log(getObjectProperty(___arguments.context.pageData, 'hideButtonsMode'));
        if ((getObjectProperty(___arguments.context.pageData, 'hideButtonsMode')) == true) {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', true);
        } else {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);
        }
      }
    }
  }

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/joblisting/components/e18a76e42143485dabe50caddb6fdd6f/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogoCell-right', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/joblisting/components/3ea61bdd3ad1e562a5185b8204761226/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();
  	pageData.currentDataContent = sourceContent; // added decodeURIComponent for troubleshooting

  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('admin_Webpages').save( ({ 'objectId': (getObjectProperty(___arguments.context.pageData, 'currentDataSource')),'BlockContent': (encodeURIComponent((getObjectProperty(___arguments.context.pageData, 'currentDataContent')))) }) );

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/joblisting/components/19f2f0dacd13571dc9b931385a463b62/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/joblisting/components/cc3a9886128a333e4fb5d24ca934c255/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  return (['You are logged on as: ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'CurrentUser')), 'record')), 'name')),' | CTRL + ALT Click on your logo to turn edit mode back on again.'].join(''));

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/joblisting/components/0b76d57506286594c0a8661497f83bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'C1F6E9F5-7F62-4DEC-87C0-70A43E04649C';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/joblisting/components/2c8b9e4890a8d3682f75191685183968/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('subcontractors', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2c8b9e4890a8d3682f75191685183968'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2c8b9e4890a8d3682f75191685183968'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/lightbox/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
    
  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/lightbox/components/caee238c2f78b361364ba26ca6dd358d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('industries', undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('caee238c2f78b361364ba26ca6dd358d'))['font-weight'] = 'bold';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('caee238c2f78b361364ba26ca6dd358d'))['font-weight'] = 'normal';

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/lightbox/components/55343ac7f355e5866b258f56b9374e51/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['font-weight'] = 'bold';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['font-weight'] = 'normal';

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/lightbox/components/e3dbcfc8260ddb18fbfa650584ebcb7b/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['font-weight'] = 'bold';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['font-weight'] = 'normal';

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/projects-and-services/components/55343ac7f355e5866b258f56b9374e51/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    
  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projects-and-services', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) == 'projects-and-services') {
    if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
      return ['easeInAndOut', 'underline'];
    } else {
      return ['hide-beta', 'easeInAndOut', 'underline'];
    }
  } else {
    if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
      return ['easeInAndOut'];
    } else {
      return ['hide-beta', 'easeInAndOut'];
    }
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projects-and-services/components/e3dbcfc8260ddb18fbfa650584ebcb7b/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('about', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) == 'about') {
    if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
      return ['easeInAndOut', 'underline'];
    } else {
      return ['hide-beta', 'easeInAndOut', 'underline'];
    }
  } else {
    if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
      return ['easeInAndOut'];
    } else {
      return ['hide-beta', 'easeInAndOut'];
    }
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projects-and-services/components/9274dbcfe0ee894416a264e55332b426/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('subcontractors', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projects-and-services/components/c7db3fda439eae33a98479749c1f6cdc/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('employees', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projects-and-services/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var WebsiteMode, AppBaseURL, AppURL, _localWebPageDataRoot, _webpageObjectID, _webpageSections;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ AN - ON BEFORE PAGE ENTER - EVENT JUST HAPPENED!!! ############################');
  ___arguments.context.pageData['isPageReady'] = false;
  _webpageObjectID = 'd3963408-3018-a188-7188-97f8e0382ffd';
  ___arguments.context.pageData['WebpageObjectID'] = _webpageObjectID;
  _webpageSections = ['headerBlock1', 'headerBlock2', 'heroBlock1', 'heroBlock2', 'landingBlock1', 'landingBlock2', 'landingBlock3', 'landingBlock4', 'footerBlock1', 'footerBlock2'];
  ___arguments.context.pageData['_webpageSections'] = (_webpageSections.length);
  ___arguments.context.pageData['WebpageSections'] = _webpageSections;
  _localWebPageDataRoot = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accoweb.pockethost.io/api/collections/webpages/records?filter=(objectId=\'',_webpageObjectID,'\')'].join('')))).setEncoding('utf8').send()), 'items'))[0];
  ___arguments.context.pageData['WebpageDataRoot'] = _localWebPageDataRoot;
  ___arguments.context.pageData['WebpageData'] = (getObjectProperty(_localWebPageDataRoot, 'PageContent'));
  ___arguments.context.pageData['isPageReady'] = true;
  ___arguments.context.pageData['BETAItemsVisible'] = false;
  AppURL = (await BackendlessUI.Functions.Custom['fn_7c99d93c763398d595b7ff4a51c14f57']());
  AppBaseURL = AppURL.slice(0, 23);
  console.log(String('AppBaseURL = ') + String(AppBaseURL));

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var result2, result, currentDataSource, _currentUser, _storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ A PAGE ENTER JUST HAPPENED!!! ############################');
  _storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
  if (_storedTokenFromCookie != null || _storedTokenFromCookie != 'undefined') {
    _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](_storedTokenFromCookie));
    console.log('### CURRENT USER ###');
    console.log(_currentUser);
    if (_currentUser != false) {
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
      if ((getObjectProperty(___arguments.context.appData, 'currentUser.record.BETAModeEnabled')) == true) {
        ___arguments.context.appData['isBETAEnabled'] = true;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = true;
      } else {
        ___arguments.context.appData['isBETAEnabled'] = false;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = false;
      }
    } else {
      ___arguments.context.appData['CurrentUser'] = null;
    }
  }
  ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['taskBarTop'] = true;
  ___arguments.context.pageData['taskBarBottom'] = false;
  ___arguments.context.pageData['hideButtonsMode'] = true;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onEnter */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onResize */
  /* handler:onPageQuery */
  async ['onPageQuery'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.pageQuery, 'debugMode')) == true && (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'currentUser'))))) {
    ___arguments.context.appData['debugMode'] = true;
  } else {
    ___arguments.context.appData['debugMode'] = false;
  }

  },
  /* handler:onPageQuery */
  /* content */
}))

define('./pages/projects-and-services/components/f6c3d992d48fe05b791cfba8a2c9ea19/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 1;
  	video.playbackRate = 1;
  	video.play();
  })();

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 0;
  	video.playbackRate = 1;
  	video.pause();
  })();

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/projects-and-services/components/27b9fd37c4233d555444978939bfe4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projects-and-services/components/4a16f104bfbce399523c5d8152efe8af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projects-and-services/components/e49eae259f43d5e4ed34fbed4c1690f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '8D6FAC01-F4F5-466C-8D61-4C6395519121';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projects-and-services/components/d6338723fe754ea845c18574e1db8e3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'B103EFB3-F65C-4F60-A3A7-0CBBB9F80C08';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projects-and-services/components/fa5129e49d61d9c6b57287189523e39e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '428FA853-8475-41D5-BEAE-0A758818D0BC';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projects-and-services/components/26ebd15ce2f2c1d6f9813d1a00a26054/bundle.js', [], () => ({
  /* content */
  /* handler:onAction */
  async ['onAction'](___arguments) {
      await (async function() {
  	window.location.reload()
  })();

  },
  /* handler:onAction */
  /* content */
}))

define('./pages/projects-and-services/components/54dcab8d080f34d8921bdbb632146cd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();//pageData.currentDataContent;
  	ownerBlock[0].innerHTML = `${sourceContent}`;
  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projects-and-services/components/c19816bbc89f510c6b0f61af2ce6e8cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projects-and-services/components/868de2a35dc382de3c1cd8fbad23a403/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  blockObjectID = '4645C476-DE2B-4007-9A54-03BBC0D8B746';
  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
       if ((getObjectProperty(item, 'id')) == blockObjectID) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projects-and-services/components/4ab52bf14234a3b76ef19002bc343042/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '4087A0EA-27D1-45A5-97A2-9E787C8323E6';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projects-and-services/components/f84a59cfd95b86ecac0818e2f8369ed1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '5155423A-F695-4B2F-AADB-4D18281D0F89';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projects-and-services/components/7b1cb0a9932c78bfd8d5b79381e54204/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'A512CA81-3F67-48FE-9F52-1773D57EEC5B';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projects-and-services/components/8b7ea841affa30d6d4891c06e62e2d89/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogo-mini', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var _currentUser, result2, result, storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.event, 'ctrlKey')) == true && (getObjectProperty(___arguments.event, 'altKey')) == true) {
    ___arguments.context.pageData['hideButtonsMode'] = false;
    storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
    if (storedTokenFromCookie != null || storedTokenFromCookie != '') {
      _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](storedTokenFromCookie));
      if (_currentUser != false) {
        if ((getObjectProperty(_currentUser, 'token')) != '') {
          localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
        }
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
      }
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      ___arguments.context.appData['inAdminMode'] = true;
      ___arguments.context.appData['isLoggedIn'] = true;
      ___arguments.context.pageData['showAdminBar'] = true;
    } else {
      console.log('####### THE COOKIE IS NOT NULL!!! #######');
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
    }
    console.log(___arguments.event);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('####### appData.CurrentUser #######');
  console.log(getObjectProperty(___arguments.context.appData, 'CurrentUser'));
  console.log('####### ISLOGGEDIN: #######');
  console.log(getObjectProperty(___arguments.context.appData, 'isLoggedIn'));
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
    if ((getObjectProperty(___arguments.context.appData, 'CurrentUser')) != false) {
      console.log('####### CHECKING IF USER isWebsiteEditor #######');
      result = (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'CurrentUser'))));
      if (result == true) {
        console.log('####### RETURN FROM isWebsiteEditor FUNCTION #######');
        console.log('isWebsiteEditor = ');
        console.log(result);
        console.log('####### HIDE BUTTONS MODE #######');
        console.log(getObjectProperty(___arguments.context.pageData, 'hideButtonsMode'));
        if ((getObjectProperty(___arguments.context.pageData, 'hideButtonsMode')) == true) {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', true);
        } else {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);
        }
      }
    }
  }

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/projects-and-services/components/e18a76e42143485dabe50caddb6fdd6f/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogoCell-right', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/projects-and-services/components/3ea61bdd3ad1e562a5185b8204761226/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();
  	pageData.currentDataContent = sourceContent; // added decodeURIComponent for troubleshooting

  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('admin_Webpages').save( ({ 'objectId': (getObjectProperty(___arguments.context.pageData, 'currentDataSource')),'BlockContent': (encodeURIComponent((getObjectProperty(___arguments.context.pageData, 'currentDataContent')))) }) );

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/projects-and-services/components/19f2f0dacd13571dc9b931385a463b62/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/projects-and-services/components/cc3a9886128a333e4fb5d24ca934c255/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  return (['You are logged on as: ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'CurrentUser')), 'record')), 'name')),' | CTRL + ALT Click on your logo to turn edit mode back on again.'].join(''));

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projects-and-services/components/0b76d57506286594c0a8661497f83bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'C1F6E9F5-7F62-4DEC-87C0-70A43E04649C';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projects-and-services/components/226882c510580398880a31741218b794/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('careers', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) == 'careers') {
    if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
      return ['easeInAndOut', 'underline'];
    } else {
      return ['hide-beta', 'easeInAndOut', 'underline'];
    }
  } else {
    if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
      return ['easeInAndOut'];
    } else {
      return ['hide-beta', 'easeInAndOut'];
    }
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/projects-and-services/components/ac5384a89159966cc8681bfea27aa946/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('industries', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projects-and-services/components/f96298252c8b58c3630720c3f3968e33/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var result2, result;

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  result = (await (async function(pageData, HTMLSource, tinydrive_dropbox_app_key, created_jwt_token) {
  	/*
  	
  	// Plugins that we probably will need: mediaembed, export linkchecker?, powerpaste, advtable, editimage, autocorrect, typography, checklist
  	Existing plugins backup: 'tinydrive code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
  	Removed from below: 
  	toolbar_sticky: true,
  	toolbar_mode: 'floating', // Modes: floating, sliding, scrolling, wrap
  	
  	*/
  	
  	const editor = await BackendlessUI.requireModule('https://cdn.tiny.cloud/1/dwt7je7v9gjog7a8oc867xici2xmy80whuw0asnvstr20590/tinymce/8/tinymce.min.js')
  	tinymce.init({ selector: '.TinyMCETextEditor',
  	plugins: 'tinydrive code anchor link charmap codesample emoticons image lists media searchreplace table visualblocks wordcount',
  	toolbar: 'undo redo | blocks fontfamily fontsize | fontsizeselect | forecolor backcolor | bold italic underline strikethrough blockquote | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat | code',
  	font_family_formats: 'Andale Mono="Andale Mono"; Arial=arial; Arial Black="arial black"; Book Antiqua = "book antiqua"; Comic Sans MS="Comic Sans MS"; Courier New=courier new,courier,monospace; Georgia=georgia; Helvetica=helvetica; Impact=impact; Tahoma=tahoma; Terminal=terminal; Times New Roman="times new roman"; Trebuchet MS = "trebuchet ms"; Sans Serif="sans serif"; Segoe UI=segoe ui; Verdana=verdana; Webdings=webdings; Wingdings=wingdings',
  	font_size_formats: "8px 10px 12px 14px 16px 18px 20px 24px 30px 36px 48px 60px 72px 96px",
  	relative_urls : true,
  	remove_script_host : false,
  	document_base_url : 'https://www.accofg.com/',
  	tinydrive_dropbox_app_key: tinydrive_dropbox_app_key,
  	tinydrive_token_provider: (success, failure) => {
  	        success({ token:  created_jwt_token });
  	  },
  	setup: function (editor) {
  	      editor.on('init', function (e) {
  	        editor.setContent(HTMLSource);
  	      });
  	  }
  	
  	}) //#${id}`}) `this was inside a template string`
  	
  	// document.getElementById('btnUpdateContent').addEventListener("click", saveContent)
  	
  	function saveContent() {
  	const myContent = tinymce.activeEditor.getContent()
  	pageData.myContent = myContent
  	}

  })(___arguments.context.pageData, (getObjectProperty(___arguments.context.pageData, 'currentDataContent')), '7svncuz1u3xumyc', (getObjectProperty(((function () { return BackendlessUI.getCustomSettings() })()), 'created_jwt_token'))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projects-and-services/components/859df6fc47f553256c989f7c2b88adcc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isOpenModal'))

  },
  /* handler:onDisplayAssignment */
  /* handler:modalVisibilityLogic */
  ['modalVisibilityLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isOpenModal'))

  },
  /* handler:modalVisibilityLogic */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;

  },
  /* handler:onClose */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    var result;


  console.log('Modal: (OnVisibilityChange) Modal Visible | Content Pushed to TinyMCE in the modal__card.OnVisible Event');

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/projects-and-services/components/71dd7f53b1157583c11cd04885411f04/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var result;


  result = (await (async function(pageData) {
  	// Create an array by ClassName 'content_editable' and invoke the function (editable) and create an event listener for each index in the array
  	// const runner = { currentDataSource: ""};
  	
  	var loadFromBlock, HTMLSource;
  	loadFromBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource);
  	console.log ('modal__card: OnMounted: The data source has been set to: ' + pageData.currentDataSource);
  	HTMLSource = loadFromBlock[0].innerHTML;
  	// loadFromBlock.currentTarget.getAttribute('data-source')
  	tinymce.activeEditor.setContent(HTMLSource);
  	pageData.currentDataContent = HTMLSource
  })(___arguments.context.pageData));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/subcontractors/components/55343ac7f355e5866b258f56b9374e51/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55343ac7f355e5866b258f56b9374e51'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projects-and-services', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/subcontractors/components/e3dbcfc8260ddb18fbfa650584ebcb7b/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e3dbcfc8260ddb18fbfa650584ebcb7b'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('about', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/subcontractors/components/9274dbcfe0ee894416a264e55332b426/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9274dbcfe0ee894416a264e55332b426'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    
  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('subcontractors', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) == 'subcontractors') {
    if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
      return ['easeInAndOut', 'underline'];
    } else {
      return ['hide-beta', 'easeInAndOut', 'underline'];
    }
  } else {
    if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
      return ['easeInAndOut'];
    } else {
      return ['hide-beta', 'easeInAndOut'];
    }
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/subcontractors/components/c7db3fda439eae33a98479749c1f6cdc/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7db3fda439eae33a98479749c1f6cdc'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('employees', undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/subcontractors/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var WebsiteMode, AppBaseURL, AppURL, _localWebPageDataRoot, _webpageObjectID, _webpageSections;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ AN - ON BEFORE PAGE ENTER - EVENT JUST HAPPENED!!! ############################');
  ___arguments.context.pageData['isPageReady'] = false;
  _webpageObjectID = 'f1c34c33-f2ca-670d-2428-2c988fd81438';
  ___arguments.context.pageData['WebpageObjectID'] = _webpageObjectID;
  _webpageSections = ['headerBlock1', 'headerBlock2', 'heroBlock1', 'heroBlock2', 'landingBlock1', 'landingBlock2', 'landingBlock3', 'landingBlock4', 'footerBlock1', 'footerBlock2'];
  ___arguments.context.pageData['_webpageSections'] = (_webpageSections.length);
  ___arguments.context.pageData['WebpageSections'] = _webpageSections;
  _localWebPageDataRoot = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://accoweb.pockethost.io/api/collections/webpages/records?filter=(objectId=\'',_webpageObjectID,'\')'].join('')))).setEncoding('utf8').send()), 'items'))[0];
  ___arguments.context.pageData['WebpageDataRoot'] = _localWebPageDataRoot;
  ___arguments.context.pageData['WebpageData'] = (getObjectProperty(_localWebPageDataRoot, 'PageContent'));
  ___arguments.context.pageData['isPageReady'] = true;
  ___arguments.context.pageData['BETAItemsVisible'] = false;
  AppURL = (await BackendlessUI.Functions.Custom['fn_7c99d93c763398d595b7ff4a51c14f57']());
  AppBaseURL = AppURL.slice(0, 23);
  console.log(String('AppBaseURL = ') + String(AppBaseURL));

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var result2, result, currentDataSource, _currentUser, _storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('############################ A PAGE ENTER JUST HAPPENED!!! ############################');
  _storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
  if (_storedTokenFromCookie != null || _storedTokenFromCookie != 'undefined') {
    _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](_storedTokenFromCookie));
    console.log('### CURRENT USER ###');
    console.log(_currentUser);
    if (_currentUser != false) {
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
      if ((getObjectProperty(___arguments.context.appData, 'currentUser.record.BETAModeEnabled')) == true) {
        ___arguments.context.appData['isBETAEnabled'] = true;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = true;
      } else {
        ___arguments.context.appData['isBETAEnabled'] = false;
        ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = false;
      }
    } else {
      ___arguments.context.appData['CurrentUser'] = null;
    }
  }
  ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['taskBarTop'] = true;
  ___arguments.context.pageData['taskBarBottom'] = false;
  ___arguments.context.pageData['hideButtonsMode'] = true;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onEnter */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 1252) {
    ___arguments.context.pageData['viewMode'] = 'Desktop';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 801 && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 1252) {
    ___arguments.context.pageData['viewMode'] = 'Tablet';
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600) {
    ___arguments.context.pageData['viewMode'] = 'Phone';
  }

  },
  /* handler:onResize */
  /* handler:onPageQuery */
  async ['onPageQuery'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.pageQuery, 'debugMode')) == true && (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'currentUser'))))) {
    ___arguments.context.appData['debugMode'] = true;
  } else {
    ___arguments.context.appData['debugMode'] = false;
  }

  },
  /* handler:onPageQuery */
  /* content */
}))

define('./pages/subcontractors/components/f6c3d992d48fe05b791cfba8a2c9ea19/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 1;
  	video.playbackRate = 1;
  	video.play();
  })();

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await (async function() {
  	const video = document.getElementsByTagName('video')[0]
  	video.muted = true;
  	// video.currentTime = 0;
  	video.playbackRate = 1;
  	video.pause();
  })();

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/subcontractors/components/27b9fd37c4233d555444978939bfe4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/subcontractors/components/4a16f104bfbce399523c5d8152efe8af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/subcontractors/components/e49eae259f43d5e4ed34fbed4c1690f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '8D6FAC01-F4F5-466C-8D61-4C6395519121';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/subcontractors/components/d6338723fe754ea845c18574e1db8e3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'B103EFB3-F65C-4F60-A3A7-0CBBB9F80C08';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/subcontractors/components/fa5129e49d61d9c6b57287189523e39e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '428FA853-8475-41D5-BEAE-0A758818D0BC';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/subcontractors/components/26ebd15ce2f2c1d6f9813d1a00a26054/bundle.js', [], () => ({
  /* content */
  /* handler:onAction */
  async ['onAction'](___arguments) {
      await (async function() {
  	window.location.reload()
  })();

  },
  /* handler:onAction */
  /* content */
}))

define('./pages/subcontractors/components/54dcab8d080f34d8921bdbb632146cd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();//pageData.currentDataContent;
  	ownerBlock[0].innerHTML = `${sourceContent}`;
  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/subcontractors/components/c19816bbc89f510c6b0f61af2ce6e8cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/subcontractors/components/868de2a35dc382de3c1cd8fbad23a403/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  blockObjectID = '4645C476-DE2B-4007-9A54-03BBC0D8B746';
  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
       if ((getObjectProperty(item, 'id')) == blockObjectID) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/subcontractors/components/4ab52bf14234a3b76ef19002bc343042/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '4087A0EA-27D1-45A5-97A2-9E787C8323E6';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/subcontractors/components/f84a59cfd95b86ecac0818e2f8369ed1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = '5155423A-F695-4B2F-AADB-4D18281D0F89';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/subcontractors/components/7b1cb0a9932c78bfd8d5b79381e54204/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'A512CA81-3F67-48FE-9F52-1773D57EEC5B';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/subcontractors/components/8b7ea841affa30d6d4891c06e62e2d89/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogo-full', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogo-mini', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var _currentUser, result2, result, storedTokenFromCookie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.event, 'ctrlKey')) == true && (getObjectProperty(___arguments.event, 'altKey')) == true) {
    ___arguments.context.pageData['hideButtonsMode'] = false;
    storedTokenFromCookie = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken'));
    if (storedTokenFromCookie != null || storedTokenFromCookie != '') {
      _currentUser = (await BackendlessUI.Functions.Custom['fn_1daef9594124e1d1dda1414d88be10bd'](storedTokenFromCookie));
      if (_currentUser != false) {
        if ((getObjectProperty(_currentUser, 'token')) != '') {
          localStorage.setItem('ACCOWebToken', JSON.stringify((getObjectProperty(_currentUser, 'token'))));
        }
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
      }
      ___arguments.context.appData['CurrentUser'] = _currentUser;
      ___arguments.context.appData['inAdminMode'] = true;
      ___arguments.context.appData['isLoggedIn'] = true;
      ___arguments.context.pageData['showAdminBar'] = true;
    } else {
      console.log('####### THE COOKIE IS NOT NULL!!! #######');
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin', undefined);
    }
    console.log(___arguments.event);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('####### appData.CurrentUser #######');
  console.log(getObjectProperty(___arguments.context.appData, 'CurrentUser'));
  console.log('####### ISLOGGEDIN: #######');
  console.log(getObjectProperty(___arguments.context.appData, 'isLoggedIn'));
  if ((getObjectProperty(___arguments.context.appData, 'isLoggedIn')) == true) {
    if ((getObjectProperty(___arguments.context.appData, 'CurrentUser')) != false) {
      console.log('####### CHECKING IF USER isWebsiteEditor #######');
      result = (await BackendlessUI.Functions.Custom['fn_476e0b7c9ee7ae9ea5da774edbe841c1']((getObjectProperty(___arguments.context.appData, 'CurrentUser'))));
      if (result == true) {
        console.log('####### RETURN FROM isWebsiteEditor FUNCTION #######');
        console.log('isWebsiteEditor = ');
        console.log(result);
        console.log('####### HIDE BUTTONS MODE #######');
        console.log(getObjectProperty(___arguments.context.pageData, 'hideButtonsMode'));
        if ((getObjectProperty(___arguments.context.pageData, 'hideButtonsMode')) == true) {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', true);
        } else {
          await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);
        }
      }
    }
  }

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/subcontractors/components/e18a76e42143485dabe50caddb6fdd6f/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Desktop') {
    return ['companyLogoCell-right', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Tablet') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewMode')) == 'Phone') {
    return ['companyLogoCell-left', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/subcontractors/components/3ea61bdd3ad1e562a5185b8204761226/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['blockMouseOverEvent'] = false;
  await (async function(pageData) {
  	var ownerBlock;
  	var sourceContent;
  	ownerBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource); // set reference to owner block control
  	sourceContent = tinymce.activeEditor.getContent();
  	pageData.currentDataContent = sourceContent; // added decodeURIComponent for troubleshooting

  })(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('admin_Webpages').save( ({ 'objectId': (getObjectProperty(___arguments.context.pageData, 'currentDataSource')),'BlockContent': (encodeURIComponent((getObjectProperty(___arguments.context.pageData, 'currentDataContent')))) }) );

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/subcontractors/components/19f2f0dacd13571dc9b931385a463b62/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('19f2f0dacd13571dc9b931385a463b62', false);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/subcontractors/components/cc3a9886128a333e4fb5d24ca934c255/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  return (['You are logged on as: ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'CurrentUser')), 'record')), 'name')),' | CTRL + ALT Click on your logo to turn edit mode back on again.'].join(''));

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/subcontractors/components/0b76d57506286594c0a8661497f83bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    blockObjectID = 'C1F6E9F5-7F62-4DEC-87C0-70A43E04649C';
    if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
      thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
         if ((getObjectProperty(item, 'id')) == blockObjectID) {
          decision = true;
        } else {
          decision = false;
        }


       return decision;
      }));
    }
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/subcontractors/components/226882c510580398880a31741218b794/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('careers', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('226882c510580398880a31741218b794'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/subcontractors/components/ac5384a89159966cc8681bfea27aa946/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ac5384a89159966cc8681bfea27aa946'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('industries', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'isBETAEnabled'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/subcontractors/components/f96298252c8b58c3630720c3f3968e33/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var result2, result;

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  result = (await (async function(pageData, HTMLSource, tinydrive_dropbox_app_key, created_jwt_token) {
  	/*
  	
  	// Plugins that we probably will need: mediaembed, export linkchecker?, powerpaste, advtable, editimage, autocorrect, typography, checklist
  	Existing plugins backup: 'tinydrive code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
  	Removed from below: 
  	toolbar_sticky: true,
  	toolbar_mode: 'floating', // Modes: floating, sliding, scrolling, wrap
  	
  	*/
  	
  	const editor = await BackendlessUI.requireModule('https://cdn.tiny.cloud/1/dwt7je7v9gjog7a8oc867xici2xmy80whuw0asnvstr20590/tinymce/8/tinymce.min.js')
  	tinymce.init({ selector: '.TinyMCETextEditor',
  	plugins: 'tinydrive code anchor link charmap codesample emoticons image lists media searchreplace table visualblocks wordcount',
  	toolbar: 'undo redo | blocks fontfamily fontsize | fontsizeselect | forecolor backcolor | bold italic underline strikethrough blockquote | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat | code',
  	font_family_formats: 'Andale Mono="Andale Mono"; Arial=arial; Arial Black="arial black"; Book Antiqua = "book antiqua"; Comic Sans MS="Comic Sans MS"; Courier New=courier new,courier,monospace; Georgia=georgia; Helvetica=helvetica; Impact=impact; Tahoma=tahoma; Terminal=terminal; Times New Roman="times new roman"; Trebuchet MS = "trebuchet ms"; Sans Serif="sans serif"; Segoe UI=segoe ui; Verdana=verdana; Webdings=webdings; Wingdings=wingdings',
  	font_size_formats: "8px 10px 12px 14px 16px 18px 20px 24px 30px 36px 48px 60px 72px 96px",
  	relative_urls : true,
  	remove_script_host : false,
  	document_base_url : 'https://www.accofg.com/',
  	tinydrive_dropbox_app_key: tinydrive_dropbox_app_key,
  	tinydrive_token_provider: (success, failure) => {
  	        success({ token:  created_jwt_token });
  	  },
  	setup: function (editor) {
  	      editor.on('init', function (e) {
  	        editor.setContent(HTMLSource);
  	      });
  	  }
  	
  	}) //#${id}`}) `this was inside a template string`
  	
  	// document.getElementById('btnUpdateContent').addEventListener("click", saveContent)
  	
  	function saveContent() {
  	const myContent = tinymce.activeEditor.getContent()
  	pageData.myContent = myContent
  	}

  })(___arguments.context.pageData, (getObjectProperty(___arguments.context.pageData, 'currentDataContent')), '7svncuz1u3xumyc', (getObjectProperty(((function () { return BackendlessUI.getCustomSettings() })()), 'created_jwt_token'))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/subcontractors/components/859df6fc47f553256c989f7c2b88adcc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isOpenModal'))

  },
  /* handler:onDisplayAssignment */
  /* handler:modalVisibilityLogic */
  ['modalVisibilityLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isOpenModal'))

  },
  /* handler:modalVisibilityLogic */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;

  },
  /* handler:onClose */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    var result;


  console.log('Modal: (OnVisibilityChange) Modal Visible | Content Pushed to TinyMCE in the modal__card.OnVisible Event');

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/subcontractors/components/71dd7f53b1157583c11cd04885411f04/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var result;


  result = (await (async function(pageData) {
  	// Create an array by ClassName 'content_editable' and invoke the function (editable) and create an event listener for each index in the array
  	// const runner = { currentDataSource: ""};
  	
  	var loadFromBlock, HTMLSource;
  	loadFromBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource);
  	console.log ('modal__card: OnMounted: The data source has been set to: ' + pageData.currentDataSource);
  	HTMLSource = loadFromBlock[0].innerHTML;
  	// loadFromBlock.currentTarget.getAttribute('data-source')
  	tinymce.activeEditor.setContent(HTMLSource);
  	pageData.currentDataContent = HTMLSource
  })(___arguments.context.pageData));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/version/components/e56c223c2ff4cb9b65c9147101973505/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://www.accofg.com', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/version/components/bbd357067ce80b2f26a1c7a3d71eb803/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function readFileContent(encoding, result) {
    if (!encoding) {
      if (typeof Buffer !== 'undefined') {
        return result instanceof Buffer
          ? result.toJSON().data
          : Buffer.from(JSON.stringify(result)).toJSON().data
      }

      return result
    }

    if (result && typeof result === 'object') {
      return JSON.stringify(result)
    }

    return result
}



  return (await Backendless.Request.get((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})(encodePath('https://dev.hyperpixels.net/api/files/web/ACCOFGWeb/version.txt'))).setEncoding('utf8').then(result => readFileContent('utf8', result)))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_726cd929d429c6e4b1036e945bbfba1e/logic/90bac6e57c011e8316afe13568e29da5/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d09f4d28c58125a4012e1443f1367509'))['text'] = 'info@accofg.com';
  await (async function() {
  	var a = document.getElementsByClassName('emailuslink'); //or grab it by tagname etc
  	a[0].href = "mailto:info@accofg.com"
  })();

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d09f4d28c58125a4012e1443f1367509'))['text'] = 'Email Us';
  await (async function() {
  	var a = document.getElementsByClassName('emailuslink'); //or grab it by tagname etc
  	a[0].href = "mailto:undefined"
  })();

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./components/reusable/r_726cd929d429c6e4b1036e945bbfba1e/logic/d09f4d28c58125a4012e1443f1367509/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d09f4d28c58125a4012e1443f1367509'))['color'] = 'crimson';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d09f4d28c58125a4012e1443f1367509'))['color'] = 'white';

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./components/reusable/r_726cd929d429c6e4b1036e945bbfba1e/logic/300c980d76424a13b64788aad768898e/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('300c980d76424a13b64788aad768898e'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('300c980d76424a13b64788aad768898e'))['color'] = 'white';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://www.facebook.com/accofg', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_726cd929d429c6e4b1036e945bbfba1e/logic/7d28f5675648b2b8723fa38590687b41/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7d28f5675648b2b8723fa38590687b41'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7d28f5675648b2b8723fa38590687b41'))['color'] = 'white';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://www.linkedin.com/company/anderson-construction-company-of-fort-gaines/', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_726cd929d429c6e4b1036e945bbfba1e/logic/6ffb65b9c5165a9712bbb3bcbf425dfe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  blockObjectID = '1AC64B77-8F6F-4F07-8A6E-12409E539A9C';
  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
       if ((getObjectProperty(item, 'id')) == blockObjectID) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_726cd929d429c6e4b1036e945bbfba1e/logic/ef44e3b54c91f8b6d036fd417ebb4127/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ef44e3b54c91f8b6d036fd417ebb4127'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ef44e3b54c91f8b6d036fd417ebb4127'))['color'] = 'white';

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./components/reusable/r_726cd929d429c6e4b1036e945bbfba1e/logic/051b08fd32bf3c1ce0df8c5bb31fa28f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  blockObjectID = '6C183D8A-DE50-4E10-AF62-F0F906CEFACF';
  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
       if ((getObjectProperty(item, 'id')) == blockObjectID) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_726cd929d429c6e4b1036e945bbfba1e/logic/9ef9509e372855e8f2b89ff80df8c348/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'WebpageObjectID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_e1b77c920e14b60673f215a2f42f48cb/logic/90bac6e57c011e8316afe13568e29da5/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d09f4d28c58125a4012e1443f1367509'))['text'] = 'info@accofg.com';
  await (async function() {
  	var a = document.getElementsByClassName('emailuslink'); //or grab it by tagname etc
  	a[0].href = "mailto:info@accofg.com"
  })();

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d09f4d28c58125a4012e1443f1367509'))['text'] = 'Email Us';
  await (async function() {
  	var a = document.getElementsByClassName('emailuslink'); //or grab it by tagname etc
  	a[0].href = "mailto:undefined"
  })();

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./components/reusable/r_e1b77c920e14b60673f215a2f42f48cb/logic/d09f4d28c58125a4012e1443f1367509/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d09f4d28c58125a4012e1443f1367509'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d09f4d28c58125a4012e1443f1367509'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./components/reusable/r_e1b77c920e14b60673f215a2f42f48cb/logic/300c980d76424a13b64788aad768898e/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('300c980d76424a13b64788aad768898e'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('300c980d76424a13b64788aad768898e'))['color'] = 'white';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://www.facebook.com/accofg', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_e1b77c920e14b60673f215a2f42f48cb/logic/7d28f5675648b2b8723fa38590687b41/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7d28f5675648b2b8723fa38590687b41'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7d28f5675648b2b8723fa38590687b41'))['color'] = 'white';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://www.linkedin.com/company/anderson-construction-company-of-fort-gaines/', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_e1b77c920e14b60673f215a2f42f48cb/logic/6ffb65b9c5165a9712bbb3bcbf425dfe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  blockObjectID = '1AC64B77-8F6F-4F07-8A6E-12409E539A9C';
  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
       if ((getObjectProperty(item, 'id')) == blockObjectID) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_e1b77c920e14b60673f215a2f42f48cb/logic/ef44e3b54c91f8b6d036fd417ebb4127/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ef44e3b54c91f8b6d036fd417ebb4127'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ef44e3b54c91f8b6d036fd417ebb4127'))['color'] = 'white';

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./components/reusable/r_e1b77c920e14b60673f215a2f42f48cb/logic/051b08fd32bf3c1ce0df8c5bb31fa28f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  blockObjectID = '6C183D8A-DE50-4E10-AF62-F0F906CEFACF';
  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
       if ((getObjectProperty(item, 'id')) == blockObjectID) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_e1b77c920e14b60673f215a2f42f48cb/logic/9ef9509e372855e8f2b89ff80df8c348/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'WebpageObjectID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_e6ee56dcb77237f6e25fce48185708e3/logic/7dbef2fdfb5ce67e529d29023d486af5/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'taskBarTop')) == true) {
    return ['taskBar-top', 'easeInAndOut'];
  } else {
    return ['taskBar-bottom', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./components/reusable/r_e6ee56dcb77237f6e25fce48185708e3/logic/41a733c49e49c93f1865eeb65dd55c21/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['taskBarTop'] = false;
  ___arguments.context.pageData['taskBarBottom'] = (!(getObjectProperty(___arguments.context.pageData, 'taskBarTop')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'taskBarBottom')) != true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_e6ee56dcb77237f6e25fce48185708e3/logic/88719f2b76f7597ab457ed18de1c8fab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['taskBarTop'] = true;
  ___arguments.context.pageData['taskBarBottom'] = (!(getObjectProperty(___arguments.context.pageData, 'taskBarTop')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'taskBarTop')) != true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_e6ee56dcb77237f6e25fce48185708e3/logic/1cf810357e1736ae1334fb2b92dd8cf9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var result;


  await (async function() {
  	const el = document.querySelectorAll('.content_editable')
  	for (let i = 0; i < el.length; i++) {
  	el[i].setAttribute('contenteditable', 'false')
  	el[i].setAttribute('data-modified','false')
  	}
  })();
  ___arguments.context.pageData['editingPage'] = false;
  ___arguments.context.pageData['inEditMode'] = false;
  ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['isDrawerOpen'] = false;
  result = (await (async function(pageData) {
  	
  	Array.from(document.getElementsByClassName("content_editable")).forEach((editable) => {
  	  
  	  // editable.removeEventListener("click", myFunction);
  	  editable.removeEventListener("click", window.___MY_EVENT_LISTENER1);
  	  editable.removeEventListener("dblclick", window.___MY_EVENT_LISTENER2);
  	  
  	});
  })(___arguments.context.pageData));
  await (async function() {
  	await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('26ebd15ce2f2c1d6f9813d1a00a26054', true, true, '', 'Edit mode has been cancelled.', 'warning');
  })();

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'editingPage')) == true) {
    return true;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_e6ee56dcb77237f6e25fce48185708e3/logic/c2a713898dab8e5bcc146d2f63a1925b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var result2, result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	const el = document.querySelectorAll('.content_editable')
  	
  	for (let i = 0; i < el.length; i++) {
  	let theDataID = el[i].classList.item(0);
  	theDataID = theDataID.substring(5);
  	el[i].setAttribute('contenteditable', 'true')
  	// el[i].setAttribute('data-modified','true') // We're now only modifying this attribute when the user clicks on the element.
  	el[i].setAttribute('data-source',theDataID)
  	
  	}
  })();
  result = (await (async function(pageData) {
  	const myFunction = (e)=> {
  	  e.currentTarget.setAttribute('data-modified','true');
  	  console.log(e.currentTarget.getAttribute('data-source') + " modified");        
  	}
  	
  	const myFunction2 = (e)=> {
  	  pageData.currentDataSource = e.currentTarget.getAttribute('data-source'); // Above code MUST be set to currentTarget to trap the element's event that the code is actually running from.
  	  console.log("(Toolbar: Edit Method) pageData.currentDataSource =: "+ pageData.currentDataSource);
  	  // pageData.isOpenModal = true;
  	  pageData.isDrawerOpen = true;
  	  // return pageData.isDrawerOpen
  	
  	  // Populate the TinyMCE control's content
  	  /*
  	  var loadFromBlock, HTMLSource;
  	  loadFromBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource);
  	  console.log ('The TinyMCE data source has been set to: ' + pageData.currentDataSource);
  	  HTMLSource = loadFromBlock[0].innerHTML;
  	  // loadFromBlock.currentTarget.getAttribute('data-source')
  	  // tinymce.activeEditor.setContent(HTMLSource);
  	  pageData.currentDataContent = HTMLSource
  	  */
  	
  	};
  	
  	Array.from(document.getElementsByClassName('content_editable')).forEach((editable) => {
  	  editable.addEventListener('click', myFunction);
  	    window.___MY_EVENT_LISTENER1  = myFunction;
  	    
  	  editable.addEventListener('dblclick', myFunction2);
  	    window.___MY_EVENT_LISTENER2  = myFunction2;
  	});  
  	
  	// Previously, we had this code: 
  	/* 
  	Array.from(document.getElementsByClassName('content_editable')).forEach((editable) => {
  	  editable.addEventListener('click', (e)=>{
  	    // e.preventDefault();
  	    console.log(e.currentTarget.getAttribute('data-source'));        
  	    // Above code MUST be set to currentTarget to trap the element's event that the code is actually running from.
  	    // e.target will trap the actual element that was clicked
  	  });
  	*/
  	
  	/* Function backup
  	editable.addEventListener('dblclick', (e)=>{
  	    // e.preventDefault();
  	    pageData.currentDataSource = e.currentTarget.getAttribute('data-source'); // Above code MUST be set to currentTarget to trap the element's event that the code is actually running from.
  	    // console.log("A double-click has occurred on element with the ID of: "+ runner.currentDataSource);
  	    console.log("pageData.currentDataSource =: "+ pageData.currentDataSource);
  	    // e.target will trap the actual element that was double-clicked
  	    pageData.isOpenModal = true;
  	    return pageData
  	  });
  	*/
  })(___arguments.context.pageData));
  ___arguments.context.pageData['inEditMode'] = true;
  ___arguments.context.pageData['editingPage'] = true;
  ___arguments.context.pageData['isOpenModal'] = false;
  if ((getObjectProperty(___arguments.context.appData, 'inAdminMode')) == true) {
    console.log('Launching Quill has been triggered!');
  }
  await (async function() {
  	await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('26ebd15ce2f2c1d6f9813d1a00a26054', true, true, '', 'You are now editing this webpage.', 'info');
  })();

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'editingPage')) == true) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_e6ee56dcb77237f6e25fce48185708e3/logic/57fe146ddaa7470303bc7594cc321ac5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var result, modifiedWebPageData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['editingPage'] = false;
  ___arguments.context.pageData['isOpenModal'] = false;
  modifiedWebPageData = (await (async function(pageData) {
  	const el = document.querySelectorAll('.content_editable')
  	
  	for (let i = 0; i < el.length; i++) {
  	  
  	  var isModified = el[i].getAttribute('data-modified');
  	  console.log(`The value of element ${i} is: ` + isModified);
  	
  	  if (isModified == 'true') {
  	    // console.log('This control is marked as true: ' + el[i])
  	    var dataId = el[i].getAttribute('data-source');
  	    var dataSource = el[i].innerHTML;
  	   // await Backendless.Data.of('admin_Webpages').save( ({ 'objectId': dataId ,'BlockContent': (encodeURIComponent(dataSource)) }) );
  	   return el
  	   
  	  } else {
  	    // console.log('This control is NOT marked as true: ' + el[i])
  	    
  	  }
  	
  	}

  })(___arguments.context.pageData));
  result = (await BackendlessUI.Functions.Custom['fn_1b07f526ab2675c1f595f218cd9d6b6f'](modifiedWebPageData, (getObjectProperty(___arguments.context.pageData, 'WebpageDataRoot')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageDataRoot')), 'id')), (getObjectProperty(___arguments.context.pageData, '_webpageSections'))));
  result = (await (async function(pageData) {
  	
  	var myFunction = (e)=> {
  	  // console.log(e.currentTarget.getAttribute("data-source"));
  	};
  	
  	var myFunction2 = (e)=> {
  	  pageData.currentDataSource = e.currentTarget.getAttribute("data-source");
  	  // console.log("pageData.currentDataSource =: "+ pageData.currentDataSource);
  	  pageData.isOpenModal = false;
  	  return pageData;
  	};
  	
  	
  	Array.from(document.getElementsByClassName("content_editable")).forEach((editable) => {
  	  // editable.removeEventListener("click", myFunction);
  	  editable.removeEventListener("dblclick", window.___MY_EVENT_LISTENER);
  	});
  })(___arguments.context.pageData));
  await (async function() {
  	await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('26ebd15ce2f2c1d6f9813d1a00a26054', true, true, 'Reload', 'The webpage has been updated!','success');
  })();
  await (async function() {
  	const el = document.querySelectorAll('.content_editable')
  	for (let i = 0; i < el.length; i++) {
  	el[i].setAttribute('contenteditable', 'false')
  	// el[i].setAttribute('data-modified','false')
  	// Removed the above line for testing...
  	
  	}
  })();

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'editingPage')) == true) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_e6ee56dcb77237f6e25fce48185708e3/logic/54e49baf26769a9218ab1aa5e9973a07/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var result;


  await (async function() {
  	const el = document.querySelectorAll('.content_editable')
  	for (let i = 0; i < el.length; i++) {
  	el[i].setAttribute('contenteditable', 'false')
  	el[i].setAttribute('data-modified','false')
  	}
  })();
  localStorage.removeItem('ACCOWebToken');
  ___arguments.context.pageData['editingPage'] = false;
  ___arguments.context.pageData['inEditMode'] = false;
  ___arguments.context.pageData['isOpenModal'] = false;
  result = (await (async function(pageData) {
  	
  	var myFunction = (e)=> {
  	  // console.log(e.currentTarget.getAttribute("data-source"));
  	};
  	
  	var myFunction2 = (e)=> {
  	  pageData.currentDataSource = e.currentTarget.getAttribute("data-source");
  	  // console.log("pageData.currentDataSource =: "+ pageData.currentDataSource);
  	  pageData.isOpenModal = false;
  	  return pageData;
  	};
  	
  	
  	Array.from(document.getElementsByClassName("content_editable")).forEach((editable) => {
  	  // editable.removeEventListener("click", myFunction);
  	  editable.removeEventListener("dblclick", window.___MY_EVENT_LISTENER);
  	});
  })(___arguments.context.pageData));
  await (async function() {
  	await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('26ebd15ce2f2c1d6f9813d1a00a26054', true, true, '', 'Edit mode has been cancelled.', 'warning');
  })();
  await (async function() {
  	window.location.reload();
  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_e6ee56dcb77237f6e25fce48185708e3/logic/a063ee21d054b42660c911eda4ac320d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['inEditMode'] = false;
  ___arguments.context.pageData['showAdminBar'] = false;
  ___arguments.context.pageData['editingPage'] = false;
  ___arguments.context.pageData['hideButtonsMode'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_e6ee56dcb77237f6e25fce48185708e3/logic/f63e128c4b16905e02113eba4f2451b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.WebpageDataRoot = ');
  console.log(getObjectProperty(___arguments.context.pageData, 'WebpageDataRoot'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'debugMode'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_e6ee56dcb77237f6e25fce48185708e3/logic/ae7af58eacedaed533e234c7e7127129/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await (async function() {
  	window.location.reload()
  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_e6ee56dcb77237f6e25fce48185708e3/logic/11a22427070ae9ac3452958e85a2888c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'CurrentUser')) != null) {
    return (String('User: ') + String(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'CurrentUser')), 'record')), 'name')));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_e6ee56dcb77237f6e25fce48185708e3/logic/a3d81c1971982523de3d2d4e6758fe19/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  console.log(generateUUID().long());

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_e6ee56dcb77237f6e25fce48185708e3/logic/5e185fd7f7683098e78389b8a398caf8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.WebpageData = ');
  console.log(getObjectProperty(___arguments.context.pageData, 'WebpageData'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'debugMode'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_e6ee56dcb77237f6e25fce48185708e3/logic/bb2aefb70427ae1264f8a7d88f670c4c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedWebPageData, result2, result;


  result2 = (await (async function(pageData) {
  	// const quill = await BackendlessUI.requireModule('https://cdn.jsdelivr.net/npm/quill@2.0.3/dist/quill.js')
  	
  	const quill = new Quill('.QuillEditor', {
  	  theme: 'snow'
  	})
  })(___arguments.context.pageData));
  console.log(modifiedWebPageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_e6ee56dcb77237f6e25fce48185708e3/logic/4ab82bda8c68488da47dda97741226cd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == true) {
    ___arguments.context.appData['isBETAEnabled'] = true;
    ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = true;
  } else {
    ___arguments.context.appData['isBETAEnabled'] = false;
    ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = false;
  }
  await Backendless.Request['patch']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://accoweb.pockethost.io/api/collections/users/records/') + String(getObjectProperty(___arguments.context.appData, 'CurrentUser.record.id'))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken')) })).setEncoding('utf8').send(({ [`BETAModeEnabled`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'currentUser.record.BETAModeEnabled')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./components/reusable/r_e6ee56dcb77237f6e25fce48185708e3/logic/5c08f6e813f8ed78de6db3e340683b28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var _webpageSections;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_8ad53e4e1c97580bf801a3793885f106'](___arguments.context.pageData, (getObjectProperty(___arguments.context.pageData, 'WebpageObjectID')), (getObjectProperty(___arguments.context.pageData, 'WebpageSections')));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_e6ee56dcb77237f6e25fce48185708e3/logic/20a8026db988d2b8a2e867d9e68869f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isDrawerOpen'))

  },
  /* handler:onDisplayAssignment */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isDrawerOpen'))

  },
  /* handler:isOpenLogic */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['isDrawerOpen'] = false;

  },
  /* handler:onClose */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var result, result2;


  if (___arguments.newValue) {
    result2 = (await (async function(pageData) {
    	// const quill = await BackendlessUI.requireModule('https://cdn.jsdelivr.net/npm/quill@2.0.3/dist/quill.js')
    	
    	const quill = new Quill('.QuillEditor', {
    	  theme: 'snow'
    	})
    })(___arguments.context.pageData));
    console.log('Drawer Visibility has changed! | Quill should be inititialized now');
  }

  },
  /* handler:onVisibilityChange */
  /* handler:onOpen */
  async ['onOpen'](___arguments) {
    var result2, result;


  if (true) {
    result2 = (await (async function(pageData) {
    	// const quill = await BackendlessUI.requireModule('https://cdn.jsdelivr.net/npm/quill@2.0.3/dist/quill.js')
    	
    	const quill = new Quill('#textEditor', {
    	  theme: 'snow'
    	})
    })(___arguments.context.pageData));
    console.log('Drawer Visibility has changed! | Quill should be inititialized now');
  }
  console.log('Drawer: Open Event');

  },
  /* handler:onOpen */
  /* content */
}))

define('./components/reusable/r_e6ee56dcb77237f6e25fce48185708e3/logic/ec8889b8587638ba6c670587ca12a818/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var user;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'CurrentUser')), 'record')), 'UserRoles'));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_e6ee56dcb77237f6e25fce48185708e3/logic/dbe1e05893c87a18d6861c4fa3e456c2/bundle.js', [], () => ({
  /* content */
  /* handler:contentLogic */
  ['contentLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'currentDataContent'))

  },
  /* handler:contentLogic */
  /* content */
}))

define('./components/reusable/r_e6ee56dcb77237f6e25fce48185708e3/logic/26bbe54a41c8e4f839285e588ca43cff/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'currentDataContent'));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_e6ee56dcb77237f6e25fce48185708e3/logic/4c58ce32463317c8e74858b8ffa49265/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    var result;

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./components/reusable/r_e6ee56dcb77237f6e25fce48185708e3/logic/0578c4e6f9c855489c044528c8f86758/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var result;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_7fb5d2e2da4fb1fd7bb10cb4bd0ee56c/logic/7dbef2fdfb5ce67e529d29023d486af5/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'taskBarTop')) == true) {
    return ['taskBar-top', 'easeInAndOut'];
  } else {
    return ['taskBar-bottom', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./components/reusable/r_7fb5d2e2da4fb1fd7bb10cb4bd0ee56c/logic/41a733c49e49c93f1865eeb65dd55c21/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['taskBarTop'] = false;
  ___arguments.context.pageData['taskBarBottom'] = (!(getObjectProperty(___arguments.context.pageData, 'taskBarTop')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'taskBarBottom')) != true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7fb5d2e2da4fb1fd7bb10cb4bd0ee56c/logic/88719f2b76f7597ab457ed18de1c8fab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['taskBarTop'] = true;
  ___arguments.context.pageData['taskBarBottom'] = (!(getObjectProperty(___arguments.context.pageData, 'taskBarTop')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'taskBarTop')) != true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7fb5d2e2da4fb1fd7bb10cb4bd0ee56c/logic/1cf810357e1736ae1334fb2b92dd8cf9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var result;


  await (async function() {
  	const el = document.querySelectorAll('.content_editable')
  	for (let i = 0; i < el.length; i++) {
  	el[i].setAttribute('contenteditable', 'false')
  	el[i].setAttribute('data-modified','false')
  	}
  })();
  ___arguments.context.pageData['editingPage'] = false;
  ___arguments.context.pageData['inEditMode'] = false;
  ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['isDrawerOpen'] = false;
  result = (await (async function(pageData) {
  	
  	Array.from(document.getElementsByClassName("content_editable")).forEach((editable) => {
  	  
  	  // editable.removeEventListener("click", myFunction);
  	  editable.removeEventListener("click", window.___MY_EVENT_LISTENER1);
  	  editable.removeEventListener("dblclick", window.___MY_EVENT_LISTENER2);
  	  
  	});
  })(___arguments.context.pageData));
  await (async function() {
  	await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('26ebd15ce2f2c1d6f9813d1a00a26054', true, true, '', 'Edit mode has been cancelled.', 'warning');
  })();

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'editingPage')) == true) {
    return true;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7fb5d2e2da4fb1fd7bb10cb4bd0ee56c/logic/c2a713898dab8e5bcc146d2f63a1925b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var result2, result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	const el = document.querySelectorAll('.content_editable')
  	
  	for (let i = 0; i < el.length; i++) {
  	let theDataID = el[i].classList.item(0);
  	theDataID = theDataID.substring(5);
  	el[i].setAttribute('contenteditable', 'true')
  	// el[i].setAttribute('data-modified','true') // We're now only modifying this attribute when the user clicks on the element.
  	el[i].setAttribute('data-source',theDataID)
  	
  	}
  })();
  result = (await (async function(pageData) {
  	const myFunction = (e)=> {
  	  e.currentTarget.setAttribute('data-modified','true');
  	  console.log(e.currentTarget.getAttribute('data-source') + " modified");        
  	}
  	
  	const myFunction2 = (e)=> {
  	  pageData.currentDataSource = e.currentTarget.getAttribute('data-source'); // Above code MUST be set to currentTarget to trap the element's event that the code is actually running from.
  	  console.log("(Toolbar: Edit Method) pageData.currentDataSource =: "+ pageData.currentDataSource);
  	  // pageData.isOpenModal = true;
  	  pageData.isDrawerOpen = true;
  	  // return pageData.isDrawerOpen
  	
  	  // Populate the TinyMCE control's content
  	  /*
  	  var loadFromBlock, HTMLSource;
  	  loadFromBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource);
  	  console.log ('The TinyMCE data source has been set to: ' + pageData.currentDataSource);
  	  HTMLSource = loadFromBlock[0].innerHTML;
  	  // loadFromBlock.currentTarget.getAttribute('data-source')
  	  // tinymce.activeEditor.setContent(HTMLSource);
  	  pageData.currentDataContent = HTMLSource
  	  */
  	
  	};
  	
  	Array.from(document.getElementsByClassName('content_editable')).forEach((editable) => {
  	  editable.addEventListener('click', myFunction);
  	    window.___MY_EVENT_LISTENER1  = myFunction;
  	    
  	  editable.addEventListener('dblclick', myFunction2);
  	    window.___MY_EVENT_LISTENER2  = myFunction2;
  	});  
  	
  	// Previously, we had this code: 
  	/* 
  	Array.from(document.getElementsByClassName('content_editable')).forEach((editable) => {
  	  editable.addEventListener('click', (e)=>{
  	    // e.preventDefault();
  	    console.log(e.currentTarget.getAttribute('data-source'));        
  	    // Above code MUST be set to currentTarget to trap the element's event that the code is actually running from.
  	    // e.target will trap the actual element that was clicked
  	  });
  	*/
  	
  	/* Function backup
  	editable.addEventListener('dblclick', (e)=>{
  	    // e.preventDefault();
  	    pageData.currentDataSource = e.currentTarget.getAttribute('data-source'); // Above code MUST be set to currentTarget to trap the element's event that the code is actually running from.
  	    // console.log("A double-click has occurred on element with the ID of: "+ runner.currentDataSource);
  	    console.log("pageData.currentDataSource =: "+ pageData.currentDataSource);
  	    // e.target will trap the actual element that was double-clicked
  	    pageData.isOpenModal = true;
  	    return pageData
  	  });
  	*/
  })(___arguments.context.pageData));
  ___arguments.context.pageData['inEditMode'] = true;
  ___arguments.context.pageData['editingPage'] = true;
  ___arguments.context.pageData['isOpenModal'] = false;
  if ((getObjectProperty(___arguments.context.appData, 'inAdminMode')) == true) {
    console.log('Launching tinyMCE has been triggered!');
  }
  await (async function() {
  	await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('26ebd15ce2f2c1d6f9813d1a00a26054', true, true, '', 'You are now editing this webpage.', 'info');
  })();

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'editingPage')) == true) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7fb5d2e2da4fb1fd7bb10cb4bd0ee56c/logic/57fe146ddaa7470303bc7594cc321ac5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var result, modifiedWebPageData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['editingPage'] = false;
  ___arguments.context.pageData['isOpenModal'] = false;
  modifiedWebPageData = (await (async function(pageData) {
  	const el = document.querySelectorAll('.content_editable')
  	
  	for (let i = 0; i < el.length; i++) {
  	  
  	  var isModified = el[i].getAttribute('data-modified');
  	  console.log(`The value of element ${i} is: ` + isModified);
  	
  	  if (isModified == 'true') {
  	    // console.log('This control is marked as true: ' + el[i])
  	    var dataId = el[i].getAttribute('data-source');
  	    var dataSource = el[i].innerHTML;
  	   // await Backendless.Data.of('admin_Webpages').save( ({ 'objectId': dataId ,'BlockContent': (encodeURIComponent(dataSource)) }) );
  	   return el
  	   
  	  } else {
  	    // console.log('This control is NOT marked as true: ' + el[i])
  	    
  	  }
  	
  	}

  })(___arguments.context.pageData));
  result = (await BackendlessUI.Functions.Custom['fn_1b07f526ab2675c1f595f218cd9d6b6f'](modifiedWebPageData, (getObjectProperty(___arguments.context.pageData, 'WebpageDataRoot')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageDataRoot')), 'id')), (getObjectProperty(___arguments.context.pageData, '_webpageSections'))));
  result = (await (async function(pageData) {
  	
  	var myFunction = (e)=> {
  	  // console.log(e.currentTarget.getAttribute("data-source"));
  	};
  	
  	var myFunction2 = (e)=> {
  	  pageData.currentDataSource = e.currentTarget.getAttribute("data-source");
  	  // console.log("pageData.currentDataSource =: "+ pageData.currentDataSource);
  	  pageData.isOpenModal = false;
  	  return pageData;
  	};
  	
  	
  	Array.from(document.getElementsByClassName("content_editable")).forEach((editable) => {
  	  // editable.removeEventListener("click", myFunction);
  	  editable.removeEventListener("dblclick", window.___MY_EVENT_LISTENER);
  	});
  })(___arguments.context.pageData));
  await (async function() {
  	await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('26ebd15ce2f2c1d6f9813d1a00a26054', true, true, 'Reload', 'The webpage has been updated!','success');
  })();
  await (async function() {
  	const el = document.querySelectorAll('.content_editable')
  	for (let i = 0; i < el.length; i++) {
  	el[i].setAttribute('contenteditable', 'false')
  	// el[i].setAttribute('data-modified','false')
  	// Removed the above line for testing...
  	
  	}
  })();

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'editingPage')) == true) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7fb5d2e2da4fb1fd7bb10cb4bd0ee56c/logic/54e49baf26769a9218ab1aa5e9973a07/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var result;


  await (async function() {
  	const el = document.querySelectorAll('.content_editable')
  	for (let i = 0; i < el.length; i++) {
  	el[i].setAttribute('contenteditable', 'false')
  	el[i].setAttribute('data-modified','false')
  	}
  })();
  localStorage.removeItem('ACCOWebToken');
  ___arguments.context.pageData['editingPage'] = false;
  ___arguments.context.pageData['inEditMode'] = false;
  ___arguments.context.pageData['isOpenModal'] = false;
  result = (await (async function(pageData) {
  	
  	var myFunction = (e)=> {
  	  // console.log(e.currentTarget.getAttribute("data-source"));
  	};
  	
  	var myFunction2 = (e)=> {
  	  pageData.currentDataSource = e.currentTarget.getAttribute("data-source");
  	  // console.log("pageData.currentDataSource =: "+ pageData.currentDataSource);
  	  pageData.isOpenModal = false;
  	  return pageData;
  	};
  	
  	
  	Array.from(document.getElementsByClassName("content_editable")).forEach((editable) => {
  	  // editable.removeEventListener("click", myFunction);
  	  editable.removeEventListener("dblclick", window.___MY_EVENT_LISTENER);
  	});
  })(___arguments.context.pageData));
  await (async function() {
  	await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('26ebd15ce2f2c1d6f9813d1a00a26054', true, true, '', 'Edit mode has been cancelled.', 'warning');
  })();
  await (async function() {
  	window.location.reload();
  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_7fb5d2e2da4fb1fd7bb10cb4bd0ee56c/logic/a063ee21d054b42660c911eda4ac320d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['inEditMode'] = false;
  ___arguments.context.pageData['showAdminBar'] = false;
  ___arguments.context.pageData['editingPage'] = false;
  ___arguments.context.pageData['hideButtonsMode'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_7fb5d2e2da4fb1fd7bb10cb4bd0ee56c/logic/f63e128c4b16905e02113eba4f2451b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.WebpageDataRoot = ');
  console.log(getObjectProperty(___arguments.context.pageData, 'WebpageDataRoot'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'debugMode'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7fb5d2e2da4fb1fd7bb10cb4bd0ee56c/logic/ae7af58eacedaed533e234c7e7127129/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await (async function() {
  	window.location.reload()
  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_7fb5d2e2da4fb1fd7bb10cb4bd0ee56c/logic/11a22427070ae9ac3452958e85a2888c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'CurrentUser')) != null) {
    return (String('User: ') + String(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'CurrentUser')), 'record')), 'name')));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_7fb5d2e2da4fb1fd7bb10cb4bd0ee56c/logic/a3d81c1971982523de3d2d4e6758fe19/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  console.log(generateUUID().long());

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_7fb5d2e2da4fb1fd7bb10cb4bd0ee56c/logic/5e185fd7f7683098e78389b8a398caf8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.WebpageData = ');
  console.log(getObjectProperty(___arguments.context.pageData, 'WebpageData'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'debugMode'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7fb5d2e2da4fb1fd7bb10cb4bd0ee56c/logic/bb2aefb70427ae1264f8a7d88f670c4c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedWebPageData, result2, result;


  result = (await (async function(pageData) {
  	/*
  	
  	const editor = await BackendlessUI.requireModule('https://cdn.tiny.cloud/1/dwt7je7v9gjog7a8oc867xici2xmy80whuw0asnvstr20590/tinymce/6/tinymce.min.js')
  	tinymce.init({ selector: '#textEditor'});
  	// document.getElementById('textEditor').addEventListener("click", saveContent);
  	
  	function saveContent() {
  	const myContent = tinymce.activeEditor.getContent();
  	console.log(myContent);
  	pageData.myContent = myContent;
  	}
  	
  	// Plugins that we probably will need: mediaembed, export linkchecker?, powerpaste, advtable, editimage, autocorrect, typography, checklist
  	Existing plugins backup: 'tinydrive code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
  	*/
  	
  	const editor = await BackendlessUI.requireModule('https://cdn.tiny.cloud/1/dwt7je7v9gjog7a8oc867xici2xmy80whuw0asnvstr20590/tinymce/6/tinymce.min.js')
  	tinymce.init({ selector: '.textEditor',
  	toolbar_sticky: true,
  	plugins: 'tinydrive code anchor link charmap codesample emoticons image lists media searchreplace table visualblocks wordcount',
  	toolbar: 'undo redo | blocks fontfamily fontsize | fontsizeselect | forecolor backcolor | bold italic underline strikethrough blockquote | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat | code',
  	font_family_formats: 'Andale Mono="Andale Mono"; Arial=arial; Arial Black="arial black"; Book Antiqua = "book antiqua"; Comic Sans MS="Comic Sans MS"; Courier New=courier new,courier,monospace; Georgia=georgia; Helvetica=helvetica; Impact=impact; Tahoma=tahoma; Terminal=terminal; Times New Roman="times new roman"; Trebuchet MS = "trebuchet ms"; Sans Serif="sans serif"; Segoe UI=segoe ui; Verdana=verdana; Webdings=webdings; Wingdings=wingdings',
  	font_size_formats: "8px 10px 12px 14px 16px 18px 20px 24px 30px 36px 48px 60px 72px 96px",
  	toolbar_mode: 'wrap', // Modes: floating, sliding, scrolling, wrap
  	relative_urls : true,
  	remove_script_host : false,
  	document_base_url : 'https://www.accofg.com/',
  	tinydrive_dropbox_app_key: 'zf8ghuzc8e0s3ad'
  	}) //#${id}`}) `this was inside a template string`
  	
  	document.getElementById('btnUpdateContent').addEventListener("click", saveContent)
  	
  	function saveContent() {
  	const myContent = tinymce.activeEditor.getContent()
  	pageData.myContent = myContent
  	}
  })(___arguments.context.pageData));
  result2 = (await (async function(pageData) {
  	// Create an array by ClassName 'content_editable' and invoke the function (editable) and create an event listener for each index in the array
  	// const runner = { currentDataSource: ""};
  	
  	var loadFromBlock, HTMLSource;
  	loadFromBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource);
  	console.log ('The TinyMCE data source has been set to: ' + pageData.currentDataSource);
  	HTMLSource = loadFromBlock[0].innerHTML;
  	// loadFromBlock.currentTarget.getAttribute('data-source')
  	tinymce.activeEditor.setContent(HTMLSource);
  	pageData.currentDataContent = HTMLSource
  })(___arguments.context.pageData));
  console.log(modifiedWebPageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_7fb5d2e2da4fb1fd7bb10cb4bd0ee56c/logic/4ab82bda8c68488da47dda97741226cd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == true) {
    ___arguments.context.appData['isBETAEnabled'] = true;
    ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = true;
  } else {
    ___arguments.context.appData['isBETAEnabled'] = false;
    ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = false;
  }
  await Backendless.Request['patch']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://accoweb.pockethost.io/api/collections/users/records/') + String(getObjectProperty(___arguments.context.appData, 'CurrentUser.record.id'))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken')) })).setEncoding('utf8').send(({ [`BETAModeEnabled`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'currentUser.record.BETAModeEnabled')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./components/reusable/r_7fb5d2e2da4fb1fd7bb10cb4bd0ee56c/logic/5c08f6e813f8ed78de6db3e340683b28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var _webpageSections;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_8ad53e4e1c97580bf801a3793885f106'](___arguments.context.pageData, (getObjectProperty(___arguments.context.pageData, 'WebpageObjectID')), (getObjectProperty(___arguments.context.pageData, 'WebpageSections')));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_7fb5d2e2da4fb1fd7bb10cb4bd0ee56c/logic/20a8026db988d2b8a2e867d9e68869f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isDrawerOpen'))

  },
  /* handler:onDisplayAssignment */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isDrawerOpen'))

  },
  /* handler:isOpenLogic */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['isDrawerOpen'] = false;

  },
  /* handler:onClose */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var result;


  result = (await (async function(pageData) {
  	// Create an array by ClassName 'content_editable' and invoke the function (editable) and create an event listener for each index in the array
  	// const runner = { currentDataSource: ""};
  	
  	var loadFromBlock, HTMLSource;
  	loadFromBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource);
  	console.log ('The TinyMCE data source has been set to: ' + pageData.currentDataSource);
  	HTMLSource = loadFromBlock[0].innerHTML;
  	// loadFromBlock.currentTarget.getAttribute('data-source')
  	tinymce.activeEditor.setContent(HTMLSource);
  	pageData.currentDataContent = HTMLSource
  })(___arguments.context.pageData));
  console.log('Drawer Visibility has changed!');

  },
  /* handler:onVisibilityChange */
  /* handler:onOpen */
  async ['onOpen'](___arguments) {
    var result2, result;


  result2 = (await (async function(pageData) {
  	// Create an array by ClassName 'content_editable' and invoke the function (editable) and create an event listener for each index in the array
  	// const runner = { currentDataSource: ""};
  	
  	var loadFromBlock, HTMLSource;
  	loadFromBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource);
  	console.log ('The TinyMCE data source has been set to: ' + pageData.currentDataSource);
  	HTMLSource = loadFromBlock[0].innerHTML;
  	// loadFromBlock.currentTarget.getAttribute('data-source')
  	tinymce.activeEditor.setContent(HTMLSource);
  	pageData.currentDataContent = HTMLSource
  })(___arguments.context.pageData));
  console.log('Drawer: Open Event');

  },
  /* handler:onOpen */
  /* content */
}))

define('./components/reusable/r_7fb5d2e2da4fb1fd7bb10cb4bd0ee56c/logic/ec8889b8587638ba6c670587ca12a818/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var user;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'CurrentUser')), 'record')), 'UserRoles'));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_7fb5d2e2da4fb1fd7bb10cb4bd0ee56c/logic/dbe1e05893c87a18d6861c4fa3e456c2/bundle.js', [], () => ({
  /* content */
  /* handler:contentLogic */
  ['contentLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'currentDataContent'))

  },
  /* handler:contentLogic */
  /* content */
}))

define('./components/reusable/r_7fb5d2e2da4fb1fd7bb10cb4bd0ee56c/logic/26bbe54a41c8e4f839285e588ca43cff/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'currentDataContent'));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_7fb5d2e2da4fb1fd7bb10cb4bd0ee56c/logic/4c58ce32463317c8e74858b8ffa49265/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    var result;

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./components/reusable/r_7fb5d2e2da4fb1fd7bb10cb4bd0ee56c/logic/0578c4e6f9c855489c044528c8f86758/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var result;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_8391f7d511b6a59d4ae5fddf52e57464/logic/7dbef2fdfb5ce67e529d29023d486af5/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'taskBarTop')) == true) {
    return ['taskBar-top', 'easeInAndOut'];
  } else {
    return ['taskBar-bottom', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./components/reusable/r_8391f7d511b6a59d4ae5fddf52e57464/logic/41a733c49e49c93f1865eeb65dd55c21/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['taskBarTop'] = false;
  ___arguments.context.pageData['taskBarBottom'] = (!(getObjectProperty(___arguments.context.pageData, 'taskBarTop')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'taskBarBottom')) != true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_8391f7d511b6a59d4ae5fddf52e57464/logic/88719f2b76f7597ab457ed18de1c8fab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['taskBarTop'] = true;
  ___arguments.context.pageData['taskBarBottom'] = (!(getObjectProperty(___arguments.context.pageData, 'taskBarTop')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'taskBarTop')) != true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_8391f7d511b6a59d4ae5fddf52e57464/logic/1cf810357e1736ae1334fb2b92dd8cf9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var result;


  await (async function() {
  	const el = document.querySelectorAll('.content_editable')
  	for (let i = 0; i < el.length; i++) {
  	el[i].setAttribute('contenteditable', 'false')
  	el[i].setAttribute('data-modified','false')
  	}
  })();
  ___arguments.context.pageData['editingPage'] = false;
  ___arguments.context.pageData['inEditMode'] = false;
  ___arguments.context.pageData['isOpenModal'] = false;
  result = (await (async function(pageData) {
  	
  	Array.from(document.getElementsByClassName("content_editable")).forEach((editable) => {
  	  
  	  // editable.removeEventListener("click", myFunction);
  	  editable.removeEventListener("click", window.___MY_EVENT_LISTENER1);
  	  editable.removeEventListener("dblclick", window.___MY_EVENT_LISTENER2);
  	  
  	});
  })(___arguments.context.pageData));
  await (async function() {
  	await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('26ebd15ce2f2c1d6f9813d1a00a26054', true, true, '', 'Edit mode has been cancelled.', 'warning');
  })();

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'editingPage')) == true) {
    return true;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_8391f7d511b6a59d4ae5fddf52e57464/logic/c2a713898dab8e5bcc146d2f63a1925b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var result2, result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	const el = document.querySelectorAll('.content_editable')
  	
  	for (let i = 0; i < el.length; i++) {
  	let theDataID = el[i].classList.item(0);
  	theDataID = theDataID.substring(5);
  	el[i].setAttribute('contenteditable', 'true')
  	// el[i].setAttribute('data-modified','true') // We're now only modifying this attribute when the user clicks on the element.
  	el[i].setAttribute('data-source',theDataID)
  	
  	}
  })();
  result = (await (async function(pageData) {
  	const myFunction = (e)=> {
  	  e.currentTarget.setAttribute('data-modified','true');
  	  console.log(e.currentTarget.getAttribute('data-source') + " modified");        
  	}
  	
  	const myFunction2 = (e)=> {
  	  pageData.currentDataSource = e.currentTarget.getAttribute('data-source'); // Above code MUST be set to currentTarget to trap the element's event that the code is actually running from.
  	  console.log("(Toolbar: Edit Method) pageData.currentDataSource =: "+ pageData.currentDataSource);
  	  pageData.isOpenModal = true;
  	  
  	  // pageData.isDrawerOpen = true;
  	  // return pageData.isDrawerOpen
  	
  	  // Populate the TinyMCE control's content
  	
  	  var loadFromBlock, HTMLSource;
  	  loadFromBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource);
  	  console.log ('The TinyMCE data source has been set to: ' + pageData.currentDataSource);
  	  HTMLSource = loadFromBlock[0].innerHTML;
  	  // loadFromBlock.currentTarget.getAttribute('data-source')
  	  // tinymce.activeEditor.setContent(HTMLSource);
  	  pageData.currentDataContent = HTMLSource
  	
  	
  	};
  	
  	Array.from(document.getElementsByClassName('content_editable')).forEach((editable) => {
  	  editable.addEventListener('click', myFunction);
  	    window.___MY_EVENT_LISTENER1  = myFunction;
  	    
  	  editable.addEventListener('dblclick', myFunction2);
  	    window.___MY_EVENT_LISTENER2  = myFunction2;
  	});  
  	
  	// Previously, we had this code: 
  	/* 
  	Array.from(document.getElementsByClassName('content_editable')).forEach((editable) => {
  	  editable.addEventListener('click', (e)=>{
  	    // e.preventDefault();
  	    console.log(e.currentTarget.getAttribute('data-source'));        
  	    // Above code MUST be set to currentTarget to trap the element's event that the code is actually running from.
  	    // e.target will trap the actual element that was clicked
  	  });
  	*/
  	
  	/* Function backup
  	editable.addEventListener('dblclick', (e)=>{
  	    // e.preventDefault();
  	    pageData.currentDataSource = e.currentTarget.getAttribute('data-source'); // Above code MUST be set to currentTarget to trap the element's event that the code is actually running from.
  	    // console.log("A double-click has occurred on element with the ID of: "+ runner.currentDataSource);
  	    console.log("pageData.currentDataSource =: "+ pageData.currentDataSource);
  	    // e.target will trap the actual element that was double-clicked
  	    pageData.isOpenModal = true;
  	    return pageData
  	  });
  	*/
  })(___arguments.context.pageData));
  console.log(result);
  if (result) {
    ___arguments.context.pageData['isOpenDrawer'] = true;
  }
  ___arguments.context.pageData['inEditMode'] = true;
  ___arguments.context.pageData['editingPage'] = true;
  ___arguments.context.pageData['isOpenModal'] = false;
  if ((getObjectProperty(___arguments.context.appData, 'inAdminMode')) == true) {
    result2 = (await (async function(pageData) {
    	/*
    	
    	const editor = await BackendlessUI.requireModule('https://cdn.tiny.cloud/1/dwt7je7v9gjog7a8oc867xici2xmy80whuw0asnvstr20590/tinymce/6/tinymce.min.js')
    	tinymce.init({ selector: '#textEditor'});
    	// document.getElementById('textEditor').addEventListener("click", saveContent);
    	
    	function saveContent() {
    	const myContent = tinymce.activeEditor.getContent();
    	console.log(myContent);
    	pageData.myContent = myContent;
    	}
    	
    	// Plugins that we probably will need: mediaembed, export linkchecker?, powerpaste, advtable, editimage, autocorrect, typography, checklist
    	Existing plugins backup: 'tinydrive code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
    	Removed from below: 
    	toolbar_sticky: true,
    	toolbar_mode: 'floating', // Modes: floating, sliding, scrolling, wrap
    	
    	*/
    	
    	const editor = await BackendlessUI.requireModule('https://cdn.tiny.cloud/1/dwt7je7v9gjog7a8oc867xici2xmy80whuw0asnvstr20590/tinymce/8/tinymce.min.js')
    	tinymce.init({ selector: '.textEditor',
    	plugins: 'tinydrive code anchor link charmap codesample emoticons image lists media searchreplace table visualblocks wordcount',
    	toolbar: 'undo redo | blocks fontfamily fontsize | fontsizeselect | forecolor backcolor | bold italic underline strikethrough blockquote | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat | code',
    	font_family_formats: 'Andale Mono="Andale Mono"; Arial=arial; Arial Black="arial black"; Book Antiqua = "book antiqua"; Comic Sans MS="Comic Sans MS"; Courier New=courier new,courier,monospace; Georgia=georgia; Helvetica=helvetica; Impact=impact; Tahoma=tahoma; Terminal=terminal; Times New Roman="times new roman"; Trebuchet MS = "trebuchet ms"; Sans Serif="sans serif"; Segoe UI=segoe ui; Verdana=verdana; Webdings=webdings; Wingdings=wingdings',
    	font_size_formats: "8px 10px 12px 14px 16px 18px 20px 24px 30px 36px 48px 60px 72px 96px",
    	relative_urls : true,
    	remove_script_host : false,
    	document_base_url : 'https://www.accofg.com/',
    	tinydrive_dropbox_app_key: 'zf8ghuzc8e0s3ad'
    	}) //#${id}`}) `this was inside a template string`
    	document.getElementById('btnUpdateContent').addEventListener("click", saveContent)
    	
    	function saveContent() {
    	const myContent = tinymce.activeEditor.getContent()
    	pageData.myContent = myContent
    	}

    })(___arguments.context.pageData));
    console.log('Launching tinyMCE has been triggered!');
  }
  await (async function() {
  	await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('26ebd15ce2f2c1d6f9813d1a00a26054', true, true, '', 'You are now editing this webpage.', 'info');
  })();

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'editingPage')) == true) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_8391f7d511b6a59d4ae5fddf52e57464/logic/57fe146ddaa7470303bc7594cc321ac5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var result, modifiedWebPageData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['editingPage'] = false;
  ___arguments.context.pageData['isOpenModal'] = false;
  modifiedWebPageData = (await (async function(pageData) {
  	const el = document.querySelectorAll('.content_editable')
  	
  	for (let i = 0; i < el.length; i++) {
  	  
  	  var isModified = el[i].getAttribute('data-modified');
  	  console.log(`The value of element ${i} is: ` + isModified);
  	
  	  if (isModified == 'true') {
  	    // console.log('This control is marked as true: ' + el[i])
  	    var dataId = el[i].getAttribute('data-source');
  	    var dataSource = el[i].innerHTML;
  	   // await Backendless.Data.of('admin_Webpages').save( ({ 'objectId': dataId ,'BlockContent': (encodeURIComponent(dataSource)) }) );
  	   return el
  	   
  	  } else {
  	    // console.log('This control is NOT marked as true: ' + el[i])
  	    
  	  }
  	
  	}

  })(___arguments.context.pageData));
  result = (await BackendlessUI.Functions.Custom['fn_1b07f526ab2675c1f595f218cd9d6b6f'](modifiedWebPageData, (getObjectProperty(___arguments.context.pageData, 'WebpageDataRoot')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageDataRoot')), 'id')), (getObjectProperty(___arguments.context.pageData, '_webpageSections'))));
  result = (await (async function(pageData) {
  	
  	var myFunction = (e)=> {
  	  // console.log(e.currentTarget.getAttribute("data-source"));
  	};
  	
  	var myFunction2 = (e)=> {
  	  pageData.currentDataSource = e.currentTarget.getAttribute("data-source");
  	  // console.log("pageData.currentDataSource =: "+ pageData.currentDataSource);
  	  pageData.isOpenModal = false;
  	  return pageData;
  	};
  	
  	
  	Array.from(document.getElementsByClassName("content_editable")).forEach((editable) => {
  	  // editable.removeEventListener("click", myFunction);
  	  editable.removeEventListener("dblclick", window.___MY_EVENT_LISTENER);
  	});
  })(___arguments.context.pageData));
  await (async function() {
  	await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('26ebd15ce2f2c1d6f9813d1a00a26054', true, true, 'Reload', 'The webpage has been updated!','success');
  })();
  await (async function() {
  	const el = document.querySelectorAll('.content_editable')
  	for (let i = 0; i < el.length; i++) {
  	el[i].setAttribute('contenteditable', 'false')
  	// el[i].setAttribute('data-modified','false')
  	// Removed the above line for testing...
  	
  	}
  })();

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'editingPage')) == true) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_8391f7d511b6a59d4ae5fddf52e57464/logic/54e49baf26769a9218ab1aa5e9973a07/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var result;


  await (async function() {
  	const el = document.querySelectorAll('.content_editable')
  	for (let i = 0; i < el.length; i++) {
  	el[i].setAttribute('contenteditable', 'false')
  	el[i].setAttribute('data-modified','false')
  	}
  })();
  localStorage.removeItem('ACCOWebToken');
  ___arguments.context.pageData['editingPage'] = false;
  ___arguments.context.pageData['inEditMode'] = false;
  ___arguments.context.pageData['isOpenModal'] = false;
  result = (await (async function(pageData) {
  	
  	var myFunction = (e)=> {
  	  // console.log(e.currentTarget.getAttribute("data-source"));
  	};
  	
  	var myFunction2 = (e)=> {
  	  pageData.currentDataSource = e.currentTarget.getAttribute("data-source");
  	  // console.log("pageData.currentDataSource =: "+ pageData.currentDataSource);
  	  pageData.isOpenModal = false;
  	  return pageData;
  	};
  	
  	
  	Array.from(document.getElementsByClassName("content_editable")).forEach((editable) => {
  	  // editable.removeEventListener("click", myFunction);
  	  editable.removeEventListener("dblclick", window.___MY_EVENT_LISTENER);
  	});
  })(___arguments.context.pageData));
  await (async function() {
  	await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('26ebd15ce2f2c1d6f9813d1a00a26054', true, true, '', 'Edit mode has been cancelled.', 'warning');
  })();
  await (async function() {
  	window.location.reload();
  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_8391f7d511b6a59d4ae5fddf52e57464/logic/a063ee21d054b42660c911eda4ac320d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['inEditMode'] = false;
  ___arguments.context.pageData['showAdminBar'] = false;
  ___arguments.context.pageData['editingPage'] = false;
  ___arguments.context.pageData['hideButtonsMode'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_8391f7d511b6a59d4ae5fddf52e57464/logic/f63e128c4b16905e02113eba4f2451b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.WebpageDataRoot = ');
  console.log(getObjectProperty(___arguments.context.pageData, 'WebpageDataRoot'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'debugMode'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_8391f7d511b6a59d4ae5fddf52e57464/logic/ae7af58eacedaed533e234c7e7127129/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await (async function() {
  	window.location.reload()
  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_8391f7d511b6a59d4ae5fddf52e57464/logic/11a22427070ae9ac3452958e85a2888c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'CurrentUser')) != null) {
    return (String('User: ') + String(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'CurrentUser')), 'record')), 'name')));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_8391f7d511b6a59d4ae5fddf52e57464/logic/a3d81c1971982523de3d2d4e6758fe19/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  console.log(generateUUID().long());

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_8391f7d511b6a59d4ae5fddf52e57464/logic/5e185fd7f7683098e78389b8a398caf8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.WebpageData = ');
  console.log(getObjectProperty(___arguments.context.pageData, 'WebpageData'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'debugMode'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_8391f7d511b6a59d4ae5fddf52e57464/logic/bb2aefb70427ae1264f8a7d88f670c4c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedWebPageData, result;


  result = (await (async function(pageData) {
  	/*
  	var myFunction = (e)=> {
  	  console.log(e.currentTarget.getAttribute('data-source'));        
  	}
  	*/
  	
  	var myFunction2 = (e)=> {
  	  pageData.currentDataSource = e.currentTarget.getAttribute('data-source'); // Above code MUST be set to currentTarget to trap the element's event that the code is actually running from.
  	  console.log("pageData.currentDataSource =: "+ pageData.currentDataSource);
  	  pageData.isOpenModal = true;
  	  return pageData  
  	};
  	
  	Array.from(document.getElementsByClassName('content_editable')).forEach((editable) => {
  	  // editable.addEventListener('click', myFunction);
  	  editable.addEventListener('dblclick', myFunction2);
  	  window.___MY_EVENT_LISTENER  = myFunction2;
  	});  
  	
  	// Previously, we had this code: 
  	/* 
  	Array.from(document.getElementsByClassName('content_editable')).forEach((editable) => {
  	  editable.addEventListener('click', (e)=>{
  	    // e.preventDefault();
  	    console.log(e.currentTarget.getAttribute('data-source'));        
  	    // Above code MUST be set to currentTarget to trap the element's event that the code is actually running from.
  	    // e.target will trap the actual element that was clicked
  	  });
  	*/
  	
  	/* Function backup
  	editable.addEventListener('dblclick', (e)=>{
  	    // e.preventDefault();
  	    pageData.currentDataSource = e.currentTarget.getAttribute('data-source'); // Above code MUST be set to currentTarget to trap the element's event that the code is actually running from.
  	    // console.log("A double-click has occurred on element with the ID of: "+ runner.currentDataSource);
  	    console.log("pageData.currentDataSource =: "+ pageData.currentDataSource);
  	    // e.target will trap the actual element that was double-clicked
  	    pageData.isOpenModal = true;
  	    return pageData
  	  });
  	*/
  })(___arguments.context.pageData));
  modifiedWebPageData = (await (async function(pageData) {
  	const el = document.querySelectorAll('.content_editable')
  	
  	for (let i = 0; i < el.length; i++) {
  	  
  	  var isModified = el[i].getAttribute('data-modified');
  	  console.log(`The value of element ${i} is: ` + isModified);
  	
  	  if (isModified == 'true') {
  	    // console.log('This control is marked as true: ' + el[i])
  	    var dataId = el[i].getAttribute('data-source');
  	    var dataSource = el[i].innerHTML;
  	   // await Backendless.Data.of('admin_Webpages').save( ({ 'objectId': dataId ,'BlockContent': (encodeURIComponent(dataSource)) }) );
  	   return el
  	   
  	  } else {
  	    // console.log('This control is NOT marked as true: ' + el[i])
  	    
  	  }
  	
  	}

  })(___arguments.context.pageData));
  console.log(modifiedWebPageData);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'debugMode'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_8391f7d511b6a59d4ae5fddf52e57464/logic/4ab82bda8c68488da47dda97741226cd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == true) {
    ___arguments.context.appData['isBETAEnabled'] = true;
    ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = true;
  } else {
    ___arguments.context.appData['isBETAEnabled'] = false;
    ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = false;
  }
  await Backendless.Request['patch']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://accoweb.pockethost.io/api/collections/users/records/') + String(getObjectProperty(___arguments.context.appData, 'CurrentUser.record.id'))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken')) })).setEncoding('utf8').send(({ [`BETAModeEnabled`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'currentUser.record.BETAModeEnabled')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./components/reusable/r_8391f7d511b6a59d4ae5fddf52e57464/logic/5c08f6e813f8ed78de6db3e340683b28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var _webpageSections;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_8ad53e4e1c97580bf801a3793885f106'](___arguments.context.pageData, (getObjectProperty(___arguments.context.pageData, 'WebpageObjectID')), (getObjectProperty(___arguments.context.pageData, 'WebpageSections')));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_6219ce08e225695c036f7d7805bab21e/logic/90bac6e57c011e8316afe13568e29da5/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d09f4d28c58125a4012e1443f1367509'))['text'] = 'info@accofg.com';
  await (async function() {
  	var a = document.getElementsByClassName('emailuslink'); //or grab it by tagname etc
  	a[0].href = "mailto:info@accofg.com"
  })();

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d09f4d28c58125a4012e1443f1367509'))['text'] = 'Email Us';
  await (async function() {
  	var a = document.getElementsByClassName('emailuslink'); //or grab it by tagname etc
  	a[0].href = "mailto:undefined"
  })();

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./components/reusable/r_6219ce08e225695c036f7d7805bab21e/logic/d09f4d28c58125a4012e1443f1367509/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d09f4d28c58125a4012e1443f1367509'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d09f4d28c58125a4012e1443f1367509'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./components/reusable/r_6219ce08e225695c036f7d7805bab21e/logic/300c980d76424a13b64788aad768898e/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('300c980d76424a13b64788aad768898e'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('300c980d76424a13b64788aad768898e'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://www.facebook.com/accofg', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_6219ce08e225695c036f7d7805bab21e/logic/7d28f5675648b2b8723fa38590687b41/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7d28f5675648b2b8723fa38590687b41'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7d28f5675648b2b8723fa38590687b41'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://www.linkedin.com/company/anderson-construction-company-of-fort-gaines/', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_6219ce08e225695c036f7d7805bab21e/logic/6ffb65b9c5165a9712bbb3bcbf425dfe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  blockObjectID = '1AC64B77-8F6F-4F07-8A6E-12409E539A9C';
  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
       if ((getObjectProperty(item, 'id')) == blockObjectID) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_6219ce08e225695c036f7d7805bab21e/logic/ef44e3b54c91f8b6d036fd417ebb4127/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ef44e3b54c91f8b6d036fd417ebb4127'))['color'] = 'red';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ef44e3b54c91f8b6d036fd417ebb4127'))['color'] = 'black';

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./components/reusable/r_6219ce08e225695c036f7d7805bab21e/logic/051b08fd32bf3c1ce0df8c5bb31fa28f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var thisBlocksData, decision, blockObjectID, item, rootData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  blockObjectID = '6C183D8A-DE50-4E10-AF62-F0F906CEFACF';
  if ((getObjectProperty(___arguments.context.pageData, 'isPageReady')) == true) {
    thisBlocksData = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageData')), 'WebpageSections')), async (item) => {
       if ((getObjectProperty(item, 'id')) == blockObjectID) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    return (decodeURIComponent((getObjectProperty((thisBlocksData[0]), 'HTMLContent'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_6219ce08e225695c036f7d7805bab21e/logic/9ef9509e372855e8f2b89ff80df8c348/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'isBETAEnabled')) {
    return ['easeInAndOut'];
  } else {
    return ['hide-beta', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'WebpageObjectID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_cb0dd63e34543826612ae4d750db37d6/logic/7dbef2fdfb5ce67e529d29023d486af5/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'taskBarTop')) == true) {
    return ['taskBar-top', 'easeInAndOut'];
  } else {
    return ['taskBar-bottom', 'easeInAndOut'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./components/reusable/r_cb0dd63e34543826612ae4d750db37d6/logic/41a733c49e49c93f1865eeb65dd55c21/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['taskBarTop'] = false;
  ___arguments.context.pageData['taskBarBottom'] = (!(getObjectProperty(___arguments.context.pageData, 'taskBarTop')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'taskBarBottom')) != true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_cb0dd63e34543826612ae4d750db37d6/logic/88719f2b76f7597ab457ed18de1c8fab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['taskBarTop'] = true;
  ___arguments.context.pageData['taskBarBottom'] = (!(getObjectProperty(___arguments.context.pageData, 'taskBarTop')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'taskBarTop')) != true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_cb0dd63e34543826612ae4d750db37d6/logic/1cf810357e1736ae1334fb2b92dd8cf9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var result;


  await (async function() {
  	const el = document.querySelectorAll('.content_editable')
  	for (let i = 0; i < el.length; i++) {
  	el[i].setAttribute('contenteditable', 'false')
  	el[i].setAttribute('data-modified','false')
  	}
  })();
  ___arguments.context.pageData['editingPage'] = false;
  ___arguments.context.pageData['inEditMode'] = false;
  ___arguments.context.pageData['isOpenModal'] = false;
  result = (await (async function(pageData) {
  	
  	Array.from(document.getElementsByClassName("content_editable")).forEach((editable) => {
  	  
  	  // editable.removeEventListener("click", myFunction);
  	  editable.removeEventListener("click", window.___MY_EVENT_LISTENER1);
  	  editable.removeEventListener("dblclick", window.___MY_EVENT_LISTENER2);
  	  
  	});
  })(___arguments.context.pageData));
  await (async function() {
  	await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('26ebd15ce2f2c1d6f9813d1a00a26054', true, true, '', 'Edit mode has been cancelled.', 'warning');
  })();

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'editingPage')) == true) {
    return true;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_cb0dd63e34543826612ae4d750db37d6/logic/c2a713898dab8e5bcc146d2f63a1925b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var result2, result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	const el = document.querySelectorAll('.content_editable')
  	
  	for (let i = 0; i < el.length; i++) {
  	let theDataID = el[i].classList.item(0);
  	theDataID = theDataID.substring(5);
  	el[i].setAttribute('contenteditable', 'true')
  	// el[i].setAttribute('data-modified','true') // We're now only modifying this attribute when the user clicks on the element.
  	el[i].setAttribute('data-source',theDataID)
  	
  	}
  })();
  result = (await (async function(pageData) {
  	const myFunction = (e)=> {
  	  e.currentTarget.setAttribute('data-modified','true');
  	  console.log(e.currentTarget.getAttribute('data-source') + " modified");        
  	}
  	
  	const myFunction2 = (e)=> {
  	  pageData.currentDataSource = e.currentTarget.getAttribute('data-source'); // Above code MUST be set to currentTarget to trap the element's event that the code is actually running from.
  	  pageData.isOpenModal = true;
  	  
  	  // Populate the TinyMCE control's content
  	  var loadFromBlock, HTMLSource;
  	  loadFromBlock = document.getElementsByClassName('DATA-'+ pageData.currentDataSource);
  	  console.log ('(Toolbar (Edit Method): The TinyMCE data source has been set to: ' + pageData.currentDataSource);
  	  HTMLSource = loadFromBlock[0].innerHTML;
  	  console.log (HTMLSource)
  	  pageData.currentDataContent = HTMLSource
  	  // tinymce.activeEditor.setContent(HTMLSource);
  	
  	};
  	
  	Array.from(document.getElementsByClassName('content_editable')).forEach((editable) => {
  	  editable.addEventListener('click', myFunction);
  	    window.___MY_EVENT_LISTENER1  = myFunction;
  	    
  	  editable.addEventListener('dblclick', myFunction2);
  	    window.___MY_EVENT_LISTENER2  = myFunction2;
  	});  
  	
  	// Previously, we had this code: 
  	/* 
  	Array.from(document.getElementsByClassName('content_editable')).forEach((editable) => {
  	  editable.addEventListener('click', (e)=>{
  	    // e.preventDefault();
  	    console.log(e.currentTarget.getAttribute('data-source'));        
  	    // Above code MUST be set to currentTarget to trap the element's event that the code is actually running from.
  	    // e.target will trap the actual element that was clicked
  	  });
  	*/
  	
  	/* Function backup
  	editable.addEventListener('dblclick', (e)=>{
  	    // e.preventDefault();
  	    pageData.currentDataSource = e.currentTarget.getAttribute('data-source'); // Above code MUST be set to currentTarget to trap the element's event that the code is actually running from.
  	    // console.log("A double-click has occurred on element with the ID of: "+ runner.currentDataSource);
  	    console.log("pageData.currentDataSource =: "+ pageData.currentDataSource);
  	    // e.target will trap the actual element that was double-clicked
  	    pageData.isOpenModal = true;
  	    return pageData
  	  });
  	*/
  })(___arguments.context.pageData));
  console.log(result);
  if (result) {
    ___arguments.context.pageData['isOpenDrawer'] = true;
  }
  ___arguments.context.pageData['inEditMode'] = true;
  ___arguments.context.pageData['editingPage'] = true;
  ___arguments.context.pageData['isOpenModal'] = false;
  if ((getObjectProperty(___arguments.context.appData, 'inAdminMode')) == true) {
  }
  await (async function() {
  	await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('26ebd15ce2f2c1d6f9813d1a00a26054', true, true, '', 'You are now editing this webpage.', 'info');
  })();

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'editingPage')) == true) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_cb0dd63e34543826612ae4d750db37d6/logic/57fe146ddaa7470303bc7594cc321ac5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var result, modifiedWebPageData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['editingPage'] = false;
  ___arguments.context.pageData['isOpenModal'] = false;
  modifiedWebPageData = (await (async function(pageData) {
  	const el = document.querySelectorAll('.content_editable')
  	
  	for (let i = 0; i < el.length; i++) {
  	  
  	  var isModified = el[i].getAttribute('data-modified');
  	  console.log(`The value of element ${i} is: ` + isModified);
  	
  	  if (isModified == 'true') {
  	    // console.log('This control is marked as true: ' + el[i])
  	    var dataId = el[i].getAttribute('data-source');
  	    var dataSource = el[i].innerHTML;
  	   // await Backendless.Data.of('admin_Webpages').save( ({ 'objectId': dataId ,'BlockContent': (encodeURIComponent(dataSource)) }) );
  	   return el
  	   
  	  } else {
  	    // console.log('This control is NOT marked as true: ' + el[i])
  	    
  	  }
  	
  	}

  })(___arguments.context.pageData));
  result = (await BackendlessUI.Functions.Custom['fn_1b07f526ab2675c1f595f218cd9d6b6f'](modifiedWebPageData, (getObjectProperty(___arguments.context.pageData, 'WebpageDataRoot')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'WebpageDataRoot')), 'id')), (getObjectProperty(___arguments.context.pageData, '_webpageSections'))));
  result = (await (async function(pageData) {
  	
  	var myFunction = (e)=> {
  	  // console.log(e.currentTarget.getAttribute("data-source"));
  	};
  	
  	var myFunction2 = (e)=> {
  	  pageData.currentDataSource = e.currentTarget.getAttribute("data-source");
  	  // console.log("pageData.currentDataSource =: "+ pageData.currentDataSource);
  	  pageData.isOpenModal = false;
  	  return pageData;
  	};
  	
  	
  	Array.from(document.getElementsByClassName("content_editable")).forEach((editable) => {
  	  // editable.removeEventListener("click", myFunction);
  	  editable.removeEventListener("dblclick", window.___MY_EVENT_LISTENER);
  	});
  })(___arguments.context.pageData));
  await (async function() {
  	await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('26ebd15ce2f2c1d6f9813d1a00a26054', true, true, 'Reload', 'The webpage has been updated!','success');
  })();
  await (async function() {
  	const el = document.querySelectorAll('.content_editable')
  	for (let i = 0; i < el.length; i++) {
  	el[i].setAttribute('contenteditable', 'false')
  	// el[i].setAttribute('data-modified','false')
  	// Removed the above line for testing...
  	
  	}
  })();

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'editingPage')) == true) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_cb0dd63e34543826612ae4d750db37d6/logic/54e49baf26769a9218ab1aa5e9973a07/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var result;


  await (async function() {
  	const el = document.querySelectorAll('.content_editable')
  	for (let i = 0; i < el.length; i++) {
  	el[i].setAttribute('contenteditable', 'false')
  	el[i].setAttribute('data-modified','false')
  	}
  })();
  localStorage.removeItem('ACCOWebToken');
  ___arguments.context.pageData['editingPage'] = false;
  ___arguments.context.pageData['inEditMode'] = false;
  ___arguments.context.pageData['isOpenModal'] = false;
  result = (await (async function(pageData) {
  	
  	var myFunction = (e)=> {
  	  // console.log(e.currentTarget.getAttribute("data-source"));
  	};
  	
  	var myFunction2 = (e)=> {
  	  pageData.currentDataSource = e.currentTarget.getAttribute("data-source");
  	  // console.log("pageData.currentDataSource =: "+ pageData.currentDataSource);
  	  pageData.isOpenModal = false;
  	  return pageData;
  	};
  	
  	
  	Array.from(document.getElementsByClassName("content_editable")).forEach((editable) => {
  	  // editable.removeEventListener("click", myFunction);
  	  editable.removeEventListener("dblclick", window.___MY_EVENT_LISTENER);
  	});
  })(___arguments.context.pageData));
  await (async function() {
  	await ( async function (componentUid, isClose, isAction, actionText, text, snackType) {  ___arguments.context.getComponentByUid(componentUid).create(isClose, isAction, actionText, text, snackType) })('26ebd15ce2f2c1d6f9813d1a00a26054', true, true, '', 'Edit mode has been cancelled.', 'warning');
  })();
  await (async function() {
  	window.location.reload();
  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_cb0dd63e34543826612ae4d750db37d6/logic/a063ee21d054b42660c911eda4ac320d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['inEditMode'] = false;
  ___arguments.context.pageData['showAdminBar'] = false;
  ___arguments.context.pageData['editingPage'] = false;
  ___arguments.context.pageData['hideButtonsMode'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_cb0dd63e34543826612ae4d750db37d6/logic/f63e128c4b16905e02113eba4f2451b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.WebpageDataRoot = ');
  console.log(getObjectProperty(___arguments.context.pageData, 'WebpageDataRoot'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'debugMode'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_cb0dd63e34543826612ae4d750db37d6/logic/ae7af58eacedaed533e234c7e7127129/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await (async function() {
  	window.location.reload()
  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_cb0dd63e34543826612ae4d750db37d6/logic/11a22427070ae9ac3452958e85a2888c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'CurrentUser')) != null) {
    return (String('User: ') + String(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'CurrentUser')), 'record')), 'name')));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_cb0dd63e34543826612ae4d750db37d6/logic/a3d81c1971982523de3d2d4e6758fe19/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  console.log(generateUUID().long());

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_cb0dd63e34543826612ae4d750db37d6/logic/5e185fd7f7683098e78389b8a398caf8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.WebpageData = ');
  console.log(getObjectProperty(___arguments.context.pageData, 'WebpageData'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'debugMode'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_cb0dd63e34543826612ae4d750db37d6/logic/bb2aefb70427ae1264f8a7d88f670c4c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var modifiedWebPageData, result2, result;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_cb0dd63e34543826612ae4d750db37d6/logic/4ab82bda8c68488da47dda97741226cd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == true) {
    ___arguments.context.appData['isBETAEnabled'] = true;
    ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = true;
  } else {
    ___arguments.context.appData['isBETAEnabled'] = false;
    ___arguments.context.appData['currentUser.record.BETAModeEnabled'] = false;
  }
  await Backendless.Request['patch']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://accoweb.pockethost.io/api/collections/users/records/') + String(getObjectProperty(___arguments.context.appData, 'CurrentUser.record.id'))))).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('ACCOWebToken')) })).setEncoding('utf8').send(({ [`BETAModeEnabled`]: ___arguments.value }));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'currentUser.record.BETAModeEnabled')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./components/reusable/r_cb0dd63e34543826612ae4d750db37d6/logic/5c08f6e813f8ed78de6db3e340683b28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var _webpageSections;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_8ad53e4e1c97580bf801a3793885f106'](___arguments.context.pageData, (getObjectProperty(___arguments.context.pageData, 'WebpageObjectID')), (getObjectProperty(___arguments.context.pageData, 'WebpageSections')));

  },
  /* handler:onClick */
  /* content */
}))

